export const playersData = {
    "kotarski": {
        "displayName": "Dominik Kotarski",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Croatia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-02-10"
    },
    "runarsson": {
        "displayName": "Rúnar Alex Rúnarsson",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Iceland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1995-02-18"
    },
    "buur": {
        "displayName": "Oscar Gadeberg Buur",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Goalkeeper",
        "number": 61,
        "dateofbirth": "2006-03-24"
    },
    "gabrielpereira": {
        "displayName": "Gabriel Pereira",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Brazil",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-02-01"
    },
    "hatzidiakos": {
        "displayName": "Pantelis Hatzidiakos",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Greece",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1997-01-18"
    },
    "huescas": {
        "displayName": "Rodrigo Huescas",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Mexico",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2003-09-23"
    },
    "marcoslopez": {
        "displayName": "Marcos López",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Peru",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1999-11-20"
    },
    "garananga": {
        "displayName": "Munashe Garananga",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Zimbabwe",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2001-01-18"
    },
    "suzuki": {
        "displayName": "Junnosuke Suzuki",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Japan",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2003-07-12"
    },
    "zague": {
        "displayName": "Yoram Zague",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "France",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2006-05-15"
    },
    "meling": {
        "displayName": "Birger Meling",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Norway",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1994-12-17"
    },
    "delaney": {
        "displayName": "Thomas Delaney",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1991-09-03"
    },
    "mattsson": {
        "displayName": "Magnus Mattsson",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-02-25"
    },
    "clem": {
        "displayName": "William Clem",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "2004-03-26"
    },
    "madsen": {
        "displayName": "Mads Emil Madsen",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1998-01-07"
    },
    "sarapata": {
        "displayName": "Dominik Sarapata",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Poland",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2007-10-25"
    },
    "hojer": {
        "displayName": "Oliver Højer",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2007-01-24"
    },
    "moukoko": {
        "displayName": "Youssoufa Moukoko",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Germany",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-11-20"
    },
    "elyounoussi": {
        "displayName": "Mohamed Elyounoussi",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Norway",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1994-08-04"
    },
    "achouri": {
        "displayName": "Elias Achouri",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Tunisia",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "1999-02-10"
    },
    "jordanlarsson": {
        "displayName": "Jordan Larsson",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Sweden",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-06-20"
    },
    "andreascornelius": {
        "displayName": "Andreas Cornelius",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Denmark",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1993-03-16"
    },
    "claesson": {
        "displayName": "Viktor Claesson",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Sweden",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1992-02-02"
    },
    "dadason": {
        "displayName": "Viktor Bjarki Daðason",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Iceland",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "2008-06-30"
    },
    "robert": {
        "displayName": "Robert",
        "club": "FC Copenhagen",
        "league": "Danish Superliga",
        "country": "Brazil",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2005-04-13"
    },
    "donnarumma": {
        "displayName": "Gianluigi Donnarumma",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1999-02-25"
    },
    "trafford": {
        "displayName": "James Trafford",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-10-10"
    },
    "stefanortega": {
        "displayName": "Stefan Ortega",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 18,
        "dateofbirth": "1992-11-06"
    },
    "guehi": {
        "displayName": "Marc Guéhi",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2000-07-13"
    },
    "rubendias": {
        "displayName": "Rúben Dias",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-05-14"
    },
    "gvardiol": {
        "displayName": "Joško Gvardiol",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Croatia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2002-01-23"
    },
    "stones": {
        "displayName": "John Stones",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1994-05-28"
    },
    "ake": {
        "displayName": "Nathan Aké",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1995-02-18"
    },
    "aitnouri": {
        "displayName": "Rayan Aït-Nouri",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Algeria",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2001-06-06"
    },
    "ricolewis": {
        "displayName": "Rico Lewis",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 82,
        "dateofbirth": "2004-11-21"
    },
    "khusanov": {
        "displayName": "Abdukodir Khusanov",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Uzbekistan",
        "position": "Defender",
        "number": 45,
        "dateofbirth": "2004-02-29"
    },
    "rodri": {
        "displayName": "Rodri",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1996-06-22"
    },
    "foden": {
        "displayName": "Phil Foden",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 47,
        "dateofbirth": "2000-05-28"
    },
    "reijnders": {
        "displayName": "Tijjani Reijnders",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1998-07-29"
    },
    "nicogonzalez": {
        "displayName": "Nico González",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2002-01-03"
    },
    "bernardosilva": {
        "displayName": "Bernardo Silva",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1994-08-10"
    },
    "cherki": {
        "displayName": "Rayan Cherki",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-08-17"
    },
    "kovacic": {
        "displayName": "Mateo Kovačić",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-05-06"
    },
    "matheusnunes": {
        "displayName": "Matheus Nunes",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1998-08-27"
    },
    "oreilly": {
        "displayName": "Nico O'Reilly",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2005-03-21"
    },
    "haaland": {
        "displayName": "Erling Haaland",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Norway",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-07-21"
    },
    "semenyo": {
        "displayName": "Antoine Semenyo",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Ghana",
        "position": "Forward",
        "number": 42,
        "dateofbirth": "2000-01-07"
    },
    "doku": {
        "displayName": "Jérémy Doku",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-05-27"
    },
    "savinho": {
        "displayName": "Savinho",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "2004-04-10"
    },
    "marmoush": {
        "displayName": "Omar Marmoush",
        "club": "Manchester City",
        "league": "Premier League",
        "country": "Egypt",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-02-07"
    },
    "bobb": {
        "displayName": "Oscar Bobb",
        "club": "Fulham",
        "league": "Premier League",
        "country": "Norway",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-07-12"
    },
    "vicario": {
        "displayName": "Guglielmo Vicario",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1996-10-07"
    },
    "kinsky": {
        "displayName": "Antonín Kinský",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2003-03-13"
    },
    "austin": {
        "displayName": "Brandon Austin",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1999-01-08"
    },
    "cristianromero": {
        "displayName": "Cristian Romero",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1998-04-27"
    },
    "vandeven": {
        "displayName": "Micky van de Ven",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2001-04-19"
    },
    "dragusin": {
        "displayName": "Radu Drăgușin",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Romania",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-02-03"
    },
    "danso": {
        "displayName": "Kevin Danso",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Austria",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-09-19"
    },
    "udogie": {
        "displayName": "Destiny Udogie",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2002-11-28"
    },
    "pedroporro": {
        "displayName": "Pedro Porro",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-09-13"
    },
    "spence": {
        "displayName": "Djed Spence",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2000-08-09"
    },
    "takai": {
        "displayName": "Kōta Takai",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Japan",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2004-09-04"
    },
    "bendavies": {
        "displayName": "Ben Davies",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Wales",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1993-04-24"
    },
    "palhinha": {
        "displayName": "João Palhinha",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1995-07-09"
    },
    "bissouma": {
        "displayName": "Yves Bissouma",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Mali",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-08-30"
    },
    "maddison": {
        "displayName": "James Maddison",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-11-23"
    },
    "archiegray": {
        "displayName": "Archie Gray",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2006-03-12"
    },
    "bergvall": {
        "displayName": "Lucas Bergvall",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2006-02-02"
    },
    "kulusevski": {
        "displayName": "Dejan Kulusevski",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2000-04-25"
    },
    "papesarr": {
        "displayName": "Pape Matar Sarr",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "2002-09-14"
    },
    "bentancur": {
        "displayName": "Rodrigo Bentancur",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "1997-06-25"
    },
    "richarlison": {
        "displayName": "Richarlison",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-05-10"
    },
    "xavisimons": {
        "displayName": "Xavi Simons",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-04-21"
    },
    "mathystel": {
        "displayName": "Mathys Tel",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2005-04-27"
    },
    "solanke": {
        "displayName": "Dominic Solanke",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1997-09-14"
    },
    "kudus": {
        "displayName": "Mohammed Kudus",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "Ghana",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-08-02"
    },
    "brennanjohnson": {
        "displayName": "Brennan Johnson",
        "club": "Crystal Palace",
        "league": "Premier League",
        "country": "Wales",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-05-23"
    },
    "odobert": {
        "displayName": "Wilson Odobert",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "2004-11-28"
    },
    "kolomuani": {
        "displayName": "Randal Kolo Muani",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "1998-12-05"
    },
    "scarlett": {
        "displayName": "Dane Scarlett",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 44,
        "dateofbirth": "2004-03-24"
    },
    "robertsanchez": {
        "displayName": "Robert Sánchez",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-11-18"
    },
    "jorgensen": {
        "displayName": "Filip Jørgensen",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "2002-04-16"
    },
    "slonina": {
        "displayName": "Gabriel Slonina",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2004-05-15"
    },
    "reecejames": {
        "displayName": "Reece James",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1999-12-08"
    },
    "colwill": {
        "displayName": "Levi Colwill",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2003-02-26"
    },
    "wesleyfofana": {
        "displayName": "Wesley Fofana",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2000-12-17"
    },
    "cucurella": {
        "displayName": "Marc Cucurella",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1998-07-22"
    },
    "gusto": {
        "displayName": "Malo Gusto",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2003-05-19"
    },
    "hato": {
        "displayName": "Jorrel Hato",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2006-03-07"
    },
    "badiashile": {
        "displayName": "Benoît Badiashile",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2001-03-26"
    },
    "adarabioyo": {
        "displayName": "Tosin Adarabioyo",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-09-24"
    },
    "caicedo": {
        "displayName": "Moisés Caicedo",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Ecuador",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2001-11-02"
    },
    "enzo": {
        "displayName": "Enzo Fernández",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2001-01-17"
    },
    "palmer": {
        "displayName": "Cole Palmer",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-05-06"
    },
    "lavia": {
        "displayName": "Roméo Lavia",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "2004-01-06"
    },
    "essugo": {
        "displayName": "Dário Essugo",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2005-03-14"
    },
    "andreysantos": {
        "displayName": "Andrey Santos",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2004-05-03"
    },
    "buonanotte": {
        "displayName": "Facundo Buonanotte",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 40,
        "dateofbirth": "2004-12-23"
    },
    "joaopedro": {
        "displayName": "João Pedro",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2001-09-26"
    },
    "estevao": {
        "displayName": "Estêvão",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 41,
        "dateofbirth": "2007-04-24"
    },
    "garnacho": {
        "displayName": "Alejandro Garnacho",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Forward",
        "number": 49,
        "dateofbirth": "2004-07-01"
    },
    "pedroneto": {
        "displayName": "Pedro Neto",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-03-09"
    },
    "gittens": {
        "displayName": "Jamie Gittens",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-08-08"
    },
    "delap": {
        "displayName": "Liam Delap",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-02-08"
    },
    "mudryk": {
        "displayName": "Mykhailo Mudryk",
        "club": "Chelsea",
        "league": "Premier League",
        "country": "Ukraine",
        "position": "Forward",
        "number": 15,
        "dateofbirth": "2001-01-05"
    },
    "nickpope": {
        "displayName": "Nick Pope",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-04-19"
    },
    "ramsdale": {
        "displayName": "Aaron Ramsdale",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "1998-05-14"
    },
    "gillespie": {
        "displayName": "Mark Gillespie",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 29,
        "dateofbirth": "1992-03-27"
    },
    "botman": {
        "displayName": "Sven Botman",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-01-12"
    },
    "thiaw": {
        "displayName": "Malick Thiaw",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Germany",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2001-08-08"
    },
    "schar": {
        "displayName": "Fabian Schär",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1991-12-20"
    },
    "danburn": {
        "displayName": "Dan Burn",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1992-05-09"
    },
    "lewishall": {
        "displayName": "Lewis Hall",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-09-08"
    },
    "livramento": {
        "displayName": "Tino Livramento",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2002-11-12"
    },
    "trippier": {
        "displayName": "Kieran Trippier",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1990-09-19"
    },
    "lascelles": {
        "displayName": "Jamaal Lascelles",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1993-11-11"
    },
    "bruno": {
        "displayName": "Bruno Guimarães",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "1997-11-16"
    },
    "tonali": {
        "displayName": "Sandro Tonali",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Italy",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-05-08"
    },
    "joelinton": {
        "displayName": "Joelinton",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1996-08-14"
    },
    "jacobramsey": {
        "displayName": "Jacob Ramsey",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "2001-05-28"
    },
    "lewismiley": {
        "displayName": "Lewis Miley",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 67,
        "dateofbirth": "2006-05-01"
    },
    "willock": {
        "displayName": "Joe Willock",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1999-08-20"
    },
    "woltemade": {
        "displayName": "Nick Woltemade",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Germany",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2002-02-14"
    },
    "anthonygordon": {
        "displayName": "Anthony Gordon",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-02-24"
    },
    "wissa": {
        "displayName": "Yoane Wissa",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "DR Congo",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1996-09-03"
    },
    "elanga": {
        "displayName": "Anthony Elanga",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2002-04-27"
    },
    "harveybarnes": {
        "displayName": "Harvey Barnes",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-12-09"
    },
    "osula": {
        "displayName": "William Osula",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2003-08-04"
    },
    "jacobmurphy": {
        "displayName": "Jacob Murphy",
        "club": "Newcastle United",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1995-02-24"
    },
    "alisson": {
        "displayName": "Alisson Becker",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-10-02"
    },
    "mamardashvili": {
        "displayName": "Giorgi Mamardashvili",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Georgia",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2000-09-29"
    },
    "woodman": {
        "displayName": "Freddie Woodman",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1997-03-04"
    },
    "vandijk": {
        "displayName": "Virgil van Dijk",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1991-07-08"
    },
    "liverpoolkonate": {
        "displayName": "Ibrahima Konaté",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-05-25"
    },
    "kerkez": {
        "displayName": "Milos Kerkez",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Hungary",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2003-11-07"
    },
    "gomez": {
        "displayName": "Joe Gomez",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-05-23"
    },
    "robertson": {
        "displayName": "Andy Robertson",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Scotland",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1994-03-11"
    },
    "frimpong": {
        "displayName": "Jeremie Frimpong",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2000-12-10"
    },
    "bradley": {
        "displayName": "Conor Bradley",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Northern Ireland",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2003-07-09"
    },
    "leoni": {
        "displayName": "Giovanni Leoni",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2006-12-21"
    },
    "wirtz": {
        "displayName": "Florian Wirtz",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Germany",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-05-03"
    },
    "alexismacallister": {
        "displayName": "Alexis Mac Allister",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-12-24"
    },
    "szoboszlai": {
        "displayName": "Dominik Szoboszlai",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Hungary",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-10-25"
    },
    "gravenberch": {
        "displayName": "Ryan Gravenberch",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2002-05-16"
    },
    "curtisjones": {
        "displayName": "Curtis Jones",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2001-01-30"
    },
    "endo": {
        "displayName": "Wataru Endo",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Japan",
        "position": "Midfielder",
        "number": 3,
        "dateofbirth": "1993-02-09"
    },
    "bajcetic": {
        "displayName": "Stefan Bajcetic",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2004-10-22"
    },
    "nyoni": {
        "displayName": "Trey Nyoni",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2007-06-30"
    },
    "isak": {
        "displayName": "Alexander Isak",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-09-21"
    },
    "salah": {
        "displayName": "Mohamed Salah",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Egypt",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1992-06-15"
    },
    "gakpo": {
        "displayName": "Cody Gakpo",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1999-05-07"
    },
    "ekitike": {
        "displayName": "Hugo Ekitike",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "France",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2002-06-20"
    },
    "chiesa": {
        "displayName": "Federico Chiesa",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "Italy",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1997-10-25"
    },
    "ngumoha": {
        "displayName": "Rio Ngumoha",
        "club": "Liverpool",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 73,
        "dateofbirth": "2008-07-21"
    },
    "bayindir": {
        "displayName": "Altay Bayındır",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1998-04-14"
    },
    "heaton": {
        "displayName": "Tom Heaton",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1986-04-15"
    },
    "lammens": {
        "displayName": "Senne Lammens",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2002-07-07"
    },
    "dalot": {
        "displayName": "Diogo Dalot",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-03-18"
    },
    "mazraoui": {
        "displayName": "Noussair Mazraoui",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Morocco",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-11-14"
    },
    "deligt": {
        "displayName": "Matthijs de Ligt",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-08-12"
    },
    "maguire": {
        "displayName": "Harry Maguire",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1993-03-05"
    },
    "inigomartinez": {
        "displayName": "Lisandro Martínez",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-01-18"
    },
    "malacia": {
        "displayName": "Tyrell Malacia",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1999-08-17"
    },
    "dorgu": {
        "displayName": "Patrick Dorgu",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2004-10-26"
    },
    "yoro": {
        "displayName": "Leny Yoro",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2005-11-13"
    },
    "shaw": {
        "displayName": "Luke Shaw",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1995-07-12"
    },
    "heaven": {
        "displayName": "Ayden Heaven",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2006-09-22"
    },
    "leon": {
        "displayName": "Diego León",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Paraguay",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2007-04-03"
    },
    "casemiro": {
        "displayName": "Casemiro",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1992-02-23"
    },
    "ugarte": {
        "displayName": "Manuel Ugarte",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2001-04-11"
    },
    "mainoo": {
        "displayName": "Kobbie Mainoo",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 37,
        "dateofbirth": "2005-04-19"
    },
    "mount": {
        "displayName": "Mason Mount",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1999-01-10"
    },
    "brunofernandes": {
        "displayName": "Bruno Fernandes",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-09-08"
    },
    "cunha": {
        "displayName": "Matheus Cunha",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1999-05-27"
    },
    "zirkzee": {
        "displayName": "Joshua Zirkzee",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-05-22"
    },
    "amad": {
        "displayName": "Amad Diallo",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2002-07-11"
    },
    "mbeumo": {
        "displayName": "Bryan Mbeumo",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Cameroon",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1999-08-07"
    },
    "sesko": {
        "displayName": "Benjamin Šeško",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Slovenia",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2003-05-31"
    },
    "chidoobi": {
        "displayName": "Chido Obi-Martin",
        "club": "Manchester United",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "2007-11-29"
    },
    "emartinez": {
        "displayName": "Emiliano Martínez",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1992-09-02"
    },
    "bizot": {
        "displayName": "Marco Bizot",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1991-03-10"
    },
    "pautorres": {
        "displayName": "Pau Torres",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1997-01-16"
    },
    "konsa": {
        "displayName": "Ezri Konsa",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-10-23"
    },
    "lindelof": {
        "displayName": "Victor Lindelöf",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1994-07-17"
    },
    "maatsen": {
        "displayName": "Ian Maatsen",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2002-03-10"
    },
    "cash": {
        "displayName": "Matty Cash",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Poland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-08-07"
    },
    "digne": {
        "displayName": "Lucas Digne",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1993-07-20"
    },
    "mings": {
        "displayName": "Tyrone Mings",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1993-03-13"
    },
    "andresgarcia": {
        "displayName": "Andrés García",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2003-02-07"
    },
    "aonana": {
        "displayName": "Amadou Onana",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2001-08-16"
    },
    "tielemans": {
        "displayName": "Youri Tielemans",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-05-07"
    },
    "mcginn": {
        "displayName": "John McGinn",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1994-10-18"
    },
    "kamara": {
        "displayName": "Boubacar Kamara",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "France",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "1999-11-23"
    },
    "barkley": {
        "displayName": "Ross Barkley",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1993-12-05"
    },
    "mrogers": {
        "displayName": "Morgan Rogers",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2002-07-26"
    },
    "elliott": {
        "displayName": "Harvey Elliott",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 9,
        "dateofbirth": "2003-04-04"
    },
    "buendia": {
        "displayName": "Emiliano Buendía",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-12-25"
    },
    "watkins": {
        "displayName": "Ollie Watkins",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1995-12-30"
    },
    "sancho": {
        "displayName": "Jadon Sancho",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2000-03-25"
    },
    "malen": {
        "displayName": "Donyell Malen",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1999-01-19"
    },
    "guessand": {
        "displayName": "Evann Guessand",
        "club": "Aston Villa",
        "league": "Premier League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2001-07-01"
    },
    "davidraya": {
        "displayName": "David Raya",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-09-15"
    },
    "kepa": {
        "displayName": "Kepa Arrizabalaga",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1994-10-03"
    },
    "tommysetford": {
        "displayName": "Tommy Setford",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Goalkeeper",
        "number": 35,
        "dateofbirth": "2006-03-13"
    },
    "saliba": {
        "displayName": "William Saliba",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-03-24"
    },
    "mosquera": {
        "displayName": "Cristhian Mosquera",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-06-27"
    },
    "benwhite": {
        "displayName": "Ben White",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-10-08"
    },
    "hincapie": {
        "displayName": "Piero Hincapié",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Ecuador",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-01-09"
    },
    "gabriel": {
        "displayName": "Gabriel Magalhães",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1997-12-19"
    },
    "jurrientimber": {
        "displayName": "Jurriën Timber",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2001-06-17"
    },
    "calafiori": {
        "displayName": "Riccardo Calafiori",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Italy",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2002-05-19"
    },
    "lewisskelly": {
        "displayName": "Myles Lewis-Skelly",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Defender",
        "number": 49,
        "dateofbirth": "2006-09-26"
    },
    "odegaard": {
        "displayName": "Martin Ødegaard",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Norway",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-12-17"
    },
    "eze": {
        "displayName": "Eberechi Eze",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-06-29"
    },
    "norgaard": {
        "displayName": "Christian Nørgaard",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1994-03-10"
    },
    "nwaneri": {
        "displayName": "Ethan Nwaneri",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2007-03-21"
    },
    "merino": {
        "displayName": "Mikel Merino",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1996-06-22"
    },
    "zubimendi": {
        "displayName": "Martín Zubimendi",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Spain",
        "position": "Midfielder",
        "number": 36,
        "dateofbirth": "1999-02-02"
    },
    "declanrice": {
        "displayName": "Declan Rice",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "1999-01-14"
    },
    "saka": {
        "displayName": "Bukayo Saka",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-09-05"
    },
    "gabrieljesus": {
        "displayName": "Gabriel Jesus",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-04-03"
    },
    "gabrielmartinelli": {
        "displayName": "Gabriel Martinelli",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-06-18"
    },
    "gyokeres": {
        "displayName": "Viktor Gyökeres",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Sweden",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1998-06-04"
    },
    "trossard": {
        "displayName": "Leandro Trossard",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Belgium",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1994-12-04"
    },
    "madueke": {
        "displayName": "Noni Madueke",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "England",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2002-03-10"
    },
    "havertz": {
        "displayName": "Kai Havertz",
        "club": "Arsenal",
        "league": "Premier League",
        "country": "Germany",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1999-06-11"
    },
    "degea": {
        "displayName": "David de Gea",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 43,
        "dateofbirth": "1990-11-07"
    },
    "lezzerini": {
        "displayName": "Luca Lezzerini",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-03-24"
    },
    "tommasomartinelli": {
        "displayName": "Tommaso Martinelli",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "2006-01-06"
    },
    "dodo": {
        "displayName": "Dodô",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-11-17"
    },
    "pongracic": {
        "displayName": "Marin Pongračić",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-09-11"
    },
    "ranieri": {
        "displayName": "Luca Ranieri",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1999-04-23"
    },
    "comuzzo": {
        "displayName": "Pietro Comuzzo",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2005-02-20"
    },
    "pablomari": {
        "displayName": "Pablo Marí",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1993-08-31"
    },
    "gosens": {
        "displayName": "Robin Gosens",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Germany",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1994-07-05"
    },
    "viti": {
        "displayName": "Mattia Viti",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2002-01-24"
    },
    "lamptey": {
        "displayName": "Tariq Lamptey",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Ghana",
        "position": "Defender",
        "number": 48,
        "dateofbirth": "2000-09-30"
    },
    "parisi": {
        "displayName": "Fabiano Parisi",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 65,
        "dateofbirth": "2000-11-09"
    },
    "sohm": {
        "displayName": "Simon Sohm",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2001-04-11"
    },
    "mandragora": {
        "displayName": "Rolando Mandragora",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-06-29"
    },
    "fagioli": {
        "displayName": "Nicolò Fagioli",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2001-02-12"
    },
    "fazzini": {
        "displayName": "Jacopo Fazzini",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2003-03-16"
    },
    "ndour": {
        "displayName": "Cher Ndour",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2004-07-27"
    },
    "richardson": {
        "displayName": "Amir Richardson",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2002-01-24"
    },
    "nicolussi": {
        "displayName": "Hans Nicolussi Caviglia",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2000-06-18"
    },
    "dzeko": {
        "displayName": "Edin Džeko",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1986-03-17"
    },
    "gudmundsson": {
        "displayName": "Albert Guðmundsson",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Iceland",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-06-15"
    },
    "kean": {
        "displayName": "Moise Kean",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-02-28"
    },
    "piccoli": {
        "displayName": "Roberto Piccoli",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 91,
        "dateofbirth": "2001-01-27"
    },
    "kouame": {
        "displayName": "Christian Kouamé",
        "club": "Fiorentina",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1997-12-06"
    },
    "meret": {
        "displayName": "Alex Meret",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-03-22"
    },
    "milinkovic_savic": {
        "displayName": "Vanja Milinković-Savić",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "1997-02-20"
    },
    "contini": {
        "displayName": "Nikita Contini",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 14,
        "dateofbirth": "1996-05-21"
    },
    "buongiorno": {
        "displayName": "Alessandro Buongiorno",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-06-06"
    },
    "beukema": {
        "displayName": "Sam Beukema",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "1998-11-17"
    },
    "rrahmani": {
        "displayName": "Amir Rrahmani",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Kosovo",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1994-02-24"
    },
    "gutierrez": {
        "displayName": "Miguel Gutiérrez",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-07-27"
    },
    "dilorenzo": {
        "displayName": "Giovanni Di Lorenzo",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1993-08-04"
    },
    "olivera": {
        "displayName": "Mathías Olivera",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Uruguay",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1997-10-31"
    },
    "spinazzola": {
        "displayName": "Leonardo Spinazzola",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "1993-03-25"
    },
    "juan_jesus": {
        "displayName": "Juan Jesus",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1991-06-10"
    },
    "mctominay": {
        "displayName": "Scott McTominay",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-12-08"
    },
    "debruyne": {
        "displayName": "Kevin De Bruyne",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1991-06-28"
    },
    "anguissa": {
        "displayName": "André-Frank Zambo Anguissa",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Cameroon",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "1995-11-16"
    },
    "lobotka": {
        "displayName": "Stanislav Lobotka",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Slovakia",
        "position": "Midfielder",
        "number": 68,
        "dateofbirth": "1994-11-25"
    },
    "gilmour": {
        "displayName": "Billy Gilmour",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-06-11"
    },
    "elmas": {
        "displayName": "Eljif Elmas",
        "club": "Napoli",
        "league": "Serie A",
        "country": "North Macedonia",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1999-09-24"
    },
    "lukaku": {
        "displayName": "Romelu Lukaku",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-05-13"
    },
    "rasmushojlund": {
        "displayName": "Rasmus Højlund",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2003-02-04"
    },
    "neres": {
        "displayName": "David Neres",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1997-03-03"
    },
    "noa_lang": {
        "displayName": "Noa Lang",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Netherlands",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "1999-06-17"
    },
    "lucca": {
        "displayName": "Lorenzo Lucca",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2000-09-10"
    },
    "politano": {
        "displayName": "Matteo Politano",
        "club": "Napoli",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1993-08-03"
    },
    "svilar": {
        "displayName": "Mile Svilar",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "1999-08-27"
    },
    "vasquez": {
        "displayName": "Devis Vásquez",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Colombia",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "1998-05-12"
    },
    "gollini": {
        "displayName": "Pierluigi Gollini",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 95,
        "dateofbirth": "1995-03-18"
    },
    "mancini": {
        "displayName": "Gianluca Mancini",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1996-04-17"
    },
    "ndicka": {
        "displayName": "Evan Ndicka",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-08-20"
    },
    "hermoso": {
        "displayName": "Mario Hermoso",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1995-06-18"
    },
    "angelino": {
        "displayName": "Angeliño",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-01-04"
    },
    "tsimikas": {
        "displayName": "Kostas Tsimikas",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Greece",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1996-05-12"
    },
    "rensch": {
        "displayName": "Devyne Rensch",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-01-18"
    },
    "wesley": {
        "displayName": "Wesley",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 43,
        "dateofbirth": "2003-09-06"
    },
    "zekicelik": {
        "displayName": "Zeki Çelik",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Turkey",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1997-02-17"
    },
    "pellegrini": {
        "displayName": "Lorenzo Pellegrini",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1996-06-19"
    },
    "cristante": {
        "displayName": "Bryan Cristante",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1995-03-03"
    },
    "kone": {
        "displayName": "Manu Koné",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2001-05-17"
    },
    "elaynaoui": {
        "displayName": "Neil El Aynaoui",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2001-07-02"
    },
    "pisilli": {
        "displayName": "Niccolò Pisilli",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 61,
        "dateofbirth": "2004-09-23"
    },
    "baldanzi": {
        "displayName": "Tommaso Baldanzi",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 35,
        "dateofbirth": "2003-03-23"
    },
    "dybala": {
        "displayName": "Paulo Dybala",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1993-11-15"
    },
    "dovbyk": {
        "displayName": "Artem Dovbyk",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Ukraine",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-06-21"
    },
    "soule": {
        "displayName": "Matías Soulé",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2003-04-15"
    },
    "bailey": {
        "displayName": "Leon Bailey",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Jamaica",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "1997-08-09"
    },
    "ferguson": {
        "displayName": "Evan Ferguson",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Ireland",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-10-19"
    },
    "elshaarawy": {
        "displayName": "Stephan El Shaarawy",
        "club": "AS Roma",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 92,
        "dateofbirth": "1992-10-27"
    },
    "digregorio": {
        "displayName": "Michele Di Gregorio",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1997-07-27"
    },
    "perin": {
        "displayName": "Mattia Perin",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-11-10"
    },
    "pinsoglio": {
        "displayName": "Carlo Pinsoglio",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1990-03-16"
    },
    "bremer": {
        "displayName": "Gleison Bremer",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-03-18"
    },
    "gatti": {
        "displayName": "Federico Gatti",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-06-24"
    },
    "kalulu": {
        "displayName": "Pierre Kalulu",
        "club": "Juventus",
        "league": "Serie A",
        "country": "France",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2000-06-05"
    },
    "lloydkelly": {
        "displayName": "Lloyd Kelly",
        "club": "Juventus",
        "league": "Serie A",
        "country": "England",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-10-06"
    },
    "cambiaso": {
        "displayName": "Andrea Cambiaso",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2000-02-20"
    },
    "juvejoaomario": {
        "displayName": "Joao Mário",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2000-01-03"
    },
    "cabal": {
        "displayName": "Juan Cabal",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Colombia",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2001-01-08"
    },
    "rouhi": {
        "displayName": "Jonas Rouhi",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Sweden",
        "position": "Defender",
        "number": 40,
        "dateofbirth": "2004-01-07"
    },
    "locatelli": {
        "displayName": "Manuel Locatelli",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1998-01-08"
    },
    "koopmeiners": {
        "displayName": "Teun Koopmeiners",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-02-28"
    },
    "thuram": {
        "displayName": "Khéphren Thuram",
        "club": "Juventus",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2001-03-26"
    },
    "mckennie": {
        "displayName": "Weston McKennie",
        "club": "Juventus",
        "league": "Serie A",
        "country": "United States",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1998-08-28"
    },
    "miretti": {
        "displayName": "Fabio Miretti",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2003-08-03"
    },
    "adzic": {
        "displayName": "Vasilije Adžić",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Montenegro",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2006-05-12"
    },
    "vlahovic": {
        "displayName": "Dušan Vlahović",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-01-28"
    },
    "yildiz": {
        "displayName": "Kenan Yildiz",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Turkey",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2005-05-04"
    },
    "conceicao": {
        "displayName": "Francisco Conceição",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-12-14"
    },
    "zhegrova": {
        "displayName": "Edon Zhegrova",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Kosovo",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1999-03-31"
    },
    "jonathandavid": {
        "displayName": "Jonathan David",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Canada",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2000-01-14"
    },
    "openda": {
        "displayName": "Loïs Openda",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-02-16"
    },
    "milik": {
        "displayName": "Arkadiusz Milik",
        "club": "Juventus",
        "league": "Serie A",
        "country": "Poland",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1994-02-28"
    },
    "sommer": {
        "displayName": "Yann Sommer",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1988-12-17"
    },
    "josepmartinez": {
        "displayName": "Josep Martínez",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1998-05-27"
    },
    "digennaro": {
        "displayName": "Raffaele Di Gennaro",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1993-10-03"
    },
    "bastoni": {
        "displayName": "Alessandro Bastoni",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 95,
        "dateofbirth": "1999-04-13"
    },
    "akanji": {
        "displayName": "Manuel Akanji",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Switzerland",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1995-07-19"
    },
    "bisseck": {
        "displayName": "Yann Bisseck",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Germany",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2000-11-29"
    },
    "devrij": {
        "displayName": "Stefan de Vrij",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1992-02-05"
    },
    "acerbi": {
        "displayName": "Francesco Acerbi",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1988-02-10"
    },
    "tomaspalacios": {
        "displayName": "Tomás Palacios",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "2003-04-28"
    },
    "dimarco": {
        "displayName": "Federico Dimarco",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "1997-11-10"
    },
    "carlosaugusto": {
        "displayName": "Carlos Augusto",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1999-01-07"
    },
    "dumfries": {
        "displayName": "Denzel Dumfries",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-04-18"
    },
    "darmian": {
        "displayName": "Matteo Darmian",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 36,
        "dateofbirth": "1989-12-02"
    },
    "barella": {
        "displayName": "Nicolò Barella",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1997-02-07"
    },
    "calhanoglu": {
        "displayName": "Hakan Çalhanoğlu",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1994-02-08"
    },
    "frattesi": {
        "displayName": "Davide Frattesi",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1999-09-22"
    },
    "petarsucic": {
        "displayName": "Petar Sučić",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-10-25"
    },
    "andy_diouf": {
        "displayName": "Andy Diouf",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2003-05-17"
    },
    "zielinski": {
        "displayName": "Piotr Zieliński",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Poland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1994-05-20"
    },
    "mkhitaryan": {
        "displayName": "Henrikh Mkhitaryan",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Armenia",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1989-01-21"
    },
    "luis_henrique": {
        "displayName": "Luis Henrique",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2001-12-14"
    },
    "lautaro": {
        "displayName": "Lautaro Martínez",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Argentina",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-08-22"
    },
    "mthuram": {
        "displayName": "Marcus Thuram",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-08-06"
    },
    "bonny": {
        "displayName": "Ange-Yoan Bonny",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-10-25"
    },
    "pioesposito": {
        "displayName": "Pio Esposito",
        "club": "Inter Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 94,
        "dateofbirth": "2005-06-28"
    },
    "maignan": {
        "displayName": "Mike Maignan",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1995-07-03"
    },
    "pietro_terracciano": {
        "displayName": "Pietro Terracciano",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1990-03-08"
    },
    "torriani": {
        "displayName": "Lorenzo Torriani",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 96,
        "dateofbirth": "2005-01-31"
    },
    "tomori": {
        "displayName": "Fikayo Tomori",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1997-12-19"
    },
    "strahinjapavlovic": {
        "displayName": "Strahinja Pavlović",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2001-05-24"
    },
    "gabbia": {
        "displayName": "Matteo Gabbia",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 46,
        "dateofbirth": "1999-10-21"
    },
    "dewinter": {
        "displayName": "Koni De Winter",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-06-12"
    },
    "estupinan": {
        "displayName": "Pervis Estupiñán",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Ecuador",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-01-21"
    },
    "athekame": {
        "displayName": "Zachary Athekame",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Switzerland",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2004-12-13"
    },
    "odogu": {
        "displayName": "David Odogu",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Germany",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2006-06-03"
    },
    "bartesaghi": {
        "displayName": "Davide Bartesaghi",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2005-12-29"
    },
    "modric": {
        "displayName": "Luka Modrić",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1985-09-09"
    },
    "youssouffofana": {
        "displayName": "Youssouf Fofana",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1999-01-10"
    },
    "ricci": {
        "displayName": "Samuele Ricci",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2001-08-21"
    },
    "rabiot": {
        "displayName": "Adrien Rabiot",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Midfielder",
        "number": 12,
        "dateofbirth": "1995-04-03"
    },
    "jashari": {
        "displayName": "Ardon Jashari",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2002-07-30"
    },
    "loftuscheek": {
        "displayName": "Ruben Loftus-Cheek",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "England",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-01-23"
    },
    "saelemaekers": {
        "displayName": "Alexis Saelemaekers",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 56,
        "dateofbirth": "1999-06-27"
    },
    "leao": {
        "displayName": "Rafael Leão",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1999-06-10"
    },
    "pulisic": {
        "displayName": "Christian Pulisic",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "United States",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-09-18"
    },
    "nkunku": {
        "displayName": "Christopher Nkunku",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "France",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1997-11-14"
    },
    "santiagogimenez": {
        "displayName": "Santiago Giménez",
        "club": "AC Milan",
        "league": "Serie A",
        "country": "Mexico",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-04-18"
    },
    "provedel": {
        "displayName": "Ivan Provedel",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 94,
        "dateofbirth": "1994-03-17"
    },
    "mandas": {
        "displayName": "Christos Mandas",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 35,
        "dateofbirth": "2001-09-17"
    },
    "furlanetto": {
        "displayName": "Alessio Furlanetto",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 55,
        "dateofbirth": "2002-02-07"
    },
    "romagnoli": {
        "displayName": "Alessio Romagnoli",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1995-01-12"
    },
    "gila": {
        "displayName": "Mario Gila",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2000-08-29"
    },
    "gigot": {
        "displayName": "Samuel Gigot",
        "club": "Lazio",
        "league": "Serie A",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1993-10-12"
    },
    "patric": {
        "displayName": "Patric",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1993-04-17"
    },
    "provstgaard": {
        "displayName": "Oliver Provstgaard",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2003-06-04"
    },
    "nunotavares": {
        "displayName": "Nuno Tavares",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Portugal",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2000-01-26"
    },
    "lucapellegrini": {
        "displayName": "Luca Pellegrini",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-03-07"
    },
    "marusic": {
        "displayName": "Adam Marušić",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Montenegro",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "1992-10-17"
    },
    "lazzari": {
        "displayName": "Manuel Lazzari",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "1993-11-29"
    },
    "hysaj": {
        "displayName": "Elseid Hysaj",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Albania",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1994-02-02"
    },
    "rovella": {
        "displayName": "Nicolò Rovella",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-12-04"
    },
    "guendouzi": {
        "displayName": "Mattéo Guendouzi",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1999-04-14"
    },
    "delebashiru": {
        "displayName": "Fisayo Dele-Bashiru",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2001-02-06"
    },
    "vecino": {
        "displayName": "Matías Vecino",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1991-08-24"
    },
    "belahyane": {
        "displayName": "Reda Belahyane",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2004-06-01"
    },
    "basic": {
        "displayName": "Toma Bašić",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "1996-11-25"
    },
    "cataldi": {
        "displayName": "Danilo Cataldi",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "1994-08-06"
    },
    "zaccagni": {
        "displayName": "Mattia Zaccagni",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1995-06-16"
    },
    "castellanos": {
        "displayName": "Taty Castellanos",
        "club": "West Ham",
        "league": "Premier League",
        "country": "Argentina",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-10-03"
    },
    "isaksen": {
        "displayName": "Gustav Isaksen",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Denmark",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2001-04-19"
    },
    "noslin": {
        "displayName": "Tijjani Noslin",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1999-07-07"
    },
    "dia": {
        "displayName": "Boulaye Dia",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Senegal",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1996-11-16"
    },
    "cancellieri": {
        "displayName": "Matteo Cancellieri",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2002-02-12"
    },
    "pedro": {
        "displayName": "Pedro",
        "club": "Lazio",
        "league": "Serie A",
        "country": "Spain",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1987-07-28"
    },
    "carnesecchi": {
        "displayName": "Marco Carnesecchi",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 29,
        "dateofbirth": "2000-07-01"
    },
    "sportiello": {
        "displayName": "Marco Sportiello",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 57,
        "dateofbirth": "1992-05-10"
    },
    "rossi": {
        "displayName": "Francesco Rossi",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1991-04-27"
    },
    "scalvini": {
        "displayName": "Giorgio Scalvini",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "2003-12-11"
    },
    "hien": {
        "displayName": "Isak Hien",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Sweden",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-01-13"
    },
    "kossounou": {
        "displayName": "Odilon Kossounou",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-01-04"
    },
    "djimsiti": {
        "displayName": "Berat Djimsiti",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Albania",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1993-02-19"
    },
    "kolasinac": {
        "displayName": "Sead Kolašinac",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1993-06-20"
    },
    "ahanor": {
        "displayName": "Honest Ahanor",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Nigeria",
        "position": "Defender",
        "number": 69,
        "dateofbirth": "2008-02-23"
    },
    "zappacosta": {
        "displayName": "Davide Zappacosta",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "1992-06-11"
    },
    "bellanova": {
        "displayName": "Raoul Bellanova",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2000-05-17"
    },
    "ederson": {
        "displayName": "Éderson",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "1999-07-07"
    },
    "deroon": {
        "displayName": "Marten de Roon",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "1991-03-29"
    },
    "pasalic": {
        "displayName": "Mario Pašalić",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-02-09"
    },
    "samardzic": {
        "displayName": "Lazar Samardžić",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-02-24"
    },
    "zalewski": {
        "displayName": "Nicola Zalewski",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Poland",
        "position": "Midfielder",
        "number": 59,
        "dateofbirth": "2002-01-23"
    },
    "musah": {
        "displayName": "Yunus Musah",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "United States",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-11-29"
    },
    "brescianini": {
        "displayName": "Marco Brescianini",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "2000-01-20"
    },
    "deketelaere": {
        "displayName": "Charles De Ketelaere",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Belgium",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-03-10"
    },
    "lookman": {
        "displayName": "Ademola Lookman",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1997-10-20"
    },
    "scamacca": {
        "displayName": "Gianluca Scamacca",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-01-01"
    },
    "krstovic": {
        "displayName": "Nikola Krstović",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Montenegro",
        "position": "Forward",
        "number": 90,
        "dateofbirth": "2000-04-05"
    },
    "maldini": {
        "displayName": "Daniel Maldini",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "2001-10-11"
    },
    "sulemana": {
        "displayName": "Kamaldeen Sulemana",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Ghana",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-02-15"
    },
    "trelowski": {
        "displayName": "Kacper Trelowski",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2003-08-19"
    },
    "madrzyk": {
        "displayName": "Jakub Mądrzyk",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "2003-08-18"
    },
    "zych": {
        "displayName": "Oliwier Zych",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 48,
        "dateofbirth": "2004-02-11"
    },
    "svarnas": {
        "displayName": "Stratos Svarnas",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Greece",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-11-11"
    },
    "racovitan": {
        "displayName": "Bogdan Racovițan",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Romania",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2000-06-06"
    },
    "mosor": {
        "displayName": "Ariel Mosór",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-02-19"
    },
    "konstantopoulos": {
        "displayName": "Apostolos Konstantopoulos",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Greece",
        "position": "Defender",
        "number": 66,
        "dateofbirth": "2002-08-02"
    },
    "arsenic": {
        "displayName": "Zoran Arsenić",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1994-06-02"
    },
    "tudor": {
        "displayName": "Fran Tudor",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Defender",
        "number": 7,
        "dateofbirth": "1995-09-27"
    },
    "otieno": {
        "displayName": "Erick Otieno",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Kenya",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1996-09-27"
    },
    "bulat": {
        "displayName": "Marko Bulat",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2001-09-26"
    },
    "repka": {
        "displayName": "Oskar Repka",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1999-01-03"
    },
    "kochergin": {
        "displayName": "Vladyslav Kocherhin",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "1996-04-05"
    },
    "barath": {
        "displayName": "Péter Baráth",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Hungary",
        "position": "Midfielder",
        "number": 88,
        "dateofbirth": "2002-02-11"
    },
    "struski": {
        "displayName": "Karol Struski",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2001-01-18"
    },
    "ameyaw": {
        "displayName": "Michael Ameyaw",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2000-09-16"
    },
    "pienko": {
        "displayName": "Tomasz Pieńko",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2004-01-05"
    },
    "adriano": {
        "displayName": "Adriano Amorim",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2002-02-11"
    },
    "jean_carlos": {
        "displayName": "Jean Carlos Silva",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1996-01-20"
    },
    "ivi_lopez": {
        "displayName": "Ivi López",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1994-06-29"
    },
    "brunes": {
        "displayName": "Jonatan Braut Brunes",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Norway",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2000-08-07"
    },
    "diaby_fadiga": {
        "displayName": "Lamine Diaby-Fadiga",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "France",
        "position": "Forward",
        "number": 80,
        "dateofbirth": "2001-01-19"
    },
    "makuch": {
        "displayName": "Patryk Makuch",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1999-04-11"
    },
    "rondic": {
        "displayName": "Imad Rondić",
        "club": "Raków Częstochowa",
        "league": "Ekstraklasa",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1999-02-16"
    },
    "tobiasz": {
        "displayName": "Kacper Tobiasz",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-11-04"
    },
    "kobylak": {
        "displayName": "Gabriel Kobylak",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 27,
        "dateofbirth": "2002-02-20"
    },
    "mendes_dudzinski": {
        "displayName": "Marcel Mendes-Dudziński",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2005-05-14"
    },
    "banasik": {
        "displayName": "Wojciech Banasik",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2006-05-08"
    },
    "piatkowski": {
        "displayName": "Kamil Piątkowski",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "2000-06-21"
    },
    "kapuadi": {
        "displayName": "Steve Kapuadi",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "France",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1998-04-30"
    },
    "pankov": {
        "displayName": "Radovan Pankov",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Serbia",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1995-08-05"
    },
    "reca": {
        "displayName": "Arkadiusz Reca",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1995-06-17"
    },
    "stojanovic": {
        "displayName": "Petar Stojanović",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Slovenia",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1995-10-07"
    },
    "ruben_vinagre": {
        "displayName": "Rúben Vinagre",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1999-04-09"
    },
    "burch": {
        "displayName": "Marco Burch",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Switzerland",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-10-19"
    },
    "jedrzejczyk": {
        "displayName": "Artur Jędrzejczyk",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 55,
        "dateofbirth": "1987-11-04"
    },
    "kacper_urbanski": {
        "displayName": "Kacper Urbański",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 82,
        "dateofbirth": "2004-09-07"
    },
    "damianszymanski": {
        "displayName": "Damian Szymański",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "1995-06-16"
    },
    "kapustka": {
        "displayName": "Bartosz Kapustka",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 67,
        "dateofbirth": "1996-12-23"
    },
    "elitim": {
        "displayName": "Juergen Elitim",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Colombia",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1999-07-13"
    },
    "claudegoncalves": {
        "displayName": "Claude Gonçalves",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1994-04-09"
    },
    "augustyniak": {
        "displayName": "Rafał Augustyniak",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1993-10-14"
    },
    "wojciech_urbanski": {
        "displayName": "Wojciech Urbański",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 53,
        "dateofbirth": "2005-01-12"
    },
    "rajovic": {
        "displayName": "Mileta Rajović",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Denmark",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1999-07-17"
    },
    "nsame": {
        "displayName": "Jean-Pierre Nsame",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Cameroon",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1993-05-01"
    },
    "colak": {
        "displayName": "Antonio Čolak",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1993-09-17"
    },
    "weishaupt": {
        "displayName": "Noah Weißhaupt",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Germany",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "2001-09-20"
    },
    "krasniqi": {
        "displayName": "Ermal Krasniqi",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Kosovo",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "1998-09-07"
    },
    "bichakhchyan": {
        "displayName": "Vahan Bichakhchyan",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Armenia",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1999-07-09"
    },
    "chodyna": {
        "displayName": "Kacper Chodyna",
        "club": "Legia Warszawa",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1999-05-24"
    },
    "mrozek": {
        "displayName": "Bartosz Mrozek",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2000-02-23"
    },
    "bakowski": {
        "displayName": "Krzysztof Bąkowski",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2003-01-04"
    },
    "pruchniewski": {
        "displayName": "Mateusz Pruchniewski",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "2007-02-15"
    },
    "joelpereira": {
        "displayName": "Joël Pereira",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-06-28"
    },
    "alexdouglas": {
        "displayName": "Alex Douglas",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-08-17"
    },
    "joaomoutinho": {
        "displayName": "João Moutinho",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-01-12"
    },
    "gurgul": {
        "displayName": "Michał Gurgul",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2006-01-30"
    },
    "milic": {
        "displayName": "Antonio Milić",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Croatia",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1994-03-10"
    },
    "gumny": {
        "displayName": "Robert Gumny",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1998-06-04"
    },
    "skrzypczak": {
        "displayName": "Mateusz Skrzypczak",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 72,
        "dateofbirth": "2000-08-22"
    },
    "monka": {
        "displayName": "Wojciech Mońka",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2007-01-18"
    },
    "ouma": {
        "displayName": "Timothy Ouma",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Kenya",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2004-06-10"
    },
    "gholizadeh": {
        "displayName": "Ali Gholizadeh",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Iran",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-03-10"
    },
    "bengtsson": {
        "displayName": "Leo Bengtsson",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1998-05-26"
    },
    "murawski": {
        "displayName": "Radosław Murawski",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1994-04-22"
    },
    "kozubal": {
        "displayName": "Antoni Kozubal",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2004-08-18"
    },
    "palama": {
        "displayName": "Luis Palma",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Honduras",
        "position": "Midfielder",
        "number": 77,
        "dateofbirth": "2000-01-17"
    },
    "ismaheel": {
        "displayName": "Taofeek Ismaheel",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 88,
        "dateofbirth": "2000-08-16"
    },
    "pablorodriguez": {
        "displayName": "Pablo Rodríguez",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "2001-08-04"
    },
    "jagiello": {
        "displayName": "Filip Jagiełło",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "1997-08-08"
    },
    "ishak": {
        "displayName": "Mikael Ishak",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-03-31"
    },
    "walemark": {
        "displayName": "Patrik Wålemark",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Sweden",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-10-14"
    },
    "hakans": {
        "displayName": "Daniel Håkans",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Finland",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-10-26"
    },
    "agnero": {
        "displayName": "Yannick Agnero",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-02-20"
    },
    "fiabema": {
        "displayName": "Bryan Fiabema",
        "club": "Lech Poznań",
        "league": "Ekstraklasa",
        "country": "Norway",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2003-02-16"
    },
    "abramowicz": {
        "displayName": "Sławomir Abramowicz",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2004-06-09"
    },
    "piekutowski": {
        "displayName": "Miłosz Piekutowski",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "2006-05-08"
    },
    "damasiewicz": {
        "displayName": "Adrian Damasiewicz",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 66,
        "dateofbirth": "2008-11-20"
    },
    "vital": {
        "displayName": "Bernardo Vital",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Portugal",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2000-12-29"
    },
    "pelmard": {
        "displayName": "Andy Pelmard",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "France",
        "position": "Defender",
        "number": 70,
        "dateofbirth": "2000-03-12"
    },
    "stojinovic": {
        "displayName": "Dušan Stojinović",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Slovenia",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-08-26"
    },
    "kobayashi": {
        "displayName": "Yuki Kobayashi",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-07-18"
    },
    "wdowik": {
        "displayName": "Bartłomiej Wdowik",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2000-09-25"
    },
    "polak": {
        "displayName": "Cezary Polak",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-05-31"
    },
    "pozo": {
        "displayName": "Álex Pozo",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Defender",
        "number": 7,
        "dateofbirth": "1999-02-22"
    },
    "wojtuszek": {
        "displayName": "Norbert Wojtuszek",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2001-10-05"
    },
    "lozano": {
        "displayName": "Sergio Lozano",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1999-03-24"
    },
    "flach": {
        "displayName": "Leon Flach",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "United States",
        "position": "Midfielder",
        "number": 31,
        "dateofbirth": "2001-02-28"
    },
    "romanczuk": {
        "displayName": "Taras Romanczuk",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1991-11-14"
    },
    "azjackson": {
        "displayName": "AZ Jackson",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "United States",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2001-11-14"
    },
    "drachal": {
        "displayName": "Dawid Drachal",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2005-01-31"
    },
    "imaz": {
        "displayName": "Jesús Imaz",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1990-09-26"
    },
    "jozwiak": {
        "displayName": "Kamil Jóźwiak",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Poland",
        "position": "Forward",
        "number": 72,
        "dateofbirth": "1998-04-22"
    },
    "cantero": {
        "displayName": "Álex Cantero",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Spain",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2000-06-08"
    },
    "prip": {
        "displayName": "Louka Prip",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Denmark",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1997-06-29"
    },
    "pululu": {
        "displayName": "Afimico Pululu",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Angola",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1999-03-23"
    },
    "rallis": {
        "displayName": "Dimitris Rallis",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Greece",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2005-03-26"
    },
    "sylla": {
        "displayName": "Youssuf Sylla",
        "club": "Jagiellonia Białystok",
        "league": "Ekstraklasa",
        "country": "Belgium",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2002-12-19"
    },
    "olsen": {
        "displayName": "Robin Olsen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "1990-01-08"
    },
    "dahlin": {
        "displayName": "Johan Dahlin",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Goalkeeper",
        "number": 27,
        "dateofbirth": "1986-09-08"
    },
    "ellborg": {
        "displayName": "Melker Ellborg",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "2003-05-22"
    },
    "jansson": {
        "displayName": "Pontus Jansson",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1991-02-13"
    },
    "busanello": {
        "displayName": "Busanello",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Brazil",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1998-10-29"
    },
    "rosler": {
        "displayName": "Colin Rösler",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Norway",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2000-04-22"
    },
    "djuric": {
        "displayName": "Andrej Djuric",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Montenegro",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-09-21"
    },
    "stryger": {
        "displayName": "Jens Stryger Larsen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Denmark",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1991-02-21"
    },
    "olsson": {
        "displayName": "Martin Olsson",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1988-05-17"
    },
    "johankarlsson": {
        "displayName": "Johan Karlsson",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-06-20"
    },
    "christiansen": {
        "displayName": "Anders Christiansen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1990-06-08"
    },
    "johnsen": {
        "displayName": "Lasse Berg Johnsen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Norway",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1999-08-18"
    },
    "bolin": {
        "displayName": "Hugo Bolin",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2003-07-24"
    },
    "rosengren": {
        "displayName": "Otto Rosengren",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-05-16"
    },
    "lewicki": {
        "displayName": "Oscar Lewicki",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1992-07-14"
    },
    "busuladzic": {
        "displayName": "Kenan Busuladzic",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 40,
        "dateofbirth": "2007-02-06"
    },
    "haksabanovic": {
        "displayName": "Sead Hakšabanović",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Montenegro",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1999-05-04"
    },
    "botheim": {
        "displayName": "Erik Botheim",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Norway",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-01-10"
    },
    "sigurdsson": {
        "displayName": "Arnór Sigurðsson",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Iceland",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "1999-05-15"
    },
    "ali": {
        "displayName": "Taha Ali",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1998-07-01"
    },
    "ekong": {
        "displayName": "Emmanuel Ekong",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-06-25"
    },
    "gudjohnsen": {
        "displayName": "Daníel Gudjohnsen",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Iceland",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "2006-03-01"
    },
    "vecchia": {
        "displayName": "Stefano Vecchia",
        "club": "Malmö FF",
        "league": "Allsvenskan",
        "country": "Sweden",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1995-01-23"
    },
    "ruisilva": {
        "displayName": "Rui Silva",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-02-07"
    },
    "joaovirginia": {
        "displayName": "João Virgínia",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1999-10-10"
    },
    "diegocallai": {
        "displayName": "Diego Callai",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2004-07-18"
    },
    "franciscosilva": {
        "displayName": "Francisco Silva",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "2005-11-20"
    },
    "goncaloinacio": {
        "displayName": "Gonçalo Inácio",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2001-08-25"
    },
    "ousmanediomande": {
        "displayName": "Ousmane Diomande",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2003-12-04"
    },
    "zenodebast": {
        "displayName": "Zeno Debast",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Belgium",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2003-10-24"
    },
    "eduardoquaresma": {
        "displayName": "Eduardo Quaresma",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 72,
        "dateofbirth": "2002-03-02"
    },
    "matheusreis": {
        "displayName": "Matheus Reis",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1995-02-18"
    },
    "vagiannidis": {
        "displayName": "Georgios Vagiannidis",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Greece",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2001-09-12"
    },
    "ivanfresneda": {
        "displayName": "Iván Fresneda",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2004-09-28"
    },
    "ricardomangas": {
        "displayName": "Ricardo Mangas",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "1998-03-19"
    },
    "mortenhjulmand": {
        "displayName": "Morten Hjulmand",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "1999-06-25"
    },
    "pedrogoncalves": {
        "displayName": "Pedro Gonçalves",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-06-28"
    },
    "hidemasamorita": {
        "displayName": "Hidemasa Morita",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Japan",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1995-05-10"
    },
    "danielbraganca": {
        "displayName": "Daniel Bragança",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1999-05-27"
    },
    "kochorashvili": {
        "displayName": "Giorgi Kochorashvili",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Georgia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1999-06-29"
    },
    "joaosimoes": {
        "displayName": "João Simões",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 52,
        "dateofbirth": "2007-01-06"
    },
    "luissuarez": {
        "displayName": "Luis Suárez",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Colombia",
        "position": "Forward",
        "number": 97,
        "dateofbirth": "1997-12-02"
    },
    "fotisioannidis": {
        "displayName": "Fotis Ioannidis",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Greece",
        "position": "Forward",
        "number": 89,
        "dateofbirth": "2000-01-10"
    },
    "franciscotrincao": {
        "displayName": "Francisco Trincão",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1999-12-29"
    },
    "geovanyquenda": {
        "displayName": "Geovany Quenda",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2007-04-30"
    },
    "maxiaraujo": {
        "displayName": "Maximiliano Araújo",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Uruguay",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2000-02-15"
    },
    "alissonsantos": {
        "displayName": "Alisson Santos",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2002-05-12"
    },
    "genycatamo": {
        "displayName": "Geny Catamo",
        "club": "Sporting CP",
        "league": "Primeira Liga",
        "country": "Mozambique",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-01-26"
    },
    "diogocosta": {
        "displayName": "Diogo Costa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "1999-09-19"
    },
    "claudioramos": {
        "displayName": "Cláudio Ramos",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 14,
        "dateofbirth": "1991-12-15"
    },
    "joaocosta": {
        "displayName": "João Costa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "1996-02-02"
    },
    "thiagosilva": {
        "displayName": "Thiago Silva",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1984-09-22"
    },
    "kiwior": {
        "displayName": "Jakub Kiwior",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Poland",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-02-15"
    },
    "nehuenperez": {
        "displayName": "Nehuén Pérez",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2000-06-24"
    },
    "bednarek": {
        "displayName": "Jan Bednarek",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Poland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1996-04-12"
    },
    "franciscomoura": {
        "displayName": "Francisco Moura",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 74,
        "dateofbirth": "1999-08-16"
    },
    "albertocosta": {
        "displayName": "Alberto Costa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2003-09-29"
    },
    "martimfernandes": {
        "displayName": "Martim Fernandes",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 52,
        "dateofbirth": "2006-01-18"
    },
    "prpic": {
        "displayName": "Dominik Prpić",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Croatia",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2004-05-19"
    },
    "alanvarela": {
        "displayName": "Alan Varela",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2001-07-04"
    },
    "gabriveiga": {
        "displayName": "Gabri Veiga",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-05-27"
    },
    "froholdt": {
        "displayName": "Victor Froholdt",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-02-25"
    },
    "pablorosario": {
        "displayName": "Pablo Rosario",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "1997-01-07"
    },
    "eustaquio": {
        "displayName": "Stephen Eustáquio",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Canada",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-12-21"
    },
    "rodrigomora": {
        "displayName": "Rodrigo Mora",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 86,
        "dateofbirth": "2007-05-05"
    },
    "samuaghehowa": {
        "displayName": "Samu Aghehowa",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-05-05"
    },
    "pepe": {
        "displayName": "Pepê",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-02-24"
    },
    "borjasainz": {
        "displayName": "Borja Sainz",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-02-01"
    },
    "luukdejong": {
        "displayName": "Luuk de Jong",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Netherlands",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "1990-08-27"
    },
    "williamgomes": {
        "displayName": "William Gomes",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2006-03-15"
    },
    "denizgul": {
        "displayName": "Deniz Gül",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Turkey",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2004-07-02"
    },
    "pietuszewski": {
        "displayName": "Oskar Pietuszewski",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "Poland",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2008-05-20"
    },
    "yannkaramoh": {
        "displayName": "Yann Karamoh",
        "club": "FC Porto",
        "league": "Primeira Liga",
        "country": "France",
        "position": "Forward",
        "number": 75,
        "dateofbirth": "1998-07-08"
    },
    "trubin": {
        "displayName": "Anatoliy Trubin",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Ukraine",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-08-01"
    },
    "samuelsoares": {
        "displayName": "Samuel Soares",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "2002-06-15"
    },
    "diogoferreira": {
        "displayName": "Diogo Ferreira",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2007-04-10"
    },
    "antoniosilva": {
        "displayName": "António Silva",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-10-30"
    },
    "tomasaraujo": {
        "displayName": "Tomás Araújo",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2002-05-16"
    },
    "otamendi": {
        "displayName": "Nicolás Otamendi",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1988-02-12"
    },
    "amardedic": {
        "displayName": "Amar Dedić",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2002-08-18"
    },
    "alexanderbah": {
        "displayName": "Alexander Bah",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Denmark",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1997-12-09"
    },
    "samueldahl": {
        "displayName": "Samuel Dahl",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Sweden",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2003-03-04"
    },
    "rafaobrador": {
        "displayName": "Rafa Obrador",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-02-24"
    },
    "joshuawynder": {
        "displayName": "Joshua Wynder",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "United States",
        "position": "Defender",
        "number": 66,
        "dateofbirth": "2005-05-02"
    },
    "richardrios": {
        "displayName": "Richard Ríos",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Colombia",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2000-06-02"
    },
    "sudakov": {
        "displayName": "Heorhiy Sudakov",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Ukraine",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-09-01"
    },
    "barreiro": {
        "displayName": "Leandro Barreiro",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Luxembourg",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2000-01-03"
    },
    "aursnes": {
        "displayName": "Fredrik Aursnes",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Norway",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-12-10"
    },
    "barrenechea": {
        "displayName": "Enzo Barrenechea",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2001-05-22"
    },
    "manusilva": {
        "displayName": "Manu Silva",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2001-06-12"
    },
    "pavlidis": {
        "displayName": "Vangelis Pavlidis",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Greece",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1998-11-21"
    },
    "lukebakio": {
        "displayName": "Dodi Lukébakio",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-09-24"
    },
    "franjoivanovic": {
        "displayName": "Franjo Ivanović",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Croatia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-10-01"
    },
    "schjelderup": {
        "displayName": "Andreas Schjelderup",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Norway",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2004-06-01"
    },
    "prestianni": {
        "displayName": "Gianluca Prestianni",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Argentina",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2006-01-31"
    },
    "bruma": {
        "displayName": "Bruma",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "1994-10-24"
    },
    "henriquearaujo": {
        "displayName": "Henrique Araújo",
        "club": "SL Benfica",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "2002-01-19"
    },
    "hornicek": {
        "displayName": "Lukáš Horníček",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-07-13"
    },
    "bellaarouch": {
        "displayName": "Alaa Bellaarouch",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Morocco",
        "position": "Goalkeeper",
        "number": 36,
        "dateofbirth": "2002-01-01"
    },
    "tiagosa": {
        "displayName": "Tiago Sá",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1995-01-11"
    },
    "joaocarvalho": {
        "displayName": "João Carvalho",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Goalkeeper",
        "number": 78,
        "dateofbirth": "2004-04-09"
    },
    "victorgomez": {
        "displayName": "Víctor Gómez",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2000-04-01"
    },
    "niakate": {
        "displayName": "Sikou Niakaté",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Mali",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-07-10"
    },
    "arreymbi": {
        "displayName": "Bright Arrey-Mbi",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Germany",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2003-03-26"
    },
    "lagerbielke": {
        "displayName": "Gustaf Lagerbielke",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Sweden",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2000-04-10"
    },
    "leonardolelo": {
        "displayName": "Leonardo Lelo",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-03-30"
    },
    "paulo_oliveira": {
        "displayName": "Paulo Oliveira",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1992-01-08"
    },
    "jonatasnoro": {
        "displayName": "Jonatás Noro",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Defender",
        "number": 53,
        "dateofbirth": "2005-07-01"
    },
    "zalazar": {
        "displayName": "Rodrigo Zalazar",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1999-08-12"
    },
    "moscardo": {
        "displayName": "Gabriel Moscardo",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-09-28"
    },
    "moutinho": {
        "displayName": "João Moutinho",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1986-09-08"
    },
    "dorgeles": {
        "displayName": "Mario Dorgeles",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2004-08-07"
    },
    "vitor_carvalho": {
        "displayName": "Vítor Carvalho",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1997-05-27"
    },
    "grillitsch": {
        "displayName": "Florian Grillitsch",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1995-08-07"
    },
    "gorby": {
        "displayName": "Gorby",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "France",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "2002-07-25"
    },
    "diegorodrigues": {
        "displayName": "Diego Rodrigues",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 50,
        "dateofbirth": "2005-08-20"
    },
    "ricardohorta": {
        "displayName": "Ricardo Horta",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Portugal",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1994-09-15"
    },
    "pau_victor": {
        "displayName": "Pau Víctor",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2001-11-26"
    },
    "elouazzani": {
        "displayName": "Amine El Ouazzani",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Morocco",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-07-15"
    },
    "gabrimartinez": {
        "displayName": "Gabri Martínez",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2003-02-22"
    },
    "frannavarro": {
        "displayName": "Fran Navarro",
        "club": "SC Braga",
        "league": "Primeira Liga",
        "country": "Spain",
        "position": "Forward",
        "number": 39,
        "dateofbirth": "1998-02-03"
    },
    "chevalier": {
        "displayName": "Lucas Chevalier",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "2001-11-06"
    },
    "safonov": {
        "displayName": "Matvey Safonov",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Russia",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "1999-02-25"
    },
    "marin": {
        "displayName": "Renato Marin",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 89,
        "dateofbirth": "2006-07-10"
    },
    "marquinhos": {
        "displayName": "Marquinhos",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1994-05-14"
    },
    "hakimi": {
        "displayName": "Achraf Hakimi",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-11-04"
    },
    "zabarnyi": {
        "displayName": "Illia Zabarnyi",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Ukraine",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-09-01"
    },
    "nunomendes": {
        "displayName": "Nuno Mendes",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2002-06-19"
    },
    "pacho": {
        "displayName": "Willian Pacho",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Ecuador",
        "position": "Defender",
        "number": 51,
        "dateofbirth": "2001-10-16"
    },
    "lucashernandez": {
        "displayName": "Lucas Hernández",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1996-02-14"
    },
    "beraldo": {
        "displayName": "Lucas Beraldo",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-11-24"
    },
    "vitinha": {
        "displayName": "Vitinha",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2000-02-13"
    },
    "joaoneves": {
        "displayName": "João Neves",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 87,
        "dateofbirth": "2004-09-27"
    },
    "zaireemery": {
        "displayName": "Warren Zaïre-Emery",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2006-03-08"
    },
    "fabianruiz": {
        "displayName": "Fabián Ruiz",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1996-04-03"
    },
    "kanginlee": {
        "displayName": "Lee Kang-in",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "South Korea",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2001-02-19"
    },
    "mayulu": {
        "displayName": "Senny Mayulu",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2006-05-17"
    },
    "kvaratskhelia": {
        "displayName": "Khvicha Kvaratskhelia",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Georgia",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-02-12"
    },
    "dembele": {
        "displayName": "Ousmane Dembélé",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-05-15"
    },
    "barcola": {
        "displayName": "Bradley Barcola",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2002-09-02"
    },
    "goncaloramos": {
        "displayName": "Gonçalo Ramos",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-06-20"
    },
    "desiredoue": {
        "displayName": "Désiré Doué",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2005-06-03"
    },
    "ibrahimmbaye": {
        "displayName": "Ibrahim Mbaye",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 49,
        "dateofbirth": "2008-01-24"
    },
    "ndjantou": {
        "displayName": "Quentin Ndjantou",
        "club": "Paris Saint-Germain",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 47,
        "dateofbirth": "2007-07-23"
    },
    "rulli": {
        "displayName": "Gerónimo Rulli",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-05-20"
    },
    "delange": {
        "displayName": "Jeffrey de Lange",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1998-04-01"
    },
    "rubenblanco": {
        "displayName": "Rubén Blanco",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 36,
        "dateofbirth": "1995-07-25"
    },
    "balerdi": {
        "displayName": "Leonardo Balerdi",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Argentina",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-01-26"
    },
    "pavard": {
        "displayName": "Benjamin Pavard",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "1996-03-28"
    },
    "aguerd": {
        "displayName": "Nayef Aguerd",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1996-03-30"
    },
    "facundomedina": {
        "displayName": "Facundo Medina",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Argentina",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "1999-05-28"
    },
    "eganriley": {
        "displayName": "CJ Egan-Riley",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-01-02"
    },
    "emerson": {
        "displayName": "Emerson Palmieri",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Italy",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1994-08-03"
    },
    "murillo": {
        "displayName": "Amir Murillo",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Panama",
        "position": "Defender",
        "number": 62,
        "dateofbirth": "1996-02-11"
    },
    "hojbjerg": {
        "displayName": "Pierre-Emile Højbjerg",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1995-08-05"
    },
    "angelgomes": {
        "displayName": "Angel Gomes",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "England",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-08-31"
    },
    "vermeeren": {
        "displayName": "Arthur Vermeeren",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2005-02-07"
    },
    "oriley": {
        "displayName": "Matt O'Riley",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2000-11-21"
    },
    "kondogbia": {
        "displayName": "Geoffrey Kondogbia",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Central African Republic",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1993-02-15"
    },
    "greenwood": {
        "displayName": "Mason Greenwood",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "England",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-10-01"
    },
    "paixao": {
        "displayName": "Igor Paixão",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2000-06-28"
    },
    "gouiri": {
        "displayName": "Amine Gouiri",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-02-16"
    },
    "aubameyang": {
        "displayName": "Pierre-Emerick Aubameyang",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "Gabon",
        "position": "Forward",
        "number": 97,
        "dateofbirth": "1989-06-18"
    },
    "maupay": {
        "displayName": "Neal Maupay",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1996-08-14"
    },
    "weah": {
        "displayName": "Timothy Weah",
        "club": "Marseille",
        "league": "Ligue 1",
        "country": "United States",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2000-02-22"
    },
    "risser": {
        "displayName": "Robin Risser",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2004-12-02"
    },
    "gurtner": {
        "displayName": "Régis Gurtner",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1986-12-08"
    },
    "jourdren": {
        "displayName": "Ilan Jourdren",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2008-01-08"
    },
    "sambaidoo": {
        "displayName": "Samson Baidoo",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Austria",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2004-03-31"
    },
    "malangsarr": {
        "displayName": "Malang Sarr",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1999-01-23"
    },
    "gradit": {
        "displayName": "Jonathan Gradit",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1992-11-24"
    },
    "udol": {
        "displayName": "Matthieu Udol",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1996-03-20"
    },
    "aguilar": {
        "displayName": "Ruben Aguilar",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1993-04-26"
    },
    "saud": {
        "displayName": "Saud Abdulhamid",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-07-18"
    },
    "chavez": {
        "displayName": "Jhoanner Chávez",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Ecuador",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2002-04-25"
    },
    "ganiou": {
        "displayName": "Ismaëlo Ganiou",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Burkina Faso",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2005-06-03"
    },
    "nidalcelik": {
        "displayName": "Nidal Čelik",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2006-07-17"
    },
    "antonio": {
        "displayName": "Kyllian Antonio",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2008-01-14"
    },
    "sangare": {
        "displayName": "Mamadou Sangaré",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Mali",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-02-26"
    },
    "thomasson": {
        "displayName": "Adrien Thomasson",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1993-12-10"
    },
    "ojediran": {
        "displayName": "Hamzat Ojediran",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2003-11-14"
    },
    "fodesylla": {
        "displayName": "Fodé Sylla",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2006-04-16"
    },
    "bulatovic": {
        "displayName": "Andrija Bulatović",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Montenegro",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2006-12-27"
    },
    "diallo": {
        "displayName": "Alpha Diallo",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 31,
        "dateofbirth": "2006-02-26"
    },
    "edouard": {
        "displayName": "Odsonne Édouard",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-01-16"
    },
    "thauvin": {
        "displayName": "Florian Thauvin",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1993-01-26"
    },
    "said": {
        "displayName": "Wesley Saïd",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1995-04-19"
    },
    "sotoca": {
        "displayName": "Florian Sotoca",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1990-10-25"
    },
    "sima": {
        "displayName": "Abdallah Sima",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2001-06-17"
    },
    "guilavogui": {
        "displayName": "Morgan Guilavogui",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "Guinea",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1998-03-10"
    },
    "bermont": {
        "displayName": "Anthony Bermont",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "2005-02-10"
    },
    "rayanfofana": {
        "displayName": "Rayan Fofana",
        "club": "RC Lens",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 38,
        "dateofbirth": "2006-11-21"
    },
    "berke_ozer": {
        "displayName": "Berke Özer",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-05-25"
    },
    "bodart": {
        "displayName": "Arnaud Bodart",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1998-03-11"
    },
    "caillard": {
        "displayName": "Marc-Aurèle Caillard",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "1994-05-12"
    },
    "alexsandro": {
        "displayName": "Alexsandro",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-08-09"
    },
    "ngoy": {
        "displayName": "Nathan Ngoy",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-06-10"
    },
    "mbemba": {
        "displayName": "Chancel Mbemba",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "DR Congo",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1994-08-08"
    },
    "mandi": {
        "displayName": "Aïssa Mandi",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1991-10-22"
    },
    "perraud": {
        "displayName": "Romain Perraud",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1997-09-22"
    },
    "verdonk": {
        "displayName": "Calvin Verdonk",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Indonesia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1997-04-26"
    },
    "tiago_santos": {
        "displayName": "Tiago Santos",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2002-07-23"
    },
    "meunier": {
        "displayName": "Thomas Meunier",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1991-09-12"
    },
    "andre": {
        "displayName": "Benjamin André",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1990-08-03"
    },
    "bentaleb": {
        "displayName": "Nabil Bentaleb",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1994-11-24"
    },
    "mukau": {
        "displayName": "Ngal'ayel Mukau",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "DR Congo",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2004-11-03"
    },
    "bouaddi": {
        "displayName": "Ayyoub Bouaddi",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2007-10-02"
    },
    "ethan_mbappe": {
        "displayName": "Ethan Mbappé",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-12-29"
    },
    "haraldsson": {
        "displayName": "Hákon Arnar Haraldsson",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Iceland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-04-10"
    },
    "andre_gomes": {
        "displayName": "André Gomes",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "1993-07-30"
    },
    "fernandez_pardo": {
        "displayName": "Matías Fernández-Pardo",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2005-02-03"
    },
    "sahraoui": {
        "displayName": "Osame Sahraoui",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-06-11"
    },
    "felix_correia": {
        "displayName": "Félix Correia",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2001-01-22"
    },
    "broholm": {
        "displayName": "Marius Broholm",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Norway",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2004-12-26"
    },
    "igamane": {
        "displayName": "Hamza Igamane",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "Morocco",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2002-11-02"
    },
    "giroud": {
        "displayName": "Olivier Giroud",
        "club": "Lille",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1986-09-30"
    },
    "hradecky": {
        "displayName": "Lukas Hradecky",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Finland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1989-11-24"
    },
    "kohn": {
        "displayName": "Philipp Köhn",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1998-04-02"
    },
    "lienard": {
        "displayName": "Yann Lienard",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2003-03-16"
    },
    "vanderson": {
        "displayName": "Vanderson",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-06-21"
    },
    "ericdier": {
        "displayName": "Eric Dier",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1994-01-15"
    },
    "kehrer": {
        "displayName": "Thilo Kehrer",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Germany",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1996-09-21"
    },
    "teze": {
        "displayName": "Jordan Teze",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-09-30"
    },
    "salisu": {
        "displayName": "Mohammed Salisu",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Ghana",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1999-04-17"
    },
    "caiohenrique": {
        "displayName": "Caio Henrique",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1997-07-31"
    },
    "mawissa": {
        "displayName": "Christian Mawissa",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2005-04-18"
    },
    "ouattara": {
        "displayName": "Kassoum Ouattara",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2004-10-14"
    },
    "zakaria": {
        "displayName": "Denis Zakaria",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-11-20"
    },
    "pogba": {
        "displayName": "Paul Pogba",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1993-03-15"
    },
    "golovin": {
        "displayName": "Aleksandr Golovin",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Russia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-05-30"
    },
    "akliouche": {
        "displayName": "Maghnes Akliouche",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2002-02-25"
    },
    "laminecamara": {
        "displayName": "Lamine Camara",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2004-01-01"
    },
    "idumbo": {
        "displayName": "Stanis Idumbo",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-06-29"
    },
    "coulibaly": {
        "displayName": "Mamadou Coulibaly",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2004-04-21"
    },
    "balogun": {
        "displayName": "Folarin Balogun",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "United States",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-07-03"
    },
    "biereth": {
        "displayName": "Mika Biereth",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Denmark",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-02-08"
    },
    "minamino": {
        "displayName": "Takumi Minamino",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Japan",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1995-01-16"
    },
    "ansufati": {
        "displayName": "Ansu Fati",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Spain",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2002-10-31"
    },
    "ilenikhena": {
        "displayName": "George Ilenikhena",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "2006-08-16"
    },
    "brunner": {
        "displayName": "Paris Brunner",
        "club": "AS Monaco",
        "league": "Ligue 1",
        "country": "Germany",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2006-02-15"
    },
    "greif": {
        "displayName": "Dominik Greif",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-04-06"
    },
    "descamps": {
        "displayName": "Rémy Descamps",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1996-06-25"
    },
    "diarra": {
        "displayName": "Lassine Diarra",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Mali",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2002-11-11"
    },
    "niakhate": {
        "displayName": "Moussa Niakhaté",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Senegal",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1996-03-08"
    },
    "clintonmata": {
        "displayName": "Clinton Mata",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Angola",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1992-11-07"
    },
    "rubenkluivert": {
        "displayName": "Ruben Kluivert",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Netherlands",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2001-05-21"
    },
    "abner": {
        "displayName": "Abner Vinícius",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2000-05-27"
    },
    "tagliafico": {
        "displayName": "Nicolás Tagliafico",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Argentina",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1992-08-31"
    },
    "maitlandniles": {
        "displayName": "Ainsley Maitland-Niles",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "England",
        "position": "Defender",
        "number": 98,
        "dateofbirth": "1997-08-29"
    },
    "hateboer": {
        "displayName": "Hans Hateboer",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Netherlands",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1994-01-09"
    },
    "tylermorton": {
        "displayName": "Tyler Morton",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "England",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2002-10-31"
    },
    "tessmann": {
        "displayName": "Tanner Tessmann",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "United States",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-09-24"
    },
    "mangala": {
        "displayName": "Orel Mangala",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1998-03-18"
    },
    "tolisso": {
        "displayName": "Corentin Tolisso",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-08-03"
    },
    "pavelsulc": {
        "displayName": "Pavel Šulc",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-12-29"
    },
    "karabec": {
        "displayName": "Adam Karabec",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2003-07-02"
    },
    "malickfofana": {
        "displayName": "Malick Fofana",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2005-03-31"
    },
    "nuamah": {
        "displayName": "Ernest Nuamah",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Ghana",
        "position": "Forward",
        "number": 37,
        "dateofbirth": "2003-11-01"
    },
    "endrick": {
        "displayName": "Endrick",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2006-07-21"
    },
    "satriano": {
        "displayName": "Martín Satriano",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Uruguay",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2001-02-20"
    },
    "moreira": {
        "displayName": "Afonso Moreira",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Portugal",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2005-03-19"
    },
    "ghezzal": {
        "displayName": "Rachid Ghezzal",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "Algeria",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1992-05-09"
    },
    "molebe": {
        "displayName": "Enzo Molebe",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "France",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2007-09-18"
    },
    "gomesrodriguez": {
        "displayName": "Alejandro Gomes Rodríguez",
        "club": "Olympique Lyon",
        "league": "Ligue 1",
        "country": "England",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "2008-03-11"
    },
    "bounou": {
        "displayName": "Yassine Bounou",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Morocco",
        "position": "Goalkeeper",
        "number": 37,
        "dateofbirth": "1991-04-05"
    },
    "alyami_mohammed": {
        "displayName": "Mohammed Al-Yami",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 17,
        "dateofbirth": "1997-08-14"
    },
    "patouillet": {
        "displayName": "Mathieu Patouillet",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2004-02-20"
    },
    "koulibaly": {
        "displayName": "Kalidou Koulibaly",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Senegal",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1991-06-20"
    },
    "theohernandez": {
        "displayName": "Théo Hernandez",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1997-10-06"
    },
    "tambakti": {
        "displayName": "Hassan Al-Tambakti",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 87,
        "dateofbirth": "1999-02-09"
    },
    "albulayhi": {
        "displayName": "Ali Al-Bulayhi",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1989-11-21"
    },
    "akcicek": {
        "displayName": "Yusuf Akçiçek",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Turkey",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2006-01-25"
    },
    "alharbi": {
        "displayName": "Moteb Al-Harbi",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2000-02-19"
    },
    "lajami": {
        "displayName": "Ali Lajami",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 78,
        "dateofbirth": "1996-04-24"
    },
    "rubenneves": {
        "displayName": "Rúben Neves",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-03-13"
    },
    "milinkovicsavic": {
        "displayName": "Sergej Milinković-Savić",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1995-02-27"
    },
    "aldawsari_salem": {
        "displayName": "Salem Al-Dawsari",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "1991-08-19"
    },
    "kanno": {
        "displayName": "Mohamed Kanno",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "1994-09-22"
    },
    "aldawsari_nasser": {
        "displayName": "Nasser Al-Dawsari",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1998-12-19"
    },
    "malcom": {
        "displayName": "Malcom",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-02-26"
    },
    "darwinnunez": {
        "displayName": "Darwin Núñez",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Uruguay",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-06-24"
    },
    "marcosleonardo": {
        "displayName": "Marcos Leonardo",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-05-02"
    },
    "kaiocesar": {
        "displayName": "Kaio César",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-02-15"
    },
    "alhamdan": {
        "displayName": "Abdullah Al-Hamdan",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1999-09-13"
    },
    "radif": {
        "displayName": "Abdullah Radif",
        "club": "Al-Hilal",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2003-01-20"
    },
    "bento": {
        "displayName": "Bento",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "1999-06-10"
    },
    "alaqidi": {
        "displayName": "Nawaf Al-Aqidi",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2000-05-10"
    },
    "najjar": {
        "displayName": "Raghed Al-Najjar",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 36,
        "dateofbirth": "1996-09-20"
    },
    "simakan": {
        "displayName": "Mohamed Simakan",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-05-03"
    },
    "martinez": {
        "displayName": "Iñigo Martínez",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Spain",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1991-05-17"
    },
    "alghannam": {
        "displayName": "Sultan Al-Ghannam",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1994-05-06"
    },
    "alamri": {
        "displayName": "Abdulelah Al-Amri",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-01-15"
    },
    "alsharari": {
        "displayName": "Nader Al-Sharari",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-05-08"
    },
    "alnajdi": {
        "displayName": "Salem Al-Najdi",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 83,
        "dateofbirth": "2003-01-27"
    },
    "brozovic": {
        "displayName": "Marcelo Brozović",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1992-11-16"
    },
    "alkhaibari": {
        "displayName": "Abdullah Al-Khaibari",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1996-08-16"
    },
    "aljaber": {
        "displayName": "Abdulmalik Al-Jaber",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2004-01-07"
    },
    "alhajai": {
        "displayName": "Sami Al-Najei",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1997-02-07"
    },
    "alhasan": {
        "displayName": "Ali Al-Hassan",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1997-03-04"
    },
    "ronaldo": {
        "displayName": "Cristiano Ronaldo",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1985-02-05"
    },
    "joaofelix": {
        "displayName": "João Félix",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 79,
        "dateofbirth": "1999-11-10"
    },
    "mane": {
        "displayName": "Sadio Mané",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Senegal",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1992-04-10"
    },
    "coman": {
        "displayName": "Kingsley Coman",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1996-06-13"
    },
    "angelo": {
        "displayName": "Ângelo",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2004-12-21"
    },
    "wesleyteixeira": {
        "displayName": "Wesley Teixeira",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 80,
        "dateofbirth": "2005-03-05"
    },
    "ghareeb": {
        "displayName": "Abdulrahman Ghareeb",
        "club": "Al-Nassr",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1997-03-31"
    },
    "rajkovic": {
        "displayName": "Predrag Rajković",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-10-31"
    },
    "alshanqiti_h": {
        "displayName": "Hamed Al-Shanqiti",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 47,
        "dateofbirth": "2005-04-26"
    },
    "alabsi": {
        "displayName": "Mohammed Al-Absi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2002-09-24"
    },
    "danilopereira": {
        "displayName": "Danilo Pereira",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1991-09-09"
    },
    "simic": {
        "displayName": "Jan-Carlo Simić",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Serbia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2005-05-02"
    },
    "almousa": {
        "displayName": "Saad Al-Mousa",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-12-10"
    },
    "mitaj": {
        "displayName": "Mario Mitaj",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Albania",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2003-08-06"
    },
    "shanqeeti_m": {
        "displayName": "Muhannad Al-Shanqeeti",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1999-03-12"
    },
    "kadesh": {
        "displayName": "Hassan Kadesh",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1992-09-06"
    },
    "sharahili": {
        "displayName": "Ahmed Sharahili",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1994-05-08"
    },
    "fagihy": {
        "displayName": "Muath Fagihy",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "2002-05-30"
    },
    "kante": {
        "displayName": "N'Golo Kanté",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1991-03-29"
    },
    "fabinho": {
        "displayName": "Fabinho",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1993-10-23"
    },
    "aouar": {
        "displayName": "Houssem Aouar",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-06-30"
    },
    "alnashri": {
        "displayName": "Awad Al-Nashri",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2002-03-15"
    },
    "doumbia": {
        "displayName": "Mahamadou Doumbia",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Mali",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2004-05-15"
    },
    "alghamdi_f": {
        "displayName": "Faisal Al-Ghamdi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2001-08-13"
    },
    "alghamdi_h": {
        "displayName": "Hamed Al-Ghamdi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "1999-04-02"
    },
    "benzema": {
        "displayName": "Karim Benzema",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1887-12-19"
    },
    "moussadiaby": {
        "displayName": "Moussa Diaby",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1999-07-07"
    },
    "bergwijn": {
        "displayName": "Steven Bergwijn",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 34,
        "dateofbirth": "1997-10-08"
    },
    "alghamdi_a": {
        "displayName": "Ahmed Al-Ghamdi",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2001-09-20"
    },
    "rogerfernandes": {
        "displayName": "Roger Fernandes",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 78,
        "dateofbirth": "2005-11-21"
    },
    "alshehri": {
        "displayName": "Saleh Al-Shehri",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1993-11-01"
    },
    "casteels": {
        "displayName": "Koen Casteels",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-06-25"
    },
    "alkassar": {
        "displayName": "Ahmed Al-Kassar",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1991-05-08"
    },
    "sanyor": {
        "displayName": "Meshari Sanyor",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 50,
        "dateofbirth": "2001-10-10"
    },
    "nacho": {
        "displayName": "Nacho",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Spain",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1990-01-18"
    },
    "gastonalvarez": {
        "displayName": "Gastón Álvarez",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Uruguay",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2000-03-24"
    },
    "alshahrani": {
        "displayName": "Yasser Al-Shahrani",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1992-05-25"
    },
    "qasem": {
        "displayName": "Mohammed Qasem",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1995-01-19"
    },
    "qassemlajami": {
        "displayName": "Qassem Lajami",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 87,
        "dateofbirth": "1996-04-24"
    },
    "aboulshamat": {
        "displayName": "Mohammed Aboulshamat",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-08-11"
    },
    "weigl": {
        "displayName": "Julian Weigl",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Germany",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1995-09-08"
    },
    "nandez": {
        "displayName": "Nahitan Nández",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-12-28"
    },
    "otavio": {
        "displayName": "Otávio",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "1995-02-09"
    },
    "aljuwayr": {
        "displayName": "Musab Al-Juwayr",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-06-20"
    },
    "hazazi": {
        "displayName": "Ali Hazazi",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1994-02-18"
    },
    "alqahtani": {
        "displayName": "Hussain Al-Qahtani",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "1994-01-19"
    },
    "alammar": {
        "displayName": "Turki Al-Ammar",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1999-09-23"
    },
    "retegui": {
        "displayName": "Mateo Retegui",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Italy",
        "position": "Forward",
        "number": 32,
        "dateofbirth": "1999-04-29"
    },
    "quinones": {
        "displayName": "Julián Quiñones",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Mexico",
        "position": "Forward",
        "number": 33,
        "dateofbirth": "1997-03-24"
    },
    "bonsubaah": {
        "displayName": "Christopher Bonsu Baah",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Ghana",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2004-12-14"
    },
    "alsalem": {
        "displayName": "Abdullah Al-Salem",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1992-12-19"
    },
    "althani": {
        "displayName": "Mohammed Al-Thani",
        "club": "Al Qadsiah",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 71,
        "dateofbirth": "1997-07-24"
    },
    "edouardmendy": {
        "displayName": "Édouard Mendy",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Senegal",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "1992-03-01"
    },
    "alsanbi": {
        "displayName": "Abdulrahman Al-Sanbi",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-02-03"
    },
    "ibanez": {
        "displayName": "Roger Ibañez",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1998-11-23"
    },
    "demiral": {
        "displayName": "Merih Demiral",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Turkey",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "1998-03-05"
    },
    "majrashi": {
        "displayName": "Ali Majrashi",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1999-10-01"
    },
    "dams": {
        "displayName": "Matteo Dams",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2004-03-09"
    },
    "sulaiman": {
        "displayName": "Mohammed Sulaiman",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2004-05-14"
    },
    "franckkessie": {
        "displayName": "Franck Kessié",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 79,
        "dateofbirth": "1996-12-19"
    },
    "enzomillot": {
        "displayName": "Enzo Millot",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-07-17"
    },
    "atangana": {
        "displayName": "Valentin Atangana",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2005-08-25"
    },
    "aljohani": {
        "displayName": "Ziyad Al-Johani",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2001-11-11"
    },
    "mahrez": {
        "displayName": "Riyad Mahrez",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Algeria",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1991-02-21"
    },
    "ivantoney": {
        "displayName": "Ivan Toney",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "England",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1996-03-16"
    },
    "galeno": {
        "displayName": "Wenderson Galeno",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1997-10-22"
    },
    "alburaikan": {
        "displayName": "Firas Al-Buraikan",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-05-14"
    },
    "matheusgoncalves": {
        "displayName": "Matheus Gonçalves",
        "club": "Al-Ahli Saudi FC",
        "league": "Saudi Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2005-08-18"
    },
    "gkederson": {
        "displayName": "Ederson",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1993-08-17"
    },
    "egribayat": {
        "displayName": "İrfan Can Eğribayat",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1998-06-30"
    },
    "tarikcetin": {
        "displayName": "Tarık Çetin",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1997-01-08"
    },
    "skriniar": {
        "displayName": "Milan Škriniar",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Slovakia",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "1995-02-11"
    },
    "soyuncu": {
        "displayName": "Çağlar Söyüncü",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-05-23"
    },
    "archiebrown": {
        "displayName": "Archie Brown",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-05-28"
    },
    "oosterwolde": {
        "displayName": "Jayden Oosterwolde",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Netherlands",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2001-04-26"
    },
    "semedo": {
        "displayName": "Nélson Semedo",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1993-11-16"
    },
    "muldur": {
        "displayName": "Mert Müldür",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1999-04-03"
    },
    "becao": {
        "displayName": "Rodrigo Becão",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Defender",
        "number": 50,
        "dateofbirth": "1996-01-19"
    },
    "edsonalvarez": {
        "displayName": "Edson Álvarez",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Mexico",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1997-10-24"
    },
    "fred": {
        "displayName": "Fred",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1993-03-05"
    },
    "talisca": {
        "displayName": "Anderson Talisca",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 94,
        "dateofbirth": "1994-02-01"
    },
    "sebaszymanski": {
        "displayName": "Sebastian Szymański",
        "club": "Stade Rennais",
        "league": "Ligue 1",
        "country": "Poland",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1999-05-10"
    },
    "asensio": {
        "displayName": "Marco Asensio",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Spain",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1996-01-21"
    },
    "yuksek": {
        "displayName": "İsmail Yüksek",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1999-01-26"
    },
    "kahveci": {
        "displayName": "İrfan Can Kahveci",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1995-07-15"
    },
    "yandas": {
        "displayName": "Mert Hakan Yandaş",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-08-19"
    },
    "akturkoglu": {
        "displayName": "Kerem Aktürkoğlu",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-10-21"
    },
    "jhonduran": {
        "displayName": "Jhon Durán",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Colombia",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2003-12-13"
    },
    "ennesyri": {
        "displayName": "Youssef En-Nesyri",
        "club": "Al-Ittihad",
        "league": "Saudi Pro League",
        "country": "Morocco",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1997-06-01"
    },
    "nene": {
        "displayName": "Dorgeles Nene",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Mali",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "2002-12-23"
    },
    "oguzaydin": {
        "displayName": "Oğuz Aydın",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "2000-10-27"
    },
    "cenktosun": {
        "displayName": "Cenk Tosun",
        "club": "Fenerbahçe",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1991-06-07"
    },
    "cakir": {
        "displayName": "Uğurcan Çakır",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1996-04-05"
    },
    "guvenc": {
        "displayName": "Günay Güvenç",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 19,
        "dateofbirth": "1991-06-25"
    },
    "batuhansen": {
        "displayName": "Batuhan Şen",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1999-02-03"
    },
    "davinsonsanchez": {
        "displayName": "Davinson Sánchez",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Colombia",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1996-06-12"
    },
    "singo": {
        "displayName": "Wilfried Singo",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Ivory Coast",
        "position": "Defender",
        "number": 90,
        "dateofbirth": "2000-12-25"
    },
    "bardakci": {
        "displayName": "Abdülkerim Bardakcı",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 42,
        "dateofbirth": "1994-09-07"
    },
    "kaanayhan": {
        "displayName": "Kaan Ayhan",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1994-11-10"
    },
    "erenelmali": {
        "displayName": "Eren Elmalı",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2000-07-07"
    },
    "jakobs": {
        "displayName": "Ismail Jakobs",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Senegal",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-08-17"
    },
    "karatas": {
        "displayName": "Kazımcan Karataş",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 88,
        "dateofbirth": "2003-01-16"
    },
    "unyay": {
        "displayName": "Arda Ünyay",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "2007-01-18"
    },
    "gundogan": {
        "displayName": "İlkay Gündoğan",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1990-10-24"
    },
    "torreira": {
        "displayName": "Lucas Torreira",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 34,
        "dateofbirth": "1996-02-11"
    },
    "gabrielsara": {
        "displayName": "Gabriel Sara",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-06-26"
    },
    "lemina": {
        "displayName": "Mario Lemina",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Gabon",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "1993-09-01"
    },
    "berkankutlu": {
        "displayName": "Berkan Kutlu",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1998-01-25"
    },
    "osimhen": {
        "displayName": "Victor Osimhen",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "1998-12-29"
    },
    "icardi": {
        "displayName": "Mauro Icardi",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Argentina",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-02-19"
    },
    "sane": {
        "displayName": "Leroy Sané",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1996-01-11"
    },
    "barisalper": {
        "displayName": "Barış Alper Yılmaz",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 53,
        "dateofbirth": "2000-05-23"
    },
    "yunusakgun": {
        "displayName": "Yunus Akgün",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-07-07"
    },
    "sallai": {
        "displayName": "Roland Sallai",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Hungary",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1997-05-22"
    },
    "kutucu": {
        "displayName": "Ahmed Kutucu",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2000-03-01"
    },
    "yusufdemir": {
        "displayName": "Yusuf Demir",
        "club": "Galatasaray",
        "league": "Süper Lig",
        "country": "Austria",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2003-06-02"
    },
    "onana": {
        "displayName": "André Onana",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Cameroon",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "1996-04-02"
    },
    "cevikkan": {
        "displayName": "Onuralp Çevikkan",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2006-01-02"
    },
    "ahmet_yildirim": {
        "displayName": "Ahmet Yıldırım",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 88,
        "dateofbirth": "2006-05-14"
    },
    "erols_colak": {
        "displayName": "Erol Can Çolak",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 96,
        "dateofbirth": "2006-04-10"
    },
    "savic": {
        "displayName": "Stefan Savić",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Montenegro",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1991-01-08"
    },
    "batagov": {
        "displayName": "Arseniy Batagov",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Ukraine",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2002-03-05"
    },
    "pina": {
        "displayName": "Wagner Pina",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Cape Verde",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2002-11-03"
    },
    "serdar_saatci": {
        "displayName": "Serdar Saatçı",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2003-02-14"
    },
    "baniya": {
        "displayName": "Rayyan Baniya",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-02-18"
    },
    "eskihellac": {
        "displayName": "Mustafa Eskihellaç",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1997-05-05"
    },
    "bosluk": {
        "displayName": "Arif Boşluk",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "2003-06-06"
    },
    "yokuslu": {
        "displayName": "Okay Yokuşlu",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "1994-03-09"
    },
    "muci": {
        "displayName": "Ernest Muçi",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Albania",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2001-03-19"
    },
    "oulai": {
        "displayName": "Christ Inao Oulaï",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2006-06-22"
    },
    "bouchouari": {
        "displayName": "Benjamin Bouchouari",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2001-11-13"
    },
    "ozantufan": {
        "displayName": "Ozan Tufan",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1995-03-23"
    },
    "jabol_folcarelli": {
        "displayName": "Tim Jabol-Folcarelli",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "France",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "1999-12-06"
    },
    "visca": {
        "displayName": "Edin Višća",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1990-02-17"
    },
    "onuachu": {
        "displayName": "Paul Onuachu",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "1994-05-28"
    },
    "zubkov": {
        "displayName": "Oleksandr Zubkov",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Ukraine",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1996-08-03"
    },
    "sikan": {
        "displayName": "Danylo Sikan",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Ukraine",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2001-04-16"
    },
    "felipe_augusto": {
        "displayName": "Felipe Augusto",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "2004-02-18"
    },
    "olaigbe": {
        "displayName": "Kazeem Olaigbe",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Belgium",
        "position": "Forward",
        "number": 70,
        "dateofbirth": "2003-01-02"
    },
    "canak": {
        "displayName": "Cihan Çanak",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 61,
        "dateofbirth": "2005-01-24"
    },
    "nwakaeme": {
        "displayName": "Anthony Nwakaeme",
        "club": "Trabzonspor",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1989-03-21"
    },
    "mertgunok": {
        "displayName": "Mert Günok",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1989-03-01"
    },
    "ersindestanoglu": {
        "displayName": "Ersin Destanoğlu",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "2001-01-01"
    },
    "emrebilgin": {
        "displayName": "Emre Bilgin",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "2004-02-26"
    },
    "emiryasar": {
        "displayName": "Emir Yaşar",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Goalkeeper",
        "number": 96,
        "dateofbirth": "2006-01-16"
    },
    "gabrielpaulista": {
        "displayName": "Gabriel Paulista",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1990-11-26"
    },
    "uduokhai": {
        "displayName": "Felix Uduokhai",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1997-09-09"
    },
    "tiagodjalo": {
        "displayName": "Tiago Djaló",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2000-04-09"
    },
    "emirhantopcu": {
        "displayName": "Emirhan Topçu",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 53,
        "dateofbirth": "2000-10-11"
    },
    "ridvanyilmaz": {
        "displayName": "Rıdvan Yılmaz",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2001-05-21"
    },
    "davidjurasek": {
        "displayName": "David Jurásek",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2000-08-07"
    },
    "taylanbulut": {
        "displayName": "Taylan Bulut",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Germany",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2006-01-19"
    },
    "jonassvensson": {
        "displayName": "Jonas Svensson",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Norway",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1993-03-06"
    },
    "orkunkokcu": {
        "displayName": "Orkun Kökçü",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-12-29"
    },
    "ndidi": {
        "displayName": "Wilfred Ndidi",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1996-12-16"
    },
    "rafasilva": {
        "displayName": "Rafa Silva",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1993-05-17"
    },
    "rashica": {
        "displayName": "Milot Rashica",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Kosovo",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1996-06-28"
    },
    "vaclavcerny": {
        "displayName": "Václav Černý",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-10-17"
    },
    "salihucan": {
        "displayName": "Salih Uçan",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-01-06"
    },
    "necipuysal": {
        "displayName": "Necip Uysal",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1991-01-24"
    },
    "tammyabraham": {
        "displayName": "Tammy Abraham",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "England",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-10-02"
    },
    "iotasilva": {
        "displayName": "Jota Silva",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Portugal",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "1999-08-01"
    },
    "elbilaltoure": {
        "displayName": "El Bilal Touré",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Mali",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2001-10-03"
    },
    "cengizunder": {
        "displayName": "Cengiz Ünder",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-07-15"
    },
    "mustafahekimoglu": {
        "displayName": "Mustafa Hekimoğlu",
        "club": "Beşiktaş",
        "league": "Süper Lig",
        "country": "Turkey",
        "position": "Forward",
        "number": 91,
        "dateofbirth": "2007-04-22"
    },
    "scherpen": {
        "displayName": "Kjell Scherpen",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 37,
        "dateofbirth": "2000-01-23"
    },
    "chambaere": {
        "displayName": "Vic Chambaere",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2003-01-10"
    },
    "teunckens": {
        "displayName": "Jens Teunckens",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 21,
        "dateofbirth": "1998-01-30"
    },
    "kavlashvili": {
        "displayName": "Giorgi Kavlashvili",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Georgia",
        "position": "Goalkeeper",
        "number": 18,
        "dateofbirth": "2007-01-24"
    },
    "kevinmacallister": {
        "displayName": "Kevin Mac Allister",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Argentina",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-11-07"
    },
    "burgess": {
        "displayName": "Christian Burgess",
        "club": "Union SG",
        "league": "Pro League",
        "country": "England",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1991-10-07"
    },
    "sykes": {
        "displayName": "Ross Sykes",
        "club": "Union SG",
        "league": "Pro League",
        "country": "England",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1999-03-26"
    },
    "patris": {
        "displayName": "Louis Patris",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2001-06-07"
    },
    "leysen": {
        "displayName": "Fedde Leysen",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 48,
        "dateofbirth": "2003-07-09"
    },
    "barry": {
        "displayName": "Mamadou Barry",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Senegal",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2005-03-20"
    },
    "francois": {
        "displayName": "Guillaume François",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "1990-06-03"
    },
    "zorgane": {
        "displayName": "Adem Zorgane",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-01-06"
    },
    "aitelhadj": {
        "displayName": "Anouar Ait El Hadj",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-04-20"
    },
    "matrasmussen": {
        "displayName": "Mathias Rasmussen",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Norway",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1997-11-25"
    },
    "schoofs": {
        "displayName": "Rob Schoofs",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1994-03-23"
    },
    "vandeperre": {
        "displayName": "Kamiel Van de Perre",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2004-02-12"
    },
    "niang": {
        "displayName": "Ousseynou Niang",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2001-10-12"
    },
    "boufal": {
        "displayName": "Sofiane Boufal",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1993-09-17"
    },
    "khalaili": {
        "displayName": "Anan Khalaili",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Israel",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2004-09-03"
    },
    "promisedavid": {
        "displayName": "Promise David",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Canada",
        "position": "Forward",
        "number": 12,
        "dateofbirth": "2001-07-03"
    },
    "florucz": {
        "displayName": "Raul Florucz",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Austria",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2001-06-10"
    },
    "kevinrodriguez": {
        "displayName": "Kevin Rodríguez",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "2000-03-04"
    },
    "fuseini": {
        "displayName": "Mohammed Fuseini",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Ghana",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-05-16"
    },
    "giger": {
        "displayName": "Marc Giger",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Switzerland",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2004-03-27"
    },
    "makate": {
        "displayName": "Cristian Makaté",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Equatorial Guinea",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2002-09-21"
    },
    "smith": {
        "displayName": "Guilherme Smith",
        "club": "Union SG",
        "league": "Pro League",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2003-06-11"
    },
    "vancrombrugge": {
        "displayName": "Hendrik Van Crombrugge",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1993-04-30"
    },
    "lawal": {
        "displayName": "Tobias Lawal",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "2000-06-07"
    },
    "brughmans": {
        "displayName": "Lucca Brughmans",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "2008-06-27"
    },
    "stevens": {
        "displayName": "Brent Stevens",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 71,
        "dateofbirth": "2003-08-11"
    },
    "smets": {
        "displayName": "Matte Smets",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2004-01-04"
    },
    "sadick": {
        "displayName": "Mujaid Sadick",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-03-14"
    },
    "elouahdi": {
        "displayName": "Zakaria El Ouahdi",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Morocco",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "2001-12-31"
    },
    "kayembe": {
        "displayName": "Joris Kayembe",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "DR Congo",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1994-08-08"
    },
    "yaimarmedina": {
        "displayName": "Yaimar Medina",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2004-11-05"
    },
    "nkuba": {
        "displayName": "Ken Nkuba",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2002-01-21"
    },
    "kongolo": {
        "displayName": "Josué Kongolo",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2006-04-13"
    },
    "adrianpalacios": {
        "displayName": "Adrián Palacios",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Colombia",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2004-06-07"
    },
    "heynen": {
        "displayName": "Bryan Heynen",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-02-06"
    },
    "hrosovsky": {
        "displayName": "Patrik Hrošovský",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Slovakia",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1992-04-22"
    },
    "karetsas": {
        "displayName": "Konstantinos Karetsas",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Greece",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2007-11-19"
    },
    "heymans": {
        "displayName": "Daan Heymans",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "1999-06-15"
    },
    "sattlberger": {
        "displayName": "Nikolas Sattlberger",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Austria",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2004-01-18"
    },
    "bangoura": {
        "displayName": "Ibrahima Sory Bangoura",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Guinea",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2004-01-05"
    },
    "junyaito": {
        "displayName": "Junya Ito",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Japan",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1993-03-09"
    },
    "steuckers": {
        "displayName": "Jarne Steuckers",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-02-04"
    },
    "oh": {
        "displayName": "Hyeon-gyu Oh",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "South Korea",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2001-04-12"
    },
    "erabi": {
        "displayName": "Jusef Erabi",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Sweden",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "2003-06-08"
    },
    "sor": {
        "displayName": "Yira Sor",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2000-07-24"
    },
    "mirisola": {
        "displayName": "Robin Mirisola",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2006-12-08"
    },
    "yokoyama": {
        "displayName": "Ayumu Yokoyama",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Japan",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2003-03-04"
    },
    "bibout": {
        "displayName": "Aaron Bibout",
        "club": "KRC Genk",
        "league": "Pro League",
        "country": "Cameroon",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2004-09-03"
    },
    "mignolet": {
        "displayName": "Simon Mignolet",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1988-03-06"
    },
    "jackers": {
        "displayName": "Nordin Jackers",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 29,
        "dateofbirth": "1997-09-05"
    },
    "vandenheuvel": {
        "displayName": "Dani van den Heuvel",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "2003-05-28"
    },
    "decorte": {
        "displayName": "Axl De Corte",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 71,
        "dateofbirth": "2006-03-24"
    },
    "mechele": {
        "displayName": "Brandon Mechele",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "1993-01-28"
    },
    "ordonez": {
        "displayName": "Joel Ordóñez",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2004-04-21"
    },
    "seys": {
        "displayName": "Joaquin Seys",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 65,
        "dateofbirth": "2005-03-28"
    },
    "sabbe": {
        "displayName": "Kyriani Sabbe",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 64,
        "dateofbirth": "2005-01-26"
    },
    "spileers": {
        "displayName": "Jorne Spileers",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 58,
        "dateofbirth": "2005-01-21"
    },
    "meijer": {
        "displayName": "Bjorn Meijer",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2003-03-18"
    },
    "zaidromero": {
        "displayName": "Zaid Romero",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Argentina",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-12-15"
    },
    "siquet": {
        "displayName": "Hugo Siquet",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 41,
        "dateofbirth": "2002-07-09"
    },
    "vanaken": {
        "displayName": "Hans Vanaken",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1992-08-24"
    },
    "onyedika": {
        "displayName": "Raphael Onyedika",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2001-04-19"
    },
    "aleksstankovic": {
        "displayName": "Aleksandar Stanković",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "2005-08-03"
    },
    "reis": {
        "displayName": "Ludovit Reis",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2000-06-01"
    },
    "vetlesen": {
        "displayName": "Hugo Vetlesen",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Norway",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-02-29"
    },
    "sandra": {
        "displayName": "Cisse Sandra",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2003-12-16"
    },
    "tzolis": {
        "displayName": "Christos Tzolis",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Greece",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2002-01-30"
    },
    "tresoldi": {
        "displayName": "Nicolò Tresoldi",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Germany",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2004-08-20"
    },
    "forbs": {
        "displayName": "Carlos Forbs",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-03-19"
    },
    "vermant": {
        "displayName": "Romeo Vermant",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2004-01-24"
    },
    "nilsson": {
        "displayName": "Gustaf Nilsson",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "Sweden",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1997-05-23"
    },
    "diakhon": {
        "displayName": "Mamadou Diakhon",
        "club": "Club Brugge",
        "league": "Pro League",
        "country": "France",
        "position": "Forward",
        "number": 67,
        "dateofbirth": "2005-09-22"
    },
    "nozawa": {
        "displayName": "Taishi Brandon Nozawa",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Japan",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2002-12-25"
    },
    "thoelen": {
        "displayName": "Yannick Thoelen",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 15,
        "dateofbirth": "1990-07-18"
    },
    "devalckeneer": {
        "displayName": "Niels Devalckeneer",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 81,
        "dateofbirth": "2004-05-17"
    },
    "vandenbosch": {
        "displayName": "Zeno Van Den Bosch",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "2003-07-06"
    },
    "kouyate": {
        "displayName": "Boubakar Kouyaté",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Mali",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1997-04-15"
    },
    "foulon": {
        "displayName": "Daam Foulon",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-03-23"
    },
    "tsunashima": {
        "displayName": "Yuto Tsunashima",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-08-15"
    },
    "bozhinov": {
        "displayName": "Rosen Bozhinov",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Bulgaria",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2005-01-23"
    },
    "bijl": {
        "displayName": "Glenn Bijl",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1995-07-13"
    },
    "bjornengels": {
        "displayName": "Björn Engels",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1994-09-15"
    },
    "renders": {
        "displayName": "Semm Renders",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2007-09-21"
    },
    "corbanie": {
        "displayName": "Kobe Corbanie",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-05-10"
    },
    "praet": {
        "displayName": "Dennis Praet",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-05-14"
    },
    "babadi": {
        "displayName": "Isaac Babadi",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2005-04-06"
    },
    "benitez": {
        "displayName": "Mauricio Benítez",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2004-02-03"
    },
    "diawara": {
        "displayName": "Mahamadou Diawara",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "France",
        "position": "Midfielder",
        "number": 34,
        "dateofbirth": "2005-02-17"
    },
    "scott": {
        "displayName": "Christopher Scott",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Germany",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2002-06-07"
    },
    "verstraeten": {
        "displayName": "Andreas Verstraeten",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2006-01-10"
    },
    "adekami": {
        "displayName": "Farouck Adekami",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2006-08-07"
    },
    "hairemans": {
        "displayName": "Geoffry Hairemans",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1991-10-21"
    },
    "janssen": {
        "displayName": "Vincent Janssen",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1994-06-15"
    },
    "somers": {
        "displayName": "Thibo Somers",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Belgium",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "1999-03-16"
    },
    "kerk": {
        "displayName": "Gyrano Kerk",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Suriname",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-12-02"
    },
    "alsahafi": {
        "displayName": "Marwan Al-Sahafi",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Saudi Arabia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-02-17"
    },
    "anthonyvalencia": {
        "displayName": "Anthony Valencia",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Ecuador",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2003-07-21"
    },
    "urinboev": {
        "displayName": "Mukhammadali Urinboev",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Uzbekistan",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-04-24"
    },
    "jesusdavid": {
        "displayName": "Gabriel Jesus David",
        "club": "Royal Antwerp",
        "league": "Pro League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 92,
        "dateofbirth": "2007-01-02"
    },
    "remiro": {
        "displayName": "Álex Remiro",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-03-24"
    },
    "marrero": {
        "displayName": "Unai Marrero",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "2001-10-08"
    },
    "aramburu": {
        "displayName": "Jon Aramburu",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Venezuela",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-07-23"
    },
    "aihen": {
        "displayName": "Aihen Muñoz",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-08-16"
    },
    "zubeldia": {
        "displayName": "Igor Zubeldia",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-03-30"
    },
    "elustondo": {
        "displayName": "Aritz Elustondo",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1994-03-28"
    },
    "caletacar": {
        "displayName": "Duje Ćaleta-Car",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Croatia",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1996-09-17"
    },
    "odriozola": {
        "displayName": "Álvaro Odriozola",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1995-12-14"
    },
    "jonmartin": {
        "displayName": "Jon Martín",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "2006-04-23"
    },
    "gorrotxategi": {
        "displayName": "Jon Gorrotxategi",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2002-09-02"
    },
    "turrientes": {
        "displayName": "Beñat Turrientes",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-01-31"
    },
    "yangel": {
        "displayName": "Yangel Herrera",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Venezuela",
        "position": "Midfielder",
        "number": 12,
        "dateofbirth": "1998-01-07"
    },
    "sergiogomez": {
        "displayName": "Sergio Gómez",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2000-09-04"
    },
    "soler": {
        "displayName": "Carlos Soler",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-01-02"
    },
    "zakharyan": {
        "displayName": "Arsen Zakharyan",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Russia",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2003-05-26"
    },
    "braismendez": {
        "displayName": "Brais Méndez",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1997-01-07"
    },
    "lukasucic": {
        "displayName": "Luka Sučić",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2002-09-08"
    },
    "pablomarin": {
        "displayName": "Pablo Marín",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2003-07-03"
    },
    "barrenetxea": {
        "displayName": "Ander Barrenetxea",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2001-12-27"
    },
    "oskarsson": {
        "displayName": "Orri Óskarsson",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Iceland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-08-29"
    },
    "oyarzabal": {
        "displayName": "Mikel Oyarzabal",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-04-21"
    },
    "guedes": {
        "displayName": "Gonçalo Guedes",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1996-11-29"
    },
    "kubo": {
        "displayName": "Takefusa Kubo",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Japan",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2001-06-04"
    },
    "sadiq": {
        "displayName": "Umar Sadiq",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 15,
        "dateofbirth": "1997-02-02"
    },
    "karrikaburu": {
        "displayName": "Jon Karrikaburu",
        "club": "Real Sociedad",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2002-09-19"
    },
    "musso": {
        "displayName": "Juan Musso",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-05-13"
    },
    "oblak": {
        "displayName": "Jan Oblak",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Slovenia",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1993-01-07"
    },
    "gimenez": {
        "displayName": "José María Giménez",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Uruguay",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1995-01-20"
    },
    "ruggeri": {
        "displayName": "Matteo Ruggeri",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Italy",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-07-11"
    },
    "lenglet": {
        "displayName": "Clément Lenglet",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1995-06-17"
    },
    "molina": {
        "displayName": "Nahuel Molina",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1998-04-06"
    },
    "hancko": {
        "displayName": "Dávid Hancko",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Slovakia",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1997-12-13"
    },
    "pubill": {
        "displayName": "Marc Pubill",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2003-06-20"
    },
    "lenormand": {
        "displayName": "Robin Le Normand",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1996-11-11"
    },
    "gallagher": {
        "displayName": "Conor Gallagher",
        "club": "Tottenham Hotspur",
        "league": "Premier League",
        "country": "England",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2000-02-06"
    },
    "cardoso": {
        "displayName": "Johnny Cardoso",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "United States",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2001-09-20"
    },
    "koke": {
        "displayName": "Koke",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1992-01-08"
    },
    "barrios": {
        "displayName": "Pablo Barrios",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-06-15"
    },
    "baena": {
        "displayName": "Álex Baena",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2001-07-20"
    },
    "almada": {
        "displayName": "Thiago Almada",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2001-04-26"
    },
    "llorente": {
        "displayName": "Marcos Llorente",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1995-01-30"
    },
    "griezmann": {
        "displayName": "Antoine Griezmann",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1991-03-21"
    },
    "sorloth": {
        "displayName": "Alexander Sørloth",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Norway",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1995-12-05"
    },
    "martin": {
        "displayName": "Carlos Martín",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 12,
        "dateofbirth": "2002-04-22"
    },
    "alvarez": {
        "displayName": "Julián Alvarez",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2000-01-31"
    },
    "simeone": {
        "displayName": "Giuliano Simeone",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2002-12-18"
    },
    "raspadori": {
        "displayName": "Giacomo Raspadori",
        "club": "Atalanta",
        "league": "Serie A",
        "country": "Italy",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2000-02-18"
    },
    "gonzalez": {
        "displayName": "Nico González",
        "club": "Atlético Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1998-04-06"
    },
    "vlachodimos": {
        "displayName": "Odysseas Vlachodimos",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-04-26"
    },
    "nyland": {
        "displayName": "Ørjan Nyland",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Norway",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1990-09-10"
    },
    "alvarofernandez": {
        "displayName": "Álvaro Fernández",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1998-04-13"
    },
    "josecarmona": {
        "displayName": "José Ángel Carmona",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-01-29"
    },
    "azpilicueta": {
        "displayName": "César Azpilicueta",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1989-08-28"
    },
    "kikesalas": {
        "displayName": "Kike Salas",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2002-04-01"
    },
    "nianzou": {
        "displayName": "Tanguy Nianzou",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-06-07"
    },
    "suazo": {
        "displayName": "Gabriel Suazo",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Chile",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1997-08-09"
    },
    "fabiocardoso": {
        "displayName": "Fábio Cardoso",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1994-04-19"
    },
    "marcao": {
        "displayName": "Marcão",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1996-06-05"
    },
    "gudelj": {
        "displayName": "Nemanja Gudelj",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1991-11-16"
    },
    "jordán": {
        "displayName": "Joan Jordán",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-07-06"
    },
    "juanlu": {
        "displayName": "Juanlu Sánchez",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2003-08-15"
    },
    "agoume": {
        "displayName": "Lucien Agoumé",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2002-02-12"
    },
    "batistamendy": {
        "displayName": "Batista Mendy",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2000-01-12"
    },
    "sow": {
        "displayName": "Djibril Sow",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1997-02-06"
    },
    "januzaj": {
        "displayName": "Adnan Januzaj",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "1995-02-05"
    },
    "isaacromero": {
        "displayName": "Isaac Romero",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-05-18"
    },
    "akoradams": {
        "displayName": "Akor Adams",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-01-29"
    },
    "alexissanchez": {
        "displayName": "Alexis Sánchez",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Chile",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1988-12-19"
    },
    "rubenvargas": {
        "displayName": "Rubén Vargas",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Switzerland",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-08-05"
    },
    "peque": {
        "displayName": "Peque Fernández",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2002-10-04"
    },
    "alfongonzalez": {
        "displayName": "Alfon González",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1999-05-04"
    },
    "ejuke": {
        "displayName": "Chidera Ejuke",
        "club": "Sevilla",
        "league": "LaLiga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1998-01-02"
    },
    "courtois": {
        "displayName": "Thibaut Courtois",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-05-11"
    },
    "lunin": {
        "displayName": "Andriy Lunin",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Ukraine",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1999-02-11"
    },
    "carvajal": {
        "displayName": "Dani Carvajal",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1992-01-11"
    },
    "militao": {
        "displayName": "Éder Militão",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1998-01-18"
    },
    "alaba": {
        "displayName": "David Alaba",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Austria",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1992-06-24"
    },
    "trent": {
        "displayName": "Trent Alexander-Arnold",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "England",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1998-10-07"
    },
    "asencio": {
        "displayName": "Raúl Asencio",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2003-02-13"
    },
    "carreras": {
        "displayName": "Álvaro Carreras",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2003-03-23"
    },
    "frangarcia": {
        "displayName": "Fran García",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1999-08-14"
    },
    "rudiger": {
        "displayName": "Antonio Rüdiger",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Germany",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1993-03-03"
    },
    "mendy": {
        "displayName": "Ferland Mendy",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1995-06-08"
    },
    "huijsen": {
        "displayName": "Dean Huijsen",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2005-04-14"
    },
    "bellingham": {
        "displayName": "Jude Bellingham",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "England",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2003-06-29"
    },
    "camavinga": {
        "displayName": "Eduardo Camavinga",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-11-10"
    },
    "valverde": {
        "displayName": "Federico Valverde",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-07-22"
    },
    "tchouameni": {
        "displayName": "Aurélien Tchouaméni",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2000-01-27"
    },
    "ardaguler": {
        "displayName": "Arda Güler",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2005-02-25"
    },
    "ceballos": {
        "displayName": "Dani Ceballos",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1996-08-07"
    },
    "mastantuono": {
        "displayName": "Franco Mastantuono",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2007-08-14"
    },
    "vinicius": {
        "displayName": "Vinícius Júnior",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-07-12"
    },
    "mbappe": {
        "displayName": "Kylian Mbappé",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "France",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1998-12-20"
    },
    "rodrygo": {
        "displayName": "Rodrygo",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-01-09"
    },
    "gonzalo": {
        "displayName": "Gonzalo García",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2004-03-24"
    },
    "brahim": {
        "displayName": "Brahim Díaz",
        "club": "Real Madrid",
        "league": "LaLiga",
        "country": "Morocco",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1999-08-03"
    },
    "luizjunior": {
        "displayName": "Luiz Júnior",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-01-14"
    },
    "diegoconde": {
        "displayName": "Diego Conde",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1998-10-28"
    },
    "arnautenas": {
        "displayName": "Arnau Tenas",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "2001-05-30"
    },
    "logancosta": {
        "displayName": "Logan Costa",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Cape Verde",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-04-01"
    },
    "altimira": {
        "displayName": "Adrià Altimira",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-01-11"
    },
    "rafamarin": {
        "displayName": "Rafa Marín",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2002-05-19"
    },
    "kambwala": {
        "displayName": "Willy Kambwala",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2004-08-25"
    },
    "foyth": {
        "displayName": "Juan Foyth",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Argentina",
        "position": "Defender",
        "number": 8,
        "dateofbirth": "1998-01-12"
    },
    "renatoveiga": {
        "displayName": "Renato Veiga",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Portugal",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2003-07-29"
    },
    "mourino": {
        "displayName": "Santiago Mouriño",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Uruguay",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2002-02-13"
    },
    "sergicardona": {
        "displayName": "Sergi Cardona",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-07-08"
    },
    "pedraza": {
        "displayName": "Alfonso Pedraza",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1996-04-09"
    },
    "paunavarro": {
        "displayName": "Pau Navarro",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2005-04-25"
    },
    "parejo": {
        "displayName": "Dani Parejo",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1989-04-16"
    },
    "comesana": {
        "displayName": "Santi Comesaña",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1996-10-05"
    },
    "partey": {
        "displayName": "Thomas Partey",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Ghana",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1993-06-13"
    },
    "papegueye": {
        "displayName": "Pape Gueye",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Senegal",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1999-01-24"
    },
    "moleiro": {
        "displayName": "Alberto Moleiro",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2003-09-30"
    },
    "solomon": {
        "displayName": "Manor Solomon",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Israel",
        "position": "Forward",
        "number": 6,
        "dateofbirth": "1999-07-24"
    },
    "gerardmoreno": {
        "displayName": "Gerard Moreno",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1992-04-07"
    },
    "mikautadze": {
        "displayName": "Georges Mikautadze",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Georgia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-10-31"
    },
    "akhomach": {
        "displayName": "Ilias Akhomach",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Morocco",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-04-16"
    },
    "buchanan": {
        "displayName": "Tajon Buchanan",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Canada",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1999-02-08"
    },
    "nicolaspepe": {
        "displayName": "Nicolas Pépé",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1995-05-29"
    },
    "oluwaseyi": {
        "displayName": "Tani Oluwaseyi",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Canada",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2000-05-15"
    },
    "ayozeperez": {
        "displayName": "Ayoze Pérez",
        "club": "Villarreal CF",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1993-07-29"
    },
    "unaisimon": {
        "displayName": "Unai Simón",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-06-11"
    },
    "padilla": {
        "displayName": "Álex Padilla",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Mexico",
        "position": "Goalkeeper",
        "number": 27,
        "dateofbirth": "2003-09-01"
    },
    "vivian": {
        "displayName": "Dani Vivian",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-07-05"
    },
    "paredes": {
        "displayName": "Aitor Paredes",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-04-29"
    },
    "yeray": {
        "displayName": "Yeray Álvarez",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1995-01-24"
    },
    "areso": {
        "displayName": "Jesús Areso",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1999-07-02"
    },
    "laporte": {
        "displayName": "Aymeric Laporte",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1994-05-27"
    },
    "lekue": {
        "displayName": "Iñigo Lekue",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1993-05-04"
    },
    "yuri": {
        "displayName": "Yuri Berchiche",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1990-02-10"
    },
    "adamaboiro": {
        "displayName": "Adama Boiro",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2002-06-22"
    },
    "gorosabel": {
        "displayName": "Andoni Gorosabel",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-08-04"
    },
    "vesga": {
        "displayName": "Mikel Vesga",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1993-04-08"
    },
    "sancet": {
        "displayName": "Oihan Sancet",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-04-25"
    },
    "galarreta": {
        "displayName": "Iñigo Ruiz de Galarreta",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1993-08-06"
    },
    "jauregizar": {
        "displayName": "Mikel Jauregizar",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2003-11-13"
    },
    "unaigomez": {
        "displayName": "Unai Gómez",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2003-05-25"
    },
    "prados": {
        "displayName": "Beñat Prados",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "2001-02-08"
    },
    "berenguer": {
        "displayName": "Álex Berenguer",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-07-04"
    },
    "inakiwilliams": {
        "displayName": "Iñaki Williams",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Ghana",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1994-06-15"
    },
    "nicowilliams": {
        "displayName": "Nico Williams",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2002-07-12"
    },
    "guruzeta": {
        "displayName": "Gorka Guruzeta",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1996-09-12"
    },
    "sannadi": {
        "displayName": "Maroan Sannadi",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Morocco",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2001-02-01"
    },
    "nicoserrano": {
        "displayName": "Nico Serrano",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2003-03-05"
    },
    "robertnavarro": {
        "displayName": "Robert Navarro",
        "club": "Athletic Bilbao",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2002-04-12"
    },
    "terstegen": {
        "displayName": "Marc-André ter Stegen",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-04-30"
    },
    "joangarcia": {
        "displayName": "Joan García",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "2001-05-04"
    },
    "szczesny": {
        "displayName": "Wojciech Szczęsny",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1990-04-18"
    },
    "balde": {
        "displayName": "Alejandro Balde",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-10-18"
    },
    "araujo": {
        "displayName": "Ronald Araújo",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Uruguay",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-03-07"
    },
    "cubarsi": {
        "displayName": "Pau Cubarsí",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2007-01-22"
    },
    "andreaschristensen": {
        "displayName": "Andreas Christensen",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Denmark",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1996-04-10"
    },
    "gerardmartin": {
        "displayName": "Gerard Martín",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2002-02-26"
    },
    "kounde": {
        "displayName": "Jules Koundé",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1998-11-12"
    },
    "ericgarcia": {
        "displayName": "Eric García",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2001-01-09"
    },
    "gavi": {
        "displayName": "Gavi",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2004-08-05"
    },
    "fermin": {
        "displayName": "Fermín López",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2003-05-11"
    },
    "casado": {
        "displayName": "Marc Casadó",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2003-09-14"
    },
    "olmo": {
        "displayName": "Dani Olmo",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1998-05-07"
    },
    "dejong": {
        "displayName": "Frenkie de Jong",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1997-05-12"
    },
    "bernal": {
        "displayName": "Marc Bernal",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2007-05-26"
    },
    "ferrantorres": {
        "displayName": "Ferran Torres",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2000-02-29"
    },
    "lewandowski": {
        "displayName": "Robert Lewandowski",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Poland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1988-08-21"
    },
    "yamal": {
        "displayName": "Lamine Yamal",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2007-07-13"
    },
    "raphinha": {
        "displayName": "Raphinha",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1996-12-14"
    },
    "rashford": {
        "displayName": "Marcus Rashford",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "England",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1997-10-31"
    },
    "bardghji": {
        "displayName": "Roony Bardghji",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Sweden",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "2005-11-15"
    },
    "pedri": {
        "displayName": "Pedri",
        "club": "Barcelona",
        "league": "LaLiga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-11-25"
    },
    "mccarthy": {
        "displayName": "John McCarthy",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1992-07-04"
    },
    "marcucci": {
        "displayName": "A.J. Marcucci",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-07-31"
    },
    "stokes": {
        "displayName": "Aiden Stokes",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 21,
        "dateofbirth": "2008-01-14"
    },
    "eile": {
        "displayName": "Noah Eile",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Sweden",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-07-19"
    },
    "morales": {
        "displayName": "Marcelo Morales",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Chile",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2003-06-06"
    },
    "snealis": {
        "displayName": "Sean Nealis",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1997-01-13"
    },
    "dnealis": {
        "displayName": "Dylan Nealis",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1998-07-30"
    },
    "omarvalencia": {
        "displayName": "Omar Valencia",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Panama",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2004-06-08"
    },
    "mina": {
        "displayName": "Juan José Mina",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2004-07-27"
    },
    "forsberg": {
        "displayName": "Emil Forsberg",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1991-10-23"
    },
    "berggren": {
        "displayName": "Gustav Berggren",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1997-09-07"
    },
    "carmona": {
        "displayName": "josecarmona",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Venezuela",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2003-02-24"
    },
    "stroud": {
        "displayName": "Peter Stroud",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-04-23"
    },
    "benedetti": {
        "displayName": "Nehuén Benedetti",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 54,
        "dateofbirth": "2005-01-20"
    },
    "donkor": {
        "displayName": "Ronald Donkor",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Ghana",
        "position": "Midfielder",
        "number": 48,
        "dateofbirth": "2004-11-20"
    },
    "choupomoting": {
        "displayName": "Eric Maxim Choupo-Moting",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Cameroon",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1989-03-23"
    },
    "cowell": {
        "displayName": "Cade Cowell",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-10-14"
    },
    "morgan": {
        "displayName": "Lewis Morgan",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Scotland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1996-09-30"
    },
    "bogacz": {
        "displayName": "Wiktor Bogacz",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Poland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-07-14"
    },
    "hall": {
        "displayName": "Julian Hall",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2008-03-24"
    },
    "gjengaar": {
        "displayName": "Dennis Gjengaar",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "Norway",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "2004-02-24"
    },
    "ngoma": {
        "displayName": "Serge Ngoma",
        "club": "New York Red Bulls",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 81,
        "dateofbirth": "2005-07-09"
    },
    "micovic": {
        "displayName": "Novak Mićović",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Serbia",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-10-25"
    },
    "marcinkowski": {
        "displayName": "JT Marcinkowski",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1997-05-09"
    },
    "bradyscott": {
        "displayName": "Brady Scott",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1999-06-30"
    },
    "glesnes": {
        "displayName": "Jakob Glesnes",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Norway",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1994-03-25"
    },
    "yoshida": {
        "displayName": "Maya Yoshida",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1988-08-24"
    },
    "yamane": {
        "displayName": "Miki Yamane",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Japan",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1993-12-22"
    },
    "zanka": {
        "displayName": "Mathias Jørgensen",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Denmark",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1990-04-23"
    },
    "aude": {
        "displayName": "Julián Aude",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Argentina",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-03-24"
    },
    "nelson": {
        "displayName": "John Nelson",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1998-07-11"
    },
    "cuevas": {
        "displayName": "Mauricio Cuevas",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2003-02-10"
    },
    "millermiller": {
        "displayName": "Harbor Miller",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2007-06-21"
    },
    "puig": {
        "displayName": "Riqui Puig",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Spain",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1999-08-13"
    },
    "reus": {
        "displayName": "Marco Reus",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Germany",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1989-05-31"
    },
    "sanabria": {
        "displayName": "Lucas Sanabria",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-12-28"
    },
    "cerrillo": {
        "displayName": "Edwin Cerrillo",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2000-10-03"
    },
    "haak": {
        "displayName": "Justin Haak",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 80,
        "dateofbirth": "2001-09-12"
    },
    "wynder": {
        "displayName": "Elijah Wynder",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2003-03-10"
    },
    "parente": {
        "displayName": "Isaiah Parente",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2000-03-16"
    },
    "pec": {
        "displayName": "Gabriel Pec",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Brazil",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-02-11"
    },
    "paintsil": {
        "displayName": "Joseph Paintsil",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Ghana",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "1998-02-01"
    },
    "ramirez": {
        "displayName": "Christian Ramirez",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1991-04-04"
    },
    "matheus": {
        "displayName": "Matheus Nascimento",
        "club": "LA Galaxy",
        "league": "MLS",
        "country": "Brazil",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-03-03"
    },
    "lloris": {
        "displayName": "Hugo Lloris",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "France",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1986-12-26"
    },
    "hasal": {
        "displayName": "Thomas Hasal",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1999-07-09"
    },
    "cabral_carter": {
        "displayName": "Cabral Carter",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2005-01-31"
    },
    "segura": {
        "displayName": "Eddie Segura",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-02-02"
    },
    "porteous": {
        "displayName": "Ryan Porteous",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Scotland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-03-25"
    },
    "palencia": {
        "displayName": "Sergi Palencia",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Spain",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1996-03-23"
    },
    "dellavalle": {
        "displayName": "Lorenzo Dellavalle",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Italy",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2004-04-04"
    },
    "hollingshead": {
        "displayName": "Ryan Hollingshead",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1991-04-16"
    },
    "smolyakov": {
        "displayName": "Artem Smolyakov",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Ukraine",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2003-05-29"
    },
    "long": {
        "displayName": "Aaron Long",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1992-10-12"
    },
    "nielsen": {
        "displayName": "Kenny Nielsen",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 45,
        "dateofbirth": "2002-02-13"
    },
    "tafari": {
        "displayName": "Nkosi Tafari",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "1997-03-23"
    },
    "igor_jesus": {
        "displayName": "Igor Jesus",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2003-03-07"
    },
    "delgado": {
        "displayName": "Mark Delgado",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-05-16"
    },
    "timothytillman": {
        "displayName": "Timothy Tillman",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1999-01-04"
    },
    "yeboah": {
        "displayName": "Yaw Yeboah",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Ghana",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1997-03-28"
    },
    "jude_terry": {
        "displayName": "Jude Terry",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 56,
        "dateofbirth": "2008-10-08"
    },
    "choiniere": {
        "displayName": "Mathieu Choinière",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Midfielder",
        "number": 66,
        "dateofbirth": "1999-02-07"
    },
    "matt_evans": {
        "displayName": "Matt Evans",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 70,
        "dateofbirth": "2006-03-11"
    },
    "son": {
        "displayName": "Son Heung-min",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "South Korea",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1992-07-08"
    },
    "shaffelburg": {
        "displayName": "Jacob Shaffelburg",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1999-11-26"
    },
    "ebobisse": {
        "displayName": "Jeremy Ebobisse",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1997-02-14"
    },
    "ordaz": {
        "displayName": "Nathan Ordaz",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "El Salvador",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2004-01-12"
    },
    "david_martinez": {
        "displayName": "David Martínez",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Venezuela",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2006-02-07"
    },
    "boyd": {
        "displayName": "Tyler Boyd",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1994-12-30"
    },
    "wibowo": {
        "displayName": "Adrian Wibowo",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Indonesia",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2006-01-17"
    },
    "bouanga": {
        "displayName": "Denis Bouanga",
        "club": "Los Angeles FC",
        "league": "MLS",
        "country": "Gabon",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1994-11-11"
    },
    "ustari": {
        "displayName": "Óscar Ustari",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Goalkeeper",
        "number": 19,
        "dateofbirth": "1986-07-03"
    },
    "stclair": {
        "displayName": "Dayne St. Clair",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Canada",
        "position": "Goalkeeper",
        "number": 97,
        "dateofbirth": "1997-05-09"
    },
    "aviles": {
        "displayName": "Tomás Avilés",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2004-02-03"
    },
    "lujan": {
        "displayName": "Gonzalo Luján",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-04-27"
    },
    "falcon": {
        "displayName": "Maximiliano Falcón",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "1997-05-01"
    },
    "fray": {
        "displayName": "Ian Fray",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "2002-08-31"
    },
    "allen": {
        "displayName": "Noah Allen",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2004-04-28"
    },
    "reguilon": {
        "displayName": "Sergio Reguilón",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1996-12-16"
    },
    "mura": {
        "displayName": "Facundo Mura",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1999-03-23"
    },
    "micael": {
        "displayName": "Micael",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Brazil",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2000-08-12"
    },
    "depaul": {
        "displayName": "Rodrigo De Paul",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1994-05-24"
    },
    "segovia": {
        "displayName": "Telasco Segovia",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Venezuela",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-04-02"
    },
    "ruiz": {
        "displayName": "David Ruiz",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Honduras",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "2004-02-08"
    },
    "bright": {
        "displayName": "Yannick Bright",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Italy",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2001-09-03"
    },
    "ayala": {
        "displayName": "David Ayala",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2002-07-26"
    },
    "messi": {
        "displayName": "Lionel Messi",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1987-06-24"
    },
    "suarez": {
        "displayName": "Luis Suárez (El Pistolero)",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1987-01-24"
    },
    "silvetti": {
        "displayName": "Mateo Silvetti",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "2006-01-14"
    },
    "allende": {
        "displayName": "Tadeo Allende",
        "club": "Inter Miami",
        "league": "MLS",
        "country": "Argentina",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1999-02-20"
    },
    "takaoka": {
        "displayName": "Yohei Takaoka",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Japan",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1996-03-16"
    },
    "zendejas": {
        "displayName": "Adrían Zendejas",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "1995-08-30"
    },
    "boehmer": {
        "displayName": "Isaac Boehmer",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "2001-11-20"
    },
    "veselinovic": {
        "displayName": "Ranko Veselinović",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Serbia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-03-24"
    },
    "schonlau": {
        "displayName": "Sebastian Schonlau",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Germany",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1994-08-05"
    },
    "blackmon": {
        "displayName": "Tristan Blackmon",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United-States",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1996-08-12"
    },
    "laborda": {
        "displayName": "Mathías Laborda",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Uruguay",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-09-15"
    },
    "adekugbe": {
        "displayName": "Sam Adekugbe",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1995-01-16"
    },
    "ocampo": {
        "displayName": "Édier Ocampo",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Colombia",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "2003-10-03"
    },
    "bovalina": {
        "displayName": "Giuseppe Bovalina",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Australia",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2004-11-11"
    },
    "tatejohnson": {
        "displayName": "Tate Johnson",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "2005-07-10"
    },
    "djordjevic": {
        "displayName": "Nikola Djordjevic",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2002-09-15"
    },
    "cubas": {
        "displayName": "Andrés Cubas",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Paraguay",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1996-05-11"
    },
    "gauld": {
        "displayName": "Ryan Gauld",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "1995-12-16"
    },
    "berhalter": {
        "displayName": "Sebastian Berhalter",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2001-05-10"
    },
    "priso": {
        "displayName": "Ralph Priso",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-08-02"
    },
    "badwal": {
        "displayName": "Jeevan Badwal",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Midfielder",
        "number": 59,
        "dateofbirth": "2006-03-11"
    },
    "mackenzie": {
        "displayName": "Liam Mackenzie",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Midfielder",
        "number": 97,
        "dateofbirth": "2007-03-15"
    },
    "muller": {
        "displayName": "Thomas Müller",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Germany",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1989-09-13"
    },
    "white": {
        "displayName": "Brian White",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "1996-02-03"
    },
    "sabbi": {
        "displayName": "Emmanuel Sabbi",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-12-24"
    },
    "cabrera": {
        "displayName": "Kenji Cabrera",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Peru",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2003-01-23"
    },
    "elloumi": {
        "displayName": "Rayan Elloumi",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "Canada",
        "position": "Forward",
        "number": 75,
        "dateofbirth": "2007-09-17"
    },
    "pierre": {
        "displayName": "Nelson Pierre",
        "club": "Vancouver Whitecaps FC",
        "league": "MLS",
        "country": "United States",
        "position": "Forward",
        "number": 42,
        "dateofbirth": "2005-03-22"
    },
    "marvin_keller": {
        "displayName": "Marvin Keller",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2002-07-03"
    },
    "heinz_lindner": {
        "displayName": "Heinz Lindner",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1990-07-17"
    },
    "dario_marzino": {
        "displayName": "Dario Marzino",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1996-09-19"
    },
    "gregory_wuthrich": {
        "displayName": "Gregory Wüthrich",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1994-12-04"
    },
    "tanguy_zoukrou": {
        "displayName": "Tanguy Zoukrou",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-05-07"
    },
    "loris_benito": {
        "displayName": "Loris Benito",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1992-01-07"
    },
    "jaouen_hadjam": {
        "displayName": "Jaouen Hadjam",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Algeria",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2003-03-26"
    },
    "ryan_andrews": {
        "displayName": "Ryan Andrews",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2004-08-26"
    },
    "saidy_janko": {
        "displayName": "Saidy Janko",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Gambia",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1995-10-22"
    },
    "rhodri_smith": {
        "displayName": "Rhodri Smith",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 66,
        "dateofbirth": "2006-09-09"
    },
    "alvyn_sanches": {
        "displayName": "Alvyn Sanches",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-02-12"
    },
    "armin_gigovic": {
        "displayName": "Armin Gigovic",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 37,
        "dateofbirth": "2002-04-06"
    },
    "edimilson_fernandes": {
        "displayName": "Edimilson Fernandes",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-04-15"
    },
    "sandro_lauper": {
        "displayName": "Sandro Lauper",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "1996-10-25"
    },
    "rayan_raveloson": {
        "displayName": "Rayan Raveloson",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Madagascar",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "1997-01-16"
    },
    "darian_males": {
        "displayName": "Darian Males",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 39,
        "dateofbirth": "2001-05-03"
    },
    "dominik_pech": {
        "displayName": "Dominik Pech",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "2006-09-04"
    },
    "christian_fassnacht": {
        "displayName": "Christian Fassnacht",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1993-11-11"
    },
    "joel_monteiro": {
        "displayName": "Joël Monteiro",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 77,
        "dateofbirth": "1999-08-05"
    },
    "chris_bedia": {
        "displayName": "Chris Bedia",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "1996-03-05"
    },
    "sergio_cordova": {
        "displayName": "Sergio Córdova",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Venezuela",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-08-09"
    },
    "alan_virginius": {
        "displayName": "Alan Virginius",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-01-03"
    },
    "ebrima_colley": {
        "displayName": "Ebrima Colley",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Gambia",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-02-01"
    },
    "facinet_conte": {
        "displayName": "Facinet Conte",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "2005-03-24"
    },
    "felix_tsimba": {
        "displayName": "Felix Emmanuel Tsimba",
        "club": "BSC Young Boys",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2006-06-22"
    },
    "hitz": {
        "displayName": "Marwin Hitz",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1987-09-18"
    },
    "salvi": {
        "displayName": "Mirko Salvi",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1994-02-14"
    },
    "spycher": {
        "displayName": "Tim Spycher",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "2004-01-02"
    },
    "pfeiffer": {
        "displayName": "Tim Pfeiffer",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 47,
        "dateofbirth": "2005-07-02"
    },
    "adjetey": {
        "displayName": "Jonas Adjetey",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Ghana",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "2003-12-13"
    },
    "barisic": {
        "displayName": "Adrian Leon Barišić",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "2001-07-19"
    },
    "van_breemen": {
        "displayName": "Finn van Breemen",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2003-02-25"
    },
    "daniliuc": {
        "displayName": "Flavius Daniliuc",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Austria",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2001-04-27"
    },
    "vouilloz": {
        "displayName": "Nicolas Vouilloz",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-05-11"
    },
    "schmid": {
        "displayName": "Dominik Schmid",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 31,
        "dateofbirth": "1998-03-10"
    },
    "tsunemoto": {
        "displayName": "Keigo Tsunemoto",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Japan",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-10-21"
    },
    "ruegg": {
        "displayName": "Kevin Rüegg",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1998-08-05"
    },
    "shaqiri": {
        "displayName": "Xherdan Shaqiri",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1991-10-10"
    },
    "metinho": {
        "displayName": "Metinho",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2003-04-23"
    },
    "koindredi": {
        "displayName": "Koba Koindredi",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2001-10-27"
    },
    "leroy": {
        "displayName": "Léo Leroy",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2000-02-14"
    },
    "bacanin": {
        "displayName": "Andrej Bačanin",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2007-06-13"
    },
    "kacuri": {
        "displayName": "Dion Kacuri",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2004-02-11"
    },
    "traore": {
        "displayName": "Bénie Traoré",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-11-30"
    },
    "otele": {
        "displayName": "Philip Otele",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-04-15"
    },
    "broschinski": {
        "displayName": "Moritz Broschinski",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Germany",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2000-09-23"
    },
    "ajeti": {
        "displayName": "Albian Ajeti",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1997-02-26"
    },
    "soticek": {
        "displayName": "Marin Šotiček",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Croatia",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-09-18"
    },
    "agbonifo": {
        "displayName": "Jeremy Agbonifo",
        "club": "FC Basel",
        "league": "Swiss Super League",
        "country": "Sweden",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2005-10-24"
    },
    "yanick_brecher": {
        "displayName": "Yanick Brecher",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1993-05-25"
    },
    "silas_huber": {
        "displayName": "Silas Huber",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2005-07-10"
    },
    "yevgen_morozov": {
        "displayName": "Yevgen Morozov",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Ukraine",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "2007-01-23"
    },
    "lindrit_kamberi": {
        "displayName": "Lindrit Kamberi",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-10-07"
    },
    "jorge_segura": {
        "displayName": "Jorge Segura",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Colombia",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-01-18"
    },
    "mariano_gomez": {
        "displayName": "Mariano Gómez",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Argentina",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-02-05"
    },
    "milan_rodic": {
        "displayName": "Milan Rodić",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Serbia",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1991-04-02"
    },
    "livano_comenencia": {
        "displayName": "Livano Comenencia",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-02-03"
    },
    "ilan_sauter": {
        "displayName": "Ilan Sauter",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2001-02-06"
    },
    "junior_ligue": {
        "displayName": "Junior (Calixte) Ligue",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2005-03-21"
    },
    "steven_zuber": {
        "displayName": "Steven Zuber",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1991-08-17"
    },
    "bledian_krasniqi": {
        "displayName": "Bledian Krasniqi",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2001-06-17"
    },
    "cheveyo_tsawa": {
        "displayName": "Cheveyo Tsawa",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2006-12-09"
    },
    "nelson_palacio": {
        "displayName": "Nelson Palacio",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Colombia",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "2001-06-16"
    },
    "miguel_reichmuth": {
        "displayName": "Miguel Reichmuth",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Switzerland",
        "position": "Midfielder",
        "number": 38,
        "dateofbirth": "2003-10-26"
    },
    "philippe_keny": {
        "displayName": "Philippe Keny",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Senegal",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1999-05-18"
    },
    "matthias_phaeton": {
        "displayName": "Matthias Phaëton",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Guadeloupe",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2000-01-08"
    },
    "umeh_emmanuel": {
        "displayName": "Umeh Emmanuel",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Nigeria",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2004-08-31"
    },
    "juan_jose_perea": {
        "displayName": "Juan José Perea",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Colombia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-02-23"
    },
    "jahnoah_markelo": {
        "displayName": "Jahnoah Markelo",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "Netherlands",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "2003-01-04"
    },
    "damienus_reverson": {
        "displayName": "Damienus Reverson",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Forward",
        "number": 29,
        "dateofbirth": "2003-10-18"
    },
    "lisandru_tramoni": {
        "displayName": "Lisandru Tramoni",
        "club": "FC Zürich",
        "league": "Swiss Super League",
        "country": "France",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2003-04-18"
    },
    "neuer": {
        "displayName": "Manuel Neuer",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1986-03-27"
    },
    "ulreich": {
        "displayName": "Sven Ulreich",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "1988-08-03"
    },
    "urbig": {
        "displayName": "Jonas Urbig",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2003-08-08"
    },
    "upamecano": {
        "displayName": "Dayot Upamecano",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-10-27"
    },
    "kim": {
        "displayName": "Kim Min-jae",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "South Korea",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1996-11-15"
    },
    "tah": {
        "displayName": "Jonathan Tah",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-02-11"
    },
    "davies": {
        "displayName": "Alphonso Davies",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Canada",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2000-11-02"
    },
    "ito": {
        "displayName": "Hiroki Ito",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Japan",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1999-05-12"
    },
    "guerreiro": {
        "displayName": "Raphaël Guerreiro",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1993-12-22"
    },
    "boey": {
        "displayName": "Sacha Boey",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2000-09-13"
    },
    "stanisic": {
        "displayName": "Josip Stanišić",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Croatia",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2000-04-02"
    },
    "kimmich": {
        "displayName": "Joshua Kimmich",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1995-02-08"
    },
    "goretzka": {
        "displayName": "Leon Goretzka",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-02-06"
    },
    "musiala": {
        "displayName": "Jamal Musiala",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-02-26"
    },
    "bischof": {
        "displayName": "Tom Bischof",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2005-06-28"
    },
    "laimer": {
        "displayName": "Konrad Laimer",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1997-05-27"
    },
    "karl": {
        "displayName": "Lennart Karl",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2008-05-31"
    },
    "alekspavlovic": {
        "displayName": "Aleksandar Pavlović",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 45,
        "dateofbirth": "2004-05-03"
    },
    "gnabry": {
        "displayName": "Serge Gnabry",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-07-14"
    },
    "kane": {
        "displayName": "Harry Kane",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "England",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-07-28"
    },
    "nicolasjackson": {
        "displayName": "Nicolas Jackson",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Senegal",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-06-20"
    },
    "diaz": {
        "displayName": "Luis Díaz",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Colombia",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1997-01-13"
    },
    "olise": {
        "displayName": "Michael Olise",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2001-12-12"
    },
    "mike": {
        "displayName": "Wisdom Mike",
        "club": "Bayern Munich",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 36,
        "dateofbirth": "2008-07-14"
    },
    "zetterer": {
        "displayName": "Michael Zetterer",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1995-07-12"
    },
    "grahl": {
        "displayName": "Jens Grahl",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1988-09-22"
    },
    "kauasantos": {
        "displayName": "Kauã Santos",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2003-04-11"
    },
    "siljevic": {
        "displayName": "Amil Šiljević",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "2007-06-08"
    },
    "robinkoch": {
        "displayName": "Robin Koch",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1996-07-17"
    },
    "theate": {
        "displayName": "Arthur Theate",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-05-25"
    },
    "amenda": {
        "displayName": "Aurèle Amenda",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Switzerland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-07-31"
    },
    "kristensen": {
        "displayName": "Rasmus Kristensen",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Denmark",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1997-07-11"
    },
    "eliasbaum": {
        "displayName": "Elias Baum",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-10-26"
    },
    "nbrown": {
        "displayName": "Nathaniel Brown",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "2003-06-16"
    },
    "buta": {
        "displayName": "Aurélio Buta",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1997-02-10"
    },
    "collins": {
        "displayName": "Nnamdi Collins",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 34,
        "dateofbirth": "2004-01-10"
    },
    "larsson": {
        "displayName": "Hugo Larsson",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2004-06-27"
    },
    "skhiri": {
        "displayName": "Ellyes Skhiri",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Tunisia",
        "position": "Midfielder",
        "number": 15,
        "dateofbirth": "1995-05-10"
    },
    "dahoud": {
        "displayName": "Mahmoud Dahoud",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1996-01-01"
    },
    "oscarhojlund": {
        "displayName": "Oscar Højlund",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2005-01-04"
    },
    "gotze": {
        "displayName": "Mario Götze",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1992-06-03"
    },
    "chandler": {
        "displayName": "Timothy Chandler",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "United States",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1990-03-29"
    },
    "uzun": {
        "displayName": "Can Uzun",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2005-11-11"
    },
    "burkardt": {
        "displayName": "Jonathan Burkardt",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-07-11"
    },
    "doan": {
        "displayName": "Ritsu Dōan",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Japan",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "1998-06-16"
    },
    "wahi": {
        "displayName": "Elye Wahi",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2003-01-02"
    },
    "chaibi": {
        "displayName": "Farès Chaïbi",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Algeria",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2002-11-28"
    },
    "knauff": {
        "displayName": "Ansgar Knauff",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-01-10"
    },
    "batshuayi": {
        "displayName": "Michy Batshuayi",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "1993-10-02"
    },
    "bahoya": {
        "displayName": "Jean-Mattéo Bahoya",
        "club": "Eintracht Frankfurt",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-05-07"
    },
    "nubel": {
        "displayName": "Alexander Nübel",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1996-09-30"
    },
    "bredlow": {
        "displayName": "Fabian Bredlow",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-03-02"
    },
    "hellstern": {
        "displayName": "Florian Hellstern",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2007-10-18"
    },
    "drljaca": {
        "displayName": "Stefan Drljača",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 21,
        "dateofbirth": "1999-04-20"
    },
    "mittelstadt": {
        "displayName": "Maximilian Mittelstädt",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 7,
        "dateofbirth": "1997-03-18"
    },
    "chabot": {
        "displayName": "Jeff Chabot",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1998-02-12"
    },
    "jeltsch": {
        "displayName": "Finn Jeltsch",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "2006-07-17"
    },
    "vagnoman": {
        "displayName": "Josha Vagnoman",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-12-11"
    },
    "assignon": {
        "displayName": "Lorenz Assignon",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2000-06-22"
    },
    "aldakhil": {
        "displayName": "Ameen Al-Dakhil",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-03-06"
    },
    "jaquez": {
        "displayName": "Luca Jaquez",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Switzerland",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2003-06-02"
    },
    "hendriks": {
        "displayName": "Ramon Hendriks",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-07-18"
    },
    "zagadou": {
        "displayName": "Dan-Axel Zagadou",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1999-06-03"
    },
    "stergiou": {
        "displayName": "Leonidas Stergiou",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Switzerland",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2002-03-03"
    },
    "stiller": {
        "displayName": "Angelo Stiller",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-04-04"
    },
    "elkhannouss": {
        "displayName": "Bilal El Khannouss",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2004-05-10"
    },
    "karazor": {
        "displayName": "Atakan Karazor",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Turkey",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1996-10-13"
    },
    "chema": {
        "displayName": "Chema Andrés",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2005-04-25"
    },
    "darvich": {
        "displayName": "Noah Darvich",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2006-09-25"
    },
    "fuhrich": {
        "displayName": "Chris Führich",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1998-01-09"
    },
    "keitel": {
        "displayName": "Yannik Keitel",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2000-02-15"
    },
    "nartey": {
        "displayName": "Nikolas Nartey",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2000-02-22"
    },
    "undav": {
        "displayName": "Deniz Undav",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "1996-07-19"
    },
    "demirovic": {
        "displayName": "Ermedin Demirović",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-03-25"
    },
    "leweling": {
        "displayName": "Jamie Leweling",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2001-02-26"
    },
    "tiagotomas": {
        "displayName": "Tiago Tomás",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2002-06-16"
    },
    "bouanani": {
        "displayName": "Badredine Bouanani",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Algeria",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2004-12-08"
    },
    "silas": {
        "displayName": "Silas",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "DR Congo",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1998-10-06"
    },
    "jovanovic": {
        "displayName": "Lazar Jovanović",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Serbia",
        "position": "Forward",
        "number": 45,
        "dateofbirth": "2006-11-30"
    },
    "diehl": {
        "displayName": "Justin Diehl",
        "club": "VfB Stuttgart",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2004-11-27"
    },
    "flekken": {
        "displayName": "Mark Flekken",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1993-06-13"
    },
    "blaswich": {
        "displayName": "Janis Blaswich",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 28,
        "dateofbirth": "1991-05-02"
    },
    "lomb": {
        "displayName": "Niklas Lomb",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 36,
        "dateofbirth": "1993-07-28"
    },
    "quansah": {
        "displayName": "Jarell Quansah",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2003-01-29"
    },
    "bade": {
        "displayName": "Loïc Badé",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-04-11"
    },
    "tapsoba": {
        "displayName": "Edmond Tapsoba",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Burkina Faso",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1999-02-02"
    },
    "grimaldo": {
        "displayName": "Alejandro Grimaldo",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1995-09-20"
    },
    "lucasvazquez": {
        "displayName": "Lucas Vázquez",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1991-07-01"
    },
    "belocian": {
        "displayName": "Jeanuël Belocian",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "2005-02-17"
    },
    "arthur": {
        "displayName": "Arthur",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2003-03-17"
    },
    "axeltape": {
        "displayName": "Axel Tape",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2007-04-14"
    },
    "andrich": {
        "displayName": "Robert Andrich",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-09-22"
    },
    "exequielpalacios": {
        "displayName": "Exequiel Palacios",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "1998-10-05"
    },
    "aleixgarcia": {
        "displayName": "Aleix García",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Spain",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "1997-06-28"
    },
    "equifernandez": {
        "displayName": "Equi Fernández",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2002-07-25"
    },
    "maliktillman": {
        "displayName": "Malik Tillman",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "United States",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2002-06-16"
    },
    "benseghir": {
        "displayName": "Eliesse Ben Seghir",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-02-16"
    },
    "maza": {
        "displayName": "Ibrahim Maza",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 30,
        "dateofbirth": "2005-11-24"
    },
    "echeverri": {
        "displayName": "Claudio Echeverri",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 9,
        "dateofbirth": "2006-01-02"
    },
    "hofmann": {
        "displayName": "Jonas Hofmann",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1992-07-14"
    },
    "schick": {
        "displayName": "Patrik Schick",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1996-01-24"
    },
    "terrier": {
        "displayName": "Martin Terrier",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1997-03-04"
    },
    "tella": {
        "displayName": "Nathan Tella",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1999-07-05"
    },
    "poku": {
        "displayName": "Ernest Poku",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Netherlands",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-01-28"
    },
    "kofane": {
        "displayName": "Christian Kofane",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Cameroon",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2006-05-19"
    },
    "sarco": {
        "displayName": "Alejo Sarco",
        "club": "Bayer Leverkusen",
        "league": "Bundesliga",
        "country": "Argentina",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2006-01-06"
    },
    "kobel": {
        "displayName": "Gregor Kobel",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Switzerland",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1997-12-06"
    },
    "meyer": {
        "displayName": "Alexander Meyer",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 33,
        "dateofbirth": "1991-04-13"
    },
    "drewes": {
        "displayName": "Patrick Drewes",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 30,
        "dateofbirth": "1993-02-04"
    },
    "schlotterbeck": {
        "displayName": "Nico Schlotterbeck",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-12-01"
    },
    "anton": {
        "displayName": "Waldemar Anton",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1996-07-20"
    },
    "yancouto": {
        "displayName": "Yan Couto",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-06-03"
    },
    "ryerson": {
        "displayName": "Julian Ryerson",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Norway",
        "position": "Defender",
        "number": 26,
        "dateofbirth": "1997-11-17"
    },
    "danielsvensson": {
        "displayName": "Daniel Svensson",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Sweden",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2002-02-12"
    },
    "anselmino": {
        "displayName": "Aarón Anselmino",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Argentina",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "2005-04-29"
    },
    "bensebaini": {
        "displayName": "Ramy Bensebaini",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Algeria",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1995-04-16"
    },
    "sule": {
        "displayName": "Niklas Süle",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1995-09-03"
    },
    "brandt": {
        "displayName": "Julian Brandt",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-05-02"
    },
    "jobebellingham": {
        "displayName": "Jobe Bellingham",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "England",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2005-09-23"
    },
    "chukwuemeka": {
        "displayName": "Carney Chukwuemeka",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "England",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2003-10-20"
    },
    "nmecha": {
        "displayName": "Felix Nmecha",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2000-10-10"
    },
    "sabitzer": {
        "displayName": "Marcel Sabitzer",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1994-03-17"
    },
    "gross": {
        "displayName": "Pascal Groß",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "1991-06-15"
    },
    "emrecan": {
        "displayName": "Emre Can",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1994-01-12"
    },
    "guirassy": {
        "displayName": "Serhou Guirassy",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Guinea",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1996-03-12"
    },
    "adeyemi": {
        "displayName": "Karim Adeyemi",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2002-01-18"
    },
    "beier": {
        "displayName": "Maximilian Beier",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "2002-10-17"
    },
    "fabiosilva": {
        "displayName": "Fábio Silva",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Portugal",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2002-07-19"
    },
    "duranville": {
        "displayName": "Julien Duranville",
        "club": "Borussia Dortmund",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2006-05-05"
    },
    "gulacsi": {
        "displayName": "Péter Gulácsi",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Hungary",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1990-05-06"
    },
    "vandevoordt": {
        "displayName": "Maarten Vandevoordt",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Goalkeeper",
        "number": 26,
        "dateofbirth": "2002-02-26"
    },
    "zingerle": {
        "displayName": "Leopold Zingerle",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 25,
        "dateofbirth": "1994-04-10"
    },
    "orban": {
        "displayName": "Willi Orbán",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Hungary",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1992-11-03"
    },
    "lukeba": {
        "displayName": "Castello Lukeba",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2002-12-17"
    },
    "raum": {
        "displayName": "David Raum",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1998-04-22"
    },
    "henrichs": {
        "displayName": "Benjamin Henrichs",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "1997-02-23"
    },
    "klostermann": {
        "displayName": "Lukas Klostermann",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1996-06-03"
    },
    "ridlebaku": {
        "displayName": "Ridle Baku",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1998-04-08"
    },
    "bitshiabu": {
        "displayName": "El Chadaille Bitshiabu",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2005-05-16"
    },
    "finkgrafe": {
        "displayName": "Max Finkgräfe",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2004-03-04"
    },
    "nedeljkovic": {
        "displayName": "Kosta Nedeljković",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Serbia",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2005-12-16"
    },
    "seiwald": {
        "displayName": "Nicolas Seiwald",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "2001-05-04"
    },
    "baumgartner": {
        "displayName": "Christoph Baumgartner",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1999-08-01"
    },
    "haidara": {
        "displayName": "Amadou Haidara",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Mali",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1998-01-31"
    },
    "xaverschlager": {
        "displayName": "Xaver Schlager",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 24,
        "dateofbirth": "1997-09-28"
    },
    "banzuzi": {
        "displayName": "Ezechiel Banzuzi",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2005-01-31"
    },
    "ouedraogo": {
        "displayName": "Assan Ouédraogo",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2006-05-09"
    },
    "maksimovic": {
        "displayName": "Andrija Maksimović",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2007-06-05"
    },
    "kampl": {
        "displayName": "Kevin Kampl",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 44,
        "dateofbirth": "1990-10-09"
    },
    "bakayoko": {
        "displayName": "Johan Bakayoko",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Belgium",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-04-20"
    },
    "nusa": {
        "displayName": "Antonio Nusa",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Norway",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2005-04-17"
    },
    "yandiomande": {
        "displayName": "Yan Diomande",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 49,
        "dateofbirth": "2006-05-04"
    },
    "romulo": {
        "displayName": "Rômulo Cardoso",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Brazil",
        "position": "Forward",
        "number": 40,
        "dateofbirth": "2002-02-08"
    },
    "harder": {
        "displayName": "Conrad Harder",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Denmark",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2005-04-07"
    },
    "werner": {
        "displayName": "Timo Werner",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 36,
        "dateofbirth": "1996-03-06"
    },
    "gomis": {
        "displayName": "Tidiam Gomis",
        "club": "RB Leipzig",
        "league": "Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2006-08-08"
    },
    "stanek": {
        "displayName": "Jindřich Staněk",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 36,
        "dateofbirth": "1996-04-27"
    },
    "jakubmarkovic": {
        "displayName": "Jakub Markovič",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 35,
        "dateofbirth": "2001-07-13"
    },
    "kolar": {
        "displayName": "Ondřej Kolář",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1994-10-17"
    },
    "ogbu": {
        "displayName": "Igoh Ogbu",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-02-08"
    },
    "zima": {
        "displayName": "David Zima",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-11-08"
    },
    "chaloupek": {
        "displayName": "Štěpán Chaloupek",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2003-03-08"
    },
    "vlcek": {
        "displayName": "Tomáš Vlček",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "2001-02-28"
    },
    "holes": {
        "displayName": "Tomáš Holeš",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1993-03-31"
    },
    "boril": {
        "displayName": "Jan Bořil",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1991-01-11"
    },
    "hashioka": {
        "displayName": "Daiki Hashioka",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Japan",
        "position": "Defender",
        "number": 8,
        "dateofbirth": "1999-05-17"
    },
    "mbodji": {
        "displayName": "Youssoupha Mbodji",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Senegal",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2004-03-01"
    },
    "zmrzly": {
        "displayName": "Ondřej Zmrzlý",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1999-04-22"
    },
    "zafeiris": {
        "displayName": "Christos Zafeiris",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Greece",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2003-02-23"
    },
    "provod": {
        "displayName": "Lukáš Provod",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "1996-10-23"
    },
    "sadilek": {
        "displayName": "Michal Sadílek",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1999-05-31"
    },
    "moses": {
        "displayName": "David Moses",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2004-01-20"
    },
    "dorley": {
        "displayName": "Oscar Dorley",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Liberia",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1998-07-19"
    },
    "doudera": {
        "displayName": "David Douděra",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1998-05-31"
    },
    "muhammed_cham": {
        "displayName": "Muhammed Cham",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "2000-09-26"
    },
    "kusej": {
        "displayName": "Vasil Kušej",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-05-24"
    },
    "chytil": {
        "displayName": "Mojmír Chytil",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 13,
        "dateofbirth": "1999-04-29"
    },
    "chory": {
        "displayName": "Tomáš Chorý",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "1995-01-26"
    },
    "schranz": {
        "displayName": "Ivan Schranz",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Forward",
        "number": 26,
        "dateofbirth": "1993-09-13"
    },
    "prekop": {
        "displayName": "Erik Prekop",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Forward",
        "number": 31,
        "dateofbirth": "1997-10-08"
    },
    "sanyang": {
        "displayName": "Youssoupha Sanyang",
        "club": "Slavia Prague",
        "league": "Chance Liga",
        "country": "Gambia",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2005-09-02"
    },
    "jedlicka": {
        "displayName": "Martin Jedlička",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 23,
        "dateofbirth": "1998-01-24"
    },
    "wiegele": {
        "displayName": "Florian Wiegele",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2001-03-21"
    },
    "tvrdon": {
        "displayName": "Marián Tvrdoň",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 13,
        "dateofbirth": "1994-08-18"
    },
    "silhavy": {
        "displayName": "Matyáš Šilhavý",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 15,
        "dateofbirth": "2007-03-06"
    },
    "dweh": {
        "displayName": "Sampson Dweh",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Liberia",
        "position": "Defender",
        "number": 40,
        "dateofbirth": "2001-10-10"
    },
    "svetmarkovic": {
        "displayName": "Svetozar Marković",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Serbia",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-03-23"
    },
    "spacil": {
        "displayName": "Karel Spáčil",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-05-18"
    },
    "paluska": {
        "displayName": "Jan Paluska",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2005-06-23"
    },
    "jemelka": {
        "displayName": "Václav Jemelka",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1995-06-23"
    },
    "hejda": {
        "displayName": "Lukáš Hejda",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1990-03-09"
    },
    "doski": {
        "displayName": "Merchas Doski",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Iraq",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "1999-12-07"
    },
    "havel": {
        "displayName": "Milan Havel",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1994-08-07"
    },
    "zeljkovic": {
        "displayName": "Adrian Zeljković",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 85,
        "dateofbirth": "2002-08-19"
    },
    "cerv": {
        "displayName": "Lukáš Červ",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2001-04-10"
    },
    "panos": {
        "displayName": "Jiří Panoš",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2007-11-15"
    },
    "valenta": {
        "displayName": "Matěj Valenta",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2000-02-09"
    },
    "memic": {
        "displayName": "Amar Memić",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 99,
        "dateofbirth": "2001-01-20"
    },
    "kopic": {
        "displayName": "Jan Kopic",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1990-06-04"
    },
    "souare": {
        "displayName": "Cheick Souaré",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "France",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "2002-09-03"
    },
    "visinsky": {
        "displayName": "Denis Višinský",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 9,
        "dateofbirth": "2003-03-21"
    },
    "ladra": {
        "displayName": "Tomáš Ladra",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1997-04-24"
    },
    "durosinmi": {
        "displayName": "Rafiu Durosinmi",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2003-01-01"
    },
    "princeadu": {
        "displayName": "Prince Adu",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Ghana",
        "position": "Forward",
        "number": 80,
        "dateofbirth": "2003-09-23"
    },
    "vydra": {
        "displayName": "Matěj Vydra",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1992-05-01"
    },
    "kabongo": {
        "displayName": "Christophe Kabongo",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-08-27"
    },
    "bello": {
        "displayName": "James Bello",
        "club": "Viktoria Plzeň",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Forward",
        "number": 72,
        "dateofbirth": "2005-05-01"
    },
    "peter_vindahl": {
        "displayName": "Peter Vindahl",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Denmark",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1998-02-16"
    },
    "jakub_surovcik": {
        "displayName": "Jakub Surovčík",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2002-06-28"
    },
    "vojtech_vorel": {
        "displayName": "Vojtěch Vorel",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 18,
        "dateofbirth": "1996-06-18"
    },
    "daniel_kerl": {
        "displayName": "Daniel Kerl",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 61,
        "dateofbirth": "2001-11-20"
    },
    "filip_panak": {
        "displayName": "Filip Panák",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 27,
        "dateofbirth": "1995-11-02"
    },
    "asger_sorensen": {
        "displayName": "Asger Sørensen",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Denmark",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1996-06-05"
    },
    "elias_cobbaut": {
        "displayName": "Elias Cobbaut",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Belgium",
        "position": "Defender",
        "number": 33,
        "dateofbirth": "1997-11-24"
    },
    "pavel_kaderabek": {
        "displayName": "Pavel Kadeřábek",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1992-04-25"
    },
    "angelo_preciado": {
        "displayName": "Ángelo Preciado",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Ecuador",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1998-02-18"
    },
    "jakub_martinec": {
        "displayName": "Jakub Martinec",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-03-13"
    },
    "emmanuel_uchenna": {
        "displayName": "Emmanuel Uchenna",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Nigeria",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "2003-05-18"
    },
    "jaroslav_zeleny": {
        "displayName": "Jaroslav Zelený",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1992-08-20"
    },
    "kaan_kairinen": {
        "displayName": "Kaan Kairinen",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Finland",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1998-12-22"
    },
    "sivert_mannsverk": {
        "displayName": "Sivert Mannsverk",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Norway",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2002-05-08"
    },
    "patrik_vydra": {
        "displayName": "Patrik Vydra",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2003-06-20"
    },
    "matej_rynes": {
        "displayName": "Matěj Ryneš",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2001-05-30"
    },
    "lukas_sadilek": {
        "displayName": "Lukáš Sadílek",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1996-05-23"
    },
    "magnus_kofod_andersen": {
        "displayName": "Magnus Kofod Andersen",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1999-05-10"
    },
    "santiago_eneme": {
        "displayName": "Santiago Eneme",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Equatorial Guinea",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2000-09-29"
    },
    "albion_rrahmani": {
        "displayName": "Albion Rrahmani",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Kosovo",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-08-31"
    },
    "jan_kuchta": {
        "displayName": "Jan Kuchta",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Czech Republic",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-01-08"
    },
    "lukas_haraslin": {
        "displayName": "Lukáš Haraslín",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Slovakia",
        "position": "Forward",
        "number": 22,
        "dateofbirth": "1996-05-26"
    },
    "veljko_birmancevic": {
        "displayName": "Veljko Birmančević",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Serbia",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1998-03-05"
    },
    "john_mercado": {
        "displayName": "John Mercado",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Ecuador",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-06-03"
    },
    "garang_kuol": {
        "displayName": "Garang Kuol",
        "club": "Sparta Prague",
        "league": "Chance Liga",
        "country": "Australia",
        "position": "Forward",
        "number": 36,
        "dateofbirth": "2004-09-15"
    },
    "haikin": {
        "displayName": "Nikita Haikin",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Russia",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1995-07-11"
    },
    "fayelund": {
        "displayName": "Julian Faye Lund",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-05-20"
    },
    "brondbo": {
        "displayName": "Magnus Brøndbo",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Goalkeeper",
        "number": 44,
        "dateofbirth": "2005-03-02"
    },
    "bjorkan": {
        "displayName": "Fredrik André Bjørkan",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1998-08-21"
    },
    "sjovold": {
        "displayName": "Fredrik Sjøvold",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2003-08-17"
    },
    "bjortuft": {
        "displayName": "Odin Bjørtuft",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-12-19"
    },
    "gundersen": {
        "displayName": "Jostein Gundersen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1996-04-02"
    },
    "maatta": {
        "displayName": "Isak Dybvik Määttä",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2001-09-19"
    },
    "villadsnielsen": {
        "displayName": "Villads Nielsen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Denmark",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2005-01-29"
    },
    "aleesami": {
        "displayName": "Haitam Aleesami",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1991-07-31"
    },
    "patrickberg": {
        "displayName": "Patrick Berg",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1997-11-24"
    },
    "saltnes": {
        "displayName": "Ulrik Saltnes",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1992-11-10"
    },
    "auklend": {
        "displayName": "Sondre Auklend",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2003-06-10"
    },
    "evjen": {
        "displayName": "Håkon Evjen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2000-02-14"
    },
    "brunstadfet": {
        "displayName": "Sondre Brunstad Fet",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1997-01-17"
    },
    "riisnaes": {
        "displayName": "Magnus Bech Riisnæs",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "2004-11-04"
    },
    "klynge": {
        "displayName": "Anders Klynge",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2000-10-14"
    },
    "jenshauge": {
        "displayName": "Jens Petter Hauge",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1999-10-12"
    },
    "kasperhogh": {
        "displayName": "Kasper Høgh",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Denmark",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-12-06"
    },
    "mathiasjorgensen": {
        "displayName": "Mathias Jørgensen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Denmark",
        "position": "Forward",
        "number": 30,
        "dateofbirth": "2000-09-20"
    },
    "blomberg": {
        "displayName": "Ole Didrik Blomberg",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-06-12"
    },
    "helmersen": {
        "displayName": "Andreas Helmersen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "1998-03-15"
    },
    "bassi": {
        "displayName": "Daniel Bassi",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Norway",
        "position": "Forward",
        "number": 24,
        "dateofbirth": "2004-10-31"
    },
    "brohansen": {
        "displayName": "Mikkel Bro Hansen",
        "club": "FK Bodø/Glimt",
        "league": "Eliteserien",
        "country": "Denmark",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2009-01-25"
    },
    "alexschlager": {
        "displayName": "Alexander Schlager",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1996-02-01"
    },
    "zawieschitzky": {
        "displayName": "Christian Zawieschitzky",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 52,
        "dateofbirth": "2007-05-02"
    },
    "hamzic": {
        "displayName": "Salko Hamzic",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 92,
        "dateofbirth": "2006-09-17"
    },
    "gadou": {
        "displayName": "Joane Gadou",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "France",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2007-01-17"
    },
    "jacobrasmussen": {
        "displayName": "Jacob Rasmussen",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Denmark",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-05-28"
    },
    "chase": {
        "displayName": "Anrie Chase",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Japan",
        "position": "Defender",
        "number": 91,
        "dateofbirth": "2004-03-24"
    },
    "terzic": {
        "displayName": "Aleksa Terzić",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Serbia",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-08-17"
    },
    "kratzig": {
        "displayName": "Frans Krätzig",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "2003-01-14"
    },
    "lainer": {
        "displayName": "Stefan Lainer",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "1992-08-27"
    },
    "mellberg": {
        "displayName": "John Mellberg",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Sweden",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2006-07-30"
    },
    "bidstrup": {
        "displayName": "Mads Bidstrup",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "2001-02-25"
    },
    "kjaergaard": {
        "displayName": "Maurits Kjærgaard",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2003-06-26"
    },
    "diabate": {
        "displayName": "Soumaïla Diabaté",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Mali",
        "position": "Midfielder",
        "number": 5,
        "dateofbirth": "2004-11-22"
    },
    "gourna_douath": {
        "displayName": "Lucas Gourna-Douath",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "France",
        "position": "Midfielder",
        "number": 29,
        "dateofbirth": "2003-08-05"
    },
    "kawamura": {
        "displayName": "Takumu Kawamura",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Japan",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1999-08-28"
    },
    "alajbegovic": {
        "displayName": "Kerim Alajbegović",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Bosnia and Herzegovina",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2007-09-21"
    },
    "karimkonate": {
        "displayName": "Karim Konaté",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Ivory Coast",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2004-03-21"
    },
    "ratkov": {
        "displayName": "Petar Ratkov",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Serbia",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2003-08-18"
    },
    "vertessen": {
        "displayName": "Yorbe Vertessen",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-01-08"
    },
    "edmundbaidoo": {
        "displayName": "Edmund Baidoo",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Ghana",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2006-01-30"
    },
    "onisiwo": {
        "displayName": "Karim Onisiwo",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1992-03-17"
    },
    "kitano": {
        "displayName": "Sota Kitano",
        "club": "Red Bull Salzburg",
        "league": "Austrian Bundesliga",
        "country": "Japan",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2004-08-13"
    },
    "oliverchristensen": {
        "displayName": "Oliver Christensen",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Denmark",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1999-03-22"
    },
    "khudyakov": {
        "displayName": "Daniil Khudyakov",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Russia",
        "position": "Goalkeeper",
        "number": 53,
        "dateofbirth": "2004-01-09"
    },
    "bignetti": {
        "displayName": "Matteo Bignetti",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "2004-05-06"
    },
    "lavalee": {
        "displayName": "Dimitri Lavalée",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Belgium",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "1997-01-13"
    },
    "oermann": {
        "displayName": "Tim Oermann",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2003-10-06"
    },
    "aiwu": {
        "displayName": "Emanuel Aiwu",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 47,
        "dateofbirth": "2000-12-25"
    },
    "karic": {
        "displayName": "Emir Karić",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1997-06-09"
    },
    "gazibegovic": {
        "displayName": "Jusuf Gazibegović",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2000-03-11"
    },
    "malic": {
        "displayName": "Arjan Malić",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Slovenia",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2005-08-28"
    },
    "geyrhofer": {
        "displayName": "Niklas Geyrhofer",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Defender",
        "number": 35,
        "dateofbirth": "2000-02-11"
    },
    "mitchell": {
        "displayName": "Jeyland Mitchell",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Costa Rica",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2004-09-29"
    },
    "jonstankovic": {
        "displayName": "Jon Gorenc Stankovič",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1996-01-14"
    },
    "kiteishvili": {
        "displayName": "Otar Kiteishvili",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Georgia",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1996-03-26"
    },
    "horvat": {
        "displayName": "Tomi Horvat",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1999-03-24"
    },
    "chukwuani": {
        "displayName": "Tochi Chukwuani",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Denmark",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2003-03-24"
    },
    "rozga": {
        "displayName": "Filip Rózga",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Poland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2006-08-07"
    },
    "hierlander": {
        "displayName": "Stefan Hierländer",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Midfielder",
        "number": 25,
        "dateofbirth": "1991-02-03"
    },
    "malone": {
        "displayName": "Maurice Malone",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Germany",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "2000-08-17"
    },
    "jatta": {
        "displayName": "Seedy Jatta",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Norway",
        "position": "Forward",
        "number": 20,
        "dateofbirth": "2003-03-18"
    },
    "grgic": {
        "displayName": "Leon Grgić",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "Austria",
        "position": "Forward",
        "number": 38,
        "dateofbirth": "2006-01-22"
    },
    "kayombo": {
        "displayName": "Axel Kayombo",
        "club": "Sturm Graz",
        "league": "Austrian Bundesliga",
        "country": "France",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2006-02-25"
    },
    "unnerstall": {
        "displayName": "Lars Unnerstall",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1990-07-20"
    },
    "elmaach": {
        "displayName": "Issam El Maach",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Goalkeeper",
        "number": 16,
        "dateofbirth": "2000-02-01"
    },
    "tyton": {
        "displayName": "Przemysław Tytoń",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1987-01-04"
    },
    "karssies": {
        "displayName": "Sam Karssies",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 21,
        "dateofbirth": "2003-02-26"
    },
    "hilgers": {
        "displayName": "Mees Hilgers",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Indonesia",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2001-05-13"
    },
    "propper": {
        "displayName": "Robin Pröpper",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1993-09-23"
    },
    "vanrooij": {
        "displayName": "Bart van Rooij",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 28,
        "dateofbirth": "2001-05-26"
    },
    "matsrots": {
        "displayName": "Mats Rots",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2006-03-11"
    },
    "baskuipers": {
        "displayName": "Bas Kuipers",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1994-08-17"
    },
    "maxbruns": {
        "displayName": "Max Bruns",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 38,
        "dateofbirth": "2002-11-06"
    },
    "lemkin": {
        "displayName": "Stav Lemkin",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Israel",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "2003-04-02"
    },
    "peixoto": {
        "displayName": "Guilherme Peixoto",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Portugal",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "2006-05-25"
    },
    "zerrouki": {
        "displayName": "Ramiz Zerrouki",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Algeria",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1998-05-26"
    },
    "vandenbelt": {
        "displayName": "Thomas van den Belt",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2001-06-18"
    },
    "hlynsson": {
        "displayName": "Kristian Hlynsson",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Iceland",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2004-01-23"
    },
    "kjolo": {
        "displayName": "Mathias Kjølø",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Norwegian",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "2001-06-27"
    },
    "verschueren": {
        "displayName": "Arno Verschueren",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "1997-04-08"
    },
    "weidmann": {
        "displayName": "Daouda Weidmann",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "France",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "2003-05-04"
    },
    "orjasaeter": {
        "displayName": "Sondre Ørjasæter",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Norway",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2003-11-28"
    },
    "lammers": {
        "displayName": "Sam Lammers",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1997-04-30"
    },
    "daanrots": {
        "displayName": "Daan Rots",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-07-25"
    },
    "vanwolfswinkel": {
        "displayName": "Ricky van Wolfswinkel",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1989-01-27"
    },
    "pjaca": {
        "displayName": "Marko Pjaca",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "Croatia",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1995-05-06"
    },
    "booth": {
        "displayName": "Taylor Booth",
        "club": "FC Twente",
        "league": "Eredivisie",
        "country": "United States",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2001-05-31"
    },
    "bijlow": {
        "displayName": "Justin Bijlow",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1998-01-22"
    },
    "wellenreuther": {
        "displayName": "Timon Wellenreuther",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1995-12-03"
    },
    "bossin": {
        "displayName": "Liam Bossin",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Ireland",
        "position": "Goalkeeper",
        "number": 39,
        "dateofbirth": "1996-07-15"
    },
    "ahmedhodzic": {
        "displayName": "Anel Ahmedhodžić",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Bosnia and Herzegovina",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1999-03-26"
    },
    "beelen": {
        "displayName": "Thomas Beelen",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2001-06-07"
    },
    "watanabe": {
        "displayName": "Tsuyoshi Watanabe",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-02-05"
    },
    "trauner": {
        "displayName": "Gernot Trauner",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Austria",
        "position": "Defender",
        "number": 18,
        "dateofbirth": "1992-03-25"
    },
    "jordanbos": {
        "displayName": "Jordan Bos",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Australia",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2002-10-29"
    },
    "smal": {
        "displayName": "Gijs Smal",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1997-08-31"
    },
    "lotomba": {
        "displayName": "Jordan Lotomba",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Switzerland",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "1998-09-29"
    },
    "nieuwkoop": {
        "displayName": "Bart Nieuwkoop",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-03-07"
    },
    "quintentimber": {
        "displayName": "Quinten Timber",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2001-06-17"
    },
    "semsteijn": {
        "displayName": "Sem Steijn",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "2001-11-12"
    },
    "hwang": {
        "displayName": "Hwang In-beom",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "South Korea",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1996-09-20"
    },
    "moder": {
        "displayName": "Jakub Moder",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Poland",
        "position": "Midfielder",
        "number": 7,
        "dateofbirth": "1999-04-07"
    },
    "valente": {
        "displayName": "Luciano Valente",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 40,
        "dateofbirth": "2003-10-04"
    },
    "targhalline": {
        "displayName": "Oussama Targhalline",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2002-05-20"
    },
    "ueda": {
        "displayName": "Ayase Ueda",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-08-28"
    },
    "hadjmoussa": {
        "displayName": "Anis Hadj Moussa",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Algeria",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2002-02-11"
    },
    "borges": {
        "displayName": "Gonçalo Borges",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Portugal",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2001-03-29"
    },
    "tengstedt": {
        "displayName": "Casper Tengstedt",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2000-06-01"
    },
    "larin": {
        "displayName": "Cyle Larin",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Canada",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1995-04-17"
    },
    "sauer": {
        "displayName": "Leo Sauer",
        "club": "Feyenoord",
        "league": "Eredivisie",
        "country": "Slovakia",
        "position": "Forward",
        "number": 16,
        "dateofbirth": "2005-12-16"
    },
    "owusuoduro": {
        "displayName": "Rome-Jayden Owusu-Oduro",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2004-07-02"
    },
    "jeroenzoet": {
        "displayName": "Jeroen Zoet",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "1991-01-06"
    },
    "verhulst": {
        "displayName": "Hobie Verhulst",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "1993-04-02"
    },
    "woutergoes": {
        "displayName": "Wouter Goes",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2004-06-10"
    },
    "penetra": {
        "displayName": "Alexandre Penetra",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Portugal",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2001-09-09"
    },
    "kasius": {
        "displayName": "Denso Kasius",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2002-10-06"
    },
    "mateochavez": {
        "displayName": "Mateo Chávez",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Mexico",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2004-05-12"
    },
    "maikuma": {
        "displayName": "Seiya Maikuma",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-10-16"
    },
    "maximdekker": {
        "displayName": "Maxim Dekker",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2004-04-21"
    },
    "andreanatali": {
        "displayName": "Andrea Natali",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Italy",
        "position": "Defender",
        "number": 14,
        "dateofbirth": "2008-01-28"
    },
    "dijkstra": {
        "displayName": "Elijah Dijkstra",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 22,
        "dateofbirth": "2006-08-05"
    },
    "mijnans": {
        "displayName": "Sven Mijnans",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-03-09"
    },
    "peerkoopmeiners": {
        "displayName": "Peer Koopmeiners",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2000-05-04"
    },
    "keessmit": {
        "displayName": "Kees Smit",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 26,
        "dateofbirth": "2006-01-20"
    },
    "jordyclasie": {
        "displayName": "Jordy Clasie",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1991-06-27"
    },
    "matejsin": {
        "displayName": "Matěj Šín",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Czech Republic",
        "position": "Midfielder",
        "number": 33,
        "dateofbirth": "2004-06-02"
    },
    "davekwakman": {
        "displayName": "Dave Kwakman",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "2004-06-07"
    },
    "troyparrott": {
        "displayName": "Troy Parrott",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Ireland",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2002-02-04"
    },
    "weslleypatati": {
        "displayName": "Weslley Patati",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2003-10-01"
    },
    "mexxmeerdink": {
        "displayName": "Mexx Meerdink",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 35,
        "dateofbirth": "2003-07-24"
    },
    "ibrahimsadiq": {
        "displayName": "Ibrahim Sadiq",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Ghana",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2000-06-14"
    },
    "isakjensen": {
        "displayName": "Isak Jensen",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2003-07-15"
    },
    "zeefuik": {
        "displayName": "Lequincio Zeefuik",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "2004-11-26"
    },
    "rozangelodaal": {
        "displayName": "Ro-Zangelo Daal",
        "club": "AZ Alkmaar",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "2004-04-16"
    },
    "jaros": {
        "displayName": "Vítězslav Jaroš",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "2001-07-23"
    },
    "heerkens": {
        "displayName": "Joeri Heerkens",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "2006-03-04"
    },
    "pasveer": {
        "displayName": "Remko Pasveer",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 22,
        "dateofbirth": "1983-11-08"
    },
    "tomiyasu": {
        "displayName": "Takehiro Tomiyasu",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "1998-11-05"
    },
    "itakura": {
        "displayName": "Ko Itakura",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Japan",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1997-01-27"
    },
    "sutalo": {
        "displayName": "Josip Šutalo",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Croatia",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2000-02-28"
    },
    "baas": {
        "displayName": "Youri Baas",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "2003-03-17"
    },
    "wijndal": {
        "displayName": "Owen Wijndal",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1999-11-28"
    },
    "gaaei": {
        "displayName": "Anton Gaaei",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2002-11-19"
    },
    "lucasrosa": {
        "displayName": "Lucas Rosa",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1999-04-03"
    },
    "bouwman": {
        "displayName": "Aaron Bouwman",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 30,
        "dateofbirth": "2007-11-04"
    },
    "taylor": {
        "displayName": "Kenneth Taylor",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-05-16"
    },
    "gloukh": {
        "displayName": "Oscar Gloukh",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Israel",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2004-04-01"
    },
    "regeer": {
        "displayName": "Youri Regeer",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "2003-08-18"
    },
    "klaassen": {
        "displayName": "Davy Klaassen",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1993-02-21"
    },
    "vandenboomen": {
        "displayName": "Branco van den Boomen",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 21,
        "dateofbirth": "1995-07-21"
    },
    "mcconnell": {
        "displayName": "James McConnell",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "England",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2004-09-13"
    },
    "fitzjim": {
        "displayName": "Kian Fitz-Jim",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2003-07-05"
    },
    "godts": {
        "displayName": "Mika Godts",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Belgium",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2005-06-07"
    },
    "dolberg": {
        "displayName": "Kasper Dolberg",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Denmark",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-10-06"
    },
    "raulmoro": {
        "displayName": "Raúl Moro",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Spain",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2002-12-05"
    },
    "berghuis": {
        "displayName": "Steven Berghuis",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "1991-12-19"
    },
    "weghorst": {
        "displayName": "Wout Weghorst",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 25,
        "dateofbirth": "1992-08-07"
    },
    "konadu": {
        "displayName": "Don-Angelo Konadu",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-12-16"
    },
    "olij": {
        "displayName": "Nick Olij",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-08-01"
    },
    "kovar": {
        "displayName": "Matěj Kovář",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "2000-05-17"
    },
    "schiks": {
        "displayName": "Niek Schiks",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Goalkeeper",
        "number": 24,
        "dateofbirth": "2004-02-03"
    },
    "yarek": {
        "displayName": "Yarek Gasiorowski",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Spain",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2005-01-12"
    },
    "flamingo": {
        "displayName": "Ryan Flamingo",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2002-12-31"
    },
    "dest": {
        "displayName": "Sergiño Dest",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "United States",
        "position": "Defender",
        "number": 8,
        "dateofbirth": "2000-11-03"
    },
    "sildillia": {
        "displayName": "Kiliann Sildillia",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "France",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2002-05-16"
    },
    "obispo": {
        "displayName": "Armando Obispo",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1999-03-05"
    },
    "maurojunior": {
        "displayName": "Mauro Júnior",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Brazil",
        "position": "Defender",
        "number": 17,
        "dateofbirth": "1999-05-06"
    },
    "nagalo": {
        "displayName": "Adamo Nagalo",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Burkina Faso",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2002-09-22"
    },
    "salah_eddine": {
        "displayName": "Anass Salah-Eddine",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "2002-01-18"
    },
    "schouten": {
        "displayName": "Jerdy Schouten",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1997-01-12"
    },
    "veerman": {
        "displayName": "Joey Veerman",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1998-11-19"
    },
    "saibari": {
        "displayName": "Ismael Saibari",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Midfielder",
        "number": 34,
        "dateofbirth": "2001-01-28"
    },
    "wanner": {
        "displayName": "Paul Wanner",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Germany",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2005-12-23"
    },
    "til": {
        "displayName": "Guus Til",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1997-12-22"
    },
    "vanbommel": {
        "displayName": "Ruben van Bommel",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "2004-08-03"
    },
    "pepi": {
        "displayName": "Ricardo Pepi",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "United States",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2003-01-09"
    },
    "dennisman": {
        "displayName": "Dennis Man",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Romania",
        "position": "Forward",
        "number": 27,
        "dateofbirth": "1998-08-26"
    },
    "perisic": {
        "displayName": "Ivan Perišić",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Croatia",
        "position": "Forward",
        "number": 5,
        "dateofbirth": "1989-02-02"
    },
    "plea": {
        "displayName": "Alassane Pléa",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "France",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1993-03-10"
    },
    "boadu": {
        "displayName": "Myron Boadu",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Netherlands",
        "position": "Forward",
        "number": 21,
        "dateofbirth": "2001-01-14"
    },
    "driouech": {
        "displayName": "Couhaib Driouech",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Morocco",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "2002-04-17"
    },
    "bajraktarevic": {
        "displayName": "Esmir Bajraktarević",
        "club": "PSV Eindhoven",
        "league": "Eredivisie",
        "country": "Bosnia and Herzegovina",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "2005-03-10"
    },
    "lafont": {
        "displayName": "Alban Lafont",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "France",
        "position": "Goalkeeper",
        "number": 40,
        "dateofbirth": "1999-01-23"
    },
    "dragowski": {
        "displayName": "Bartłomiej Drągowski",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Poland",
        "position": "Goalkeeper",
        "number": 69,
        "dateofbirth": "1997-08-19"
    },
    "kotsaris": {
        "displayName": "Konstantinos Kotsaris",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 70,
        "dateofbirth": "1996-07-25"
    },
    "calabria": {
        "displayName": "Davide Calabria",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1996-12-06"
    },
    "touba": {
        "displayName": "Ahmed Touba",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Algeria",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1998-03-13"
    },
    "kyriakopoulos": {
        "displayName": "Georgios Kyriakopoulos",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 77,
        "dateofbirth": "1996-02-05"
    },
    "jedvaj": {
        "displayName": "Tin Jedvaj",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1995-11-28"
    },
    "ingason": {
        "displayName": "Sverrir Ingi Ingason",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Iceland",
        "position": "Defender",
        "number": 15,
        "dateofbirth": "1993-08-05"
    },
    "max": {
        "displayName": "Philipp Max",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Germany",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1993-09-30"
    },
    "mladenovic": {
        "displayName": "Filip Mladenović",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "1991-08-15"
    },
    "chirivella": {
        "displayName": "Pedro Chirivella",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Spain",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1997-05-23"
    },
    "renatosanches": {
        "displayName": "Renato Sanches",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1997-08-18"
    },
    "siopis": {
        "displayName": "Manolis Siopis",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1994-05-14"
    },
    "cerin": {
        "displayName": "Adam Gnezda Čerin",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Slovenia",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "1999-07-16"
    },
    "bakasetas": {
        "displayName": "Anastasios Bakasetas",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1993-06-28"
    },
    "taborda": {
        "displayName": "Vicente Taborda",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "2001-06-14"
    },
    "tete": {
        "displayName": "Tetê",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2000-02-15"
    },
    "pellistri": {
        "displayName": "Facundo Pellistri",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Uruguay",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2001-12-20"
    },
    "swiderski": {
        "displayName": "Karol Świderski",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Poland",
        "position": "Forward",
        "number": 19,
        "dateofbirth": "1997-01-23"
    },
    "dessers": {
        "displayName": "Cyriel Dessers",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Nigeria",
        "position": "Forward",
        "number": 33,
        "dateofbirth": "1994-12-08"
    },
    "zaroury": {
        "displayName": "Anass Zaroury",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Morocco",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2000-11-07"
    },
    "pantovic": {
        "displayName": "Miloš Pantović",
        "club": "Panathinaikos",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Forward",
        "number": 72,
        "dateofbirth": "1996-07-07"
    },
    "pavlenka": {
        "displayName": "Jiří Pavlenka",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Czech Republic",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1992-04-14"
    },
    "gugeshashvili": {
        "displayName": "Luka Gugeshashvili",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Georgia",
        "position": "Goalkeeper",
        "number": 88,
        "dateofbirth": "1999-04-29"
    },
    "tsiftsis": {
        "displayName": "Antonis Tsiftsis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 99,
        "dateofbirth": "1999-07-21"
    },
    "monastirlis": {
        "displayName": "Dimitrios Monastirlis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 41,
        "dateofbirth": "2004-03-22"
    },
    "vogliacco": {
        "displayName": "Alessandro Vogliacco",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "1998-09-14"
    },
    "michailidis": {
        "displayName": "Giannis Michailidis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2000-02-18"
    },
    "lovren": {
        "displayName": "Dejan Lovren",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1989-07-05"
    },
    "kedziora": {
        "displayName": "Tomasz Kędziora",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Poland",
        "position": "Defender",
        "number": 16,
        "dateofbirth": "1994-06-11"
    },
    "baba": {
        "displayName": "Abdul Rahman Baba",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Ghana",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1994-07-02"
    },
    "gregtaylor": {
        "displayName": "Greg Taylor",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Scotland",
        "position": "Defender",
        "number": 32,
        "dateofbirth": "1997-11-05"
    },
    "jonjoekenny": {
        "displayName": "Jonjoe Kenny",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1997-03-15"
    },
    "sastre": {
        "displayName": "Joan Sastre",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Spain",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1997-04-30"
    },
    "konstantelias": {
        "displayName": "Giannis Konstantelias",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 65,
        "dateofbirth": "2003-03-05"
    },
    "madycamara": {
        "displayName": "Mady Camara",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Guinea",
        "position": "Midfielder",
        "number": 2,
        "dateofbirth": "1997-02-28"
    },
    "meite": {
        "displayName": "Soualiho Meïté",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "France",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1994-03-17"
    },
    "pelkas": {
        "displayName": "Dimitrios Pelkas",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1993-10-26"
    },
    "ozdoev": {
        "displayName": "Magomed Ozdoev",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Russia",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1992-11-05"
    },
    "bianco": {
        "displayName": "Alessandro Bianco",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "2002-10-01"
    },
    "taison": {
        "displayName": "Taison",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "1988-01-13"
    },
    "zivkovic": {
        "displayName": "Andrija Živković",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1996-07-11"
    },
    "despodov": {
        "displayName": "Kiril Despodov",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Bulgaria",
        "position": "Forward",
        "number": 77,
        "dateofbirth": "1996-11-11"
    },
    "giakoumakis": {
        "displayName": "Giorgos Giakoumakis",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1994-12-09"
    },
    "chalov": {
        "displayName": "Fedor Chalov",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Russia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1998-04-10"
    },
    "ivanusec": {
        "displayName": "Luka Ivanušec",
        "club": "PAOK",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "1998-11-26"
    },
    "strakosha": {
        "displayName": "Thomas Strakosha",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Albania",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1995-03-19"
    },
    "brignoli": {
        "displayName": "Alberto Brignoli",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Goalkeeper",
        "number": 91,
        "dateofbirth": "1991-08-19"
    },
    "angelopoulos": {
        "displayName": "Angelos Angelopoulos",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 81,
        "dateofbirth": "2003-02-19"
    },
    "moukoudi": {
        "displayName": "Harold Moukoudi",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Cameroon",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1997-11-27"
    },
    "vida": {
        "displayName": "Domagoj Vida",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1989-04-29"
    },
    "filiperelvas": {
        "displayName": "Filipe Relvas",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Defender",
        "number": 44,
        "dateofbirth": "1999-09-20"
    },
    "rota": {
        "displayName": "Lazaros Rota",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 12,
        "dateofbirth": "1997-08-23"
    },
    "penrice": {
        "displayName": "James Penrice",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Scotland",
        "position": "Defender",
        "number": 29,
        "dateofbirth": "1998-12-22"
    },
    "pilios": {
        "displayName": "Stavros Pilios",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-12-10"
    },
    "pineda": {
        "displayName": "Orbelín Pineda",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Mexico",
        "position": "Midfielder",
        "number": 13,
        "dateofbirth": "1996-03-24"
    },
    "joaomario": {
        "displayName": "João Mario",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "1993-01-19"
    },
    "razvanmarin": {
        "displayName": "Răzvan Marin",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Romania",
        "position": "Midfielder",
        "number": 18,
        "dateofbirth": "1996-05-23"
    },
    "grujic": {
        "displayName": "Marko Grujić",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Midfielder",
        "number": 4,
        "dateofbirth": "1996-04-13"
    },
    "mantalos": {
        "displayName": "Petros Mantalos",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1991-08-31"
    },
    "eliasson": {
        "displayName": "Niclas Eliasson",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Sweden",
        "position": "Midfielder",
        "number": 19,
        "dateofbirth": "1995-12-07"
    },
    "kaloskamis": {
        "displayName": "Dimitrios Kaloskamis",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 17,
        "dateofbirth": "2005-03-01"
    },
    "ljubicic": {
        "displayName": "Robert Ljubičić",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Croatia",
        "position": "Midfielder",
        "number": 23,
        "dateofbirth": "1999-07-14"
    },
    "jovic": {
        "displayName": "Luka Jović",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Serbia",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1997-12-23"
    },
    "pierrot": {
        "displayName": "Frantzdy Pierrot",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Haiti",
        "position": "Forward",
        "number": 14,
        "dateofbirth": "1995-03-29"
    },
    "kutesa": {
        "displayName": "Dereck Kutesa",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Switzerland",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1997-12-06"
    },
    "koita": {
        "displayName": "Aboubakary Koïta",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Mauritania",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1998-09-20"
    },
    "zini": {
        "displayName": "Zini",
        "club": "AEK Athens",
        "league": "Super League Greece",
        "country": "Angola",
        "position": "Forward",
        "number": 90,
        "dateofbirth": "2002-07-03"
    },
    "tzolakis": {
        "displayName": "Konstantinos Tzolakis",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 88,
        "dateofbirth": "2002-11-08"
    },
    "paschalakis": {
        "displayName": "Alexandros Paschalakis",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1989-07-28"
    },
    "botis": {
        "displayName": "Nikolaos Botis",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "2004-03-31"
    },
    "kouraklis": {
        "displayName": "Georgios Kouraklis",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Goalkeeper",
        "number": 61,
        "dateofbirth": "2006-03-18"
    },
    "retsos": {
        "displayName": "Panagiotis Retsos",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 45,
        "dateofbirth": "1998-08-09"
    },
    "pirola": {
        "displayName": "Lorenzo Pirola",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Italy",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "2002-02-20"
    },
    "franortega": {
        "displayName": "Francisco Ortega",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "1999-03-19"
    },
    "rodinei": {
        "displayName": "Rodinei",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Defender",
        "number": 23,
        "dateofbirth": "1992-01-29"
    },
    "costinha": {
        "displayName": "Costinha",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "2000-03-26"
    },
    "biancone": {
        "displayName": "Giulian Biancone",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "France",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2000-03-31"
    },
    "onyemaechi": {
        "displayName": "Bruno Onyemaechi",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Nigeria",
        "position": "Defender",
        "number": 70,
        "dateofbirth": "1999-04-03"
    },
    "mancha": {
        "displayName": "Gustavo Mancha",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Defender",
        "number": 39,
        "dateofbirth": "2004-07-25"
    },
    "kalogeropoulos": {
        "displayName": "Alexis Kalogeropoulos",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "2004-07-26"
    },
    "hezze": {
        "displayName": "Santiago Hezze",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 32,
        "dateofbirth": "2001-10-22"
    },
    "chiquinho": {
        "displayName": "Chiquinho",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 22,
        "dateofbirth": "1995-07-19"
    },
    "danigarcia": {
        "displayName": "Dani García",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Spain",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1990-05-24"
    },
    "strefezza": {
        "displayName": "Gabriel Strefezza",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Brazil",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "1997-04-18"
    },
    "nascimento": {
        "displayName": "Diogo Nascimento",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-11-02"
    },
    "cabella": {
        "displayName": "Rémy Cabella",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "France",
        "position": "Midfielder",
        "number": 90,
        "dateofbirth": "1990-03-08"
    },
    "scipioni": {
        "displayName": "Lorenzo Scipioni",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Argentina",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2004-11-24"
    },
    "mouzakitis": {
        "displayName": "Christos Mouzakitis",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Greece",
        "position": "Midfielder",
        "number": 96,
        "dateofbirth": "2006-12-25"
    },
    "elkaabi": {
        "displayName": "Ayoub El Kaabi",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Morocco",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "1993-06-25"
    },
    "taremi": {
        "displayName": "Mehdi Taremi",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Iran",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1992-07-18"
    },
    "podence": {
        "displayName": "Daniel Podence",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Forward",
        "number": 56,
        "dateofbirth": "1995-10-21"
    },
    "gelonmartins": {
        "displayName": "Gelson Martins",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Portugal",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "1995-05-11"
    },
    "yaremchuk": {
        "displayName": "Roman Yaremchuk",
        "club": "Olympiacos",
        "league": "Super League Greece",
        "country": "Ukraine",
        "position": "Forward",
        "number": 11,
        "dateofbirth": "1995-11-27"
    },
    "schmeichel": {
        "displayName": "Kasper Schmeichel",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Denmark",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1986-11-05"
    },
    "sinisalo": {
        "displayName": "Viljami Sinisalo",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Finland",
        "position": "Goalkeeper",
        "number": 12,
        "dateofbirth": "2001-10-11"
    },
    "doohan": {
        "displayName": "Ross Doohan",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1998-03-29"
    },
    "cartervickers": {
        "displayName": "Cameron Carter-Vickers",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "United States",
        "position": "Defender",
        "number": 20,
        "dateofbirth": "1997-12-31"
    },
    "tierney": {
        "displayName": "Kieran Tierney",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 63,
        "dateofbirth": "1997-06-05"
    },
    "alistairjohnston": {
        "displayName": "Alistair Johnston",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Canada",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1998-10-08"
    },
    "scales": {
        "displayName": "Liam Scales",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Ireland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1998-08-08"
    },
    "trusty": {
        "displayName": "Auston Trusty",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "United States",
        "position": "Defender",
        "number": 6,
        "dateofbirth": "1998-08-12"
    },
    "simpsonpusey": {
        "displayName": "Jahmai Simpson-Pusey",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Defender",
        "number": 4,
        "dateofbirth": "2005-11-04"
    },
    "inamura": {
        "displayName": "Hayato Inamura",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Japan",
        "position": "Defender",
        "number": 25,
        "dateofbirth": "2002-05-06"
    },
    "saracchi": {
        "displayName": "Marcelo Saracchi",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Uruguay",
        "position": "Defender",
        "number": 36,
        "dateofbirth": "1998-04-23"
    },
    "mcgregor": {
        "displayName": "Callum McGregor",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 42,
        "dateofbirth": "1993-06-14"
    },
    "hatate": {
        "displayName": "Reo Hatate",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Japan",
        "position": "Midfielder",
        "number": 41,
        "dateofbirth": "1997-11-21"
    },
    "arneengels": {
        "displayName": "Arne Engels",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 27,
        "dateofbirth": "2003-09-08"
    },
    "mccowan": {
        "displayName": "Luke McCowan",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1997-12-09"
    },
    "bernardo": {
        "displayName": "Paulo Bernardo",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Portugal",
        "position": "Midfielder",
        "number": 28,
        "dateofbirth": "2002-01-24"
    },
    "jota": {
        "displayName": "Jota",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Portugal",
        "position": "Forward",
        "number": 7,
        "dateofbirth": "1999-03-30"
    },
    "iheanacho": {
        "displayName": "Kelechi Iheanacho",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Nigeria",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "1996-10-03"
    },
    "maeda": {
        "displayName": "Daizen Maeda",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Japan",
        "position": "Forward",
        "number": 38,
        "dateofbirth": "1997-10-20"
    },
    "nygren": {
        "displayName": "Benjamin Nygren",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Sweden",
        "position": "Forward",
        "number": 8,
        "dateofbirth": "2001-07-08"
    },
    "balikwisha": {
        "displayName": "Michel-Ange Balikwisha",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Belgium",
        "position": "Forward",
        "number": 10,
        "dateofbirth": "2001-05-10"
    },
    "yamada": {
        "displayName": "Shin Yamada",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Japan",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2000-05-30"
    },
    "forrest": {
        "displayName": "James Forrest",
        "club": "Celtic",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Forward",
        "number": 49,
        "dateofbirth": "1991-07-07"
    },
    "butland": {
        "displayName": "Jack Butland",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Goalkeeper",
        "number": 1,
        "dateofbirth": "1993-03-10"
    },
    "liamkelly": {
        "displayName": "Liam Kelly",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Goalkeeper",
        "number": 31,
        "dateofbirth": "1996-01-23"
    },
    "kieranwright": {
        "displayName": "Kieran Wright",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Goalkeeper",
        "number": 32,
        "dateofbirth": "1999-04-01"
    },
    "tavernier": {
        "displayName": "James Tavernier",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Defender",
        "number": 2,
        "dateofbirth": "1991-10-31"
    },
    "nsiala": {
        "displayName": "Clinton Nsiala",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "France",
        "position": "Defender",
        "number": 19,
        "dateofbirth": "2004-01-17"
    },
    "souttar": {
        "displayName": "John Souttar",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Defender",
        "number": 5,
        "dateofbirth": "1996-09-25"
    },
    "maxaarons": {
        "displayName": "Max Aarons",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Defender",
        "number": 3,
        "dateofbirth": "2000-01-04"
    },
    "djiga": {
        "displayName": "Nasser Djiga",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Burkina Faso",
        "position": "Defender",
        "number": 24,
        "dateofbirth": "2002-11-15"
    },
    "derekcornelius": {
        "displayName": "Derek Cornelius",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Canada",
        "position": "Defender",
        "number": 13,
        "dateofbirth": "1997-11-25"
    },
    "sterling": {
        "displayName": "Dujon Sterling",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Defender",
        "number": 21,
        "dateofbirth": "1999-10-24"
    },
    "fernandez": {
        "displayName": "Emmanuel Fernandez",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Defender",
        "number": 37,
        "dateofbirth": "2001-11-20"
    },
    "raskin": {
        "displayName": "Nicolas Raskin",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Belgium",
        "position": "Midfielder",
        "number": 43,
        "dateofbirth": "2001-02-23"
    },
    "barron": {
        "displayName": "Connor Barron",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "2002-08-29"
    },
    "mo_diomande": {
        "displayName": "Mohamed Diomandé",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Ivory Coast",
        "position": "Midfielder",
        "number": 10,
        "dateofbirth": "2001-10-30"
    },
    "aasgaard": {
        "displayName": "Thelo Aasgaard",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Norway",
        "position": "Midfielder",
        "number": 11,
        "dateofbirth": "2002-05-02"
    },
    "bajrami": {
        "displayName": "Nedim Bajrami",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Albania",
        "position": "Midfielder",
        "number": 14,
        "dateofbirth": "1999-02-28"
    },
    "rothwell": {
        "displayName": "Joe Rothwell",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Midfielder",
        "number": 6,
        "dateofbirth": "1995-01-11"
    },
    "lyallcameron": {
        "displayName": "Lyall Cameron",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 16,
        "dateofbirth": "2002-10-10"
    },
    "dowell": {
        "displayName": "Kieran Dowell",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Midfielder",
        "number": 20,
        "dateofbirth": "1997-10-10"
    },
    "baileyrice": {
        "displayName": "Bailey Rice",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Midfielder",
        "number": 49,
        "dateofbirth": "2006-10-04"
    },
    "mikeymoore": {
        "displayName": "Mikey Moore",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "England",
        "position": "Forward",
        "number": 47,
        "dateofbirth": "2007-08-11"
    },
    "chermiti": {
        "displayName": "Youssef Chermiti",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Portugal",
        "position": "Forward",
        "number": 9,
        "dateofbirth": "2004-05-24"
    },
    "miovski": {
        "displayName": "Bojan Miovski",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "North Macedonia",
        "position": "Forward",
        "number": 28,
        "dateofbirth": "1999-06-24"
    },
    "danilo": {
        "displayName": "Danilo",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Brazil",
        "position": "Forward",
        "number": 99,
        "dateofbirth": "1999-04-07"
    },
    "gassama": {
        "displayName": "Djeidi Gassama",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "France",
        "position": "Forward",
        "number": 23,
        "dateofbirth": "2003-09-10"
    },
    "antman": {
        "displayName": "Oliver Antman",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Finland",
        "position": "Forward",
        "number": 18,
        "dateofbirth": "2001-08-15"
    },
    "matondo": {
        "displayName": "Rabbi Matondo",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Wales",
        "position": "Forward",
        "number": 17,
        "dateofbirth": "2000-09-09"
    },
    "findlaycurtis": {
        "displayName": "Findlay Curtis",
        "club": "Rangers",
        "league": "Scottish Premiership",
        "country": "Scotland",
        "position": "Forward",
        "number": 52,
        "dateofbirth": "2006-10-01"
    },
    "markojankovic": {
        "displayName": "Marko Janković",
        "club": "Qarabağ",
        "league": "Premyer Liqa",
        "country": "Montenegro",
        "position": "Midfielder",
        "number": 8,
        "dateofbirth": "1995-07-09"
    },
    "zinchenko": {
        "displayName": "Oleksandr Zinchenko",
        "club": "Ajax",
        "league": "Eredivisie",
        "country": "Ukraine",
        "position": "Defender",
        "number": 47,
        "dateofbirth": "1996-12-15"
    }
};